import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Custom scalar for DateTime. Accepts timestamps in milliseconds (e.g., Unix epoch time * 1000) or ISO date strings (e.g., "2025-09-28T03:00:17Z") for input. Always outputs timestamps in milliseconds. */
  DateTime: { input: any; output: any; }
  /** The `File` scalar type represents a file upload. */
  File: { input: any; output: any; }
  /** Custom scalar representing GeoJSON objects */
  GeoJSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export enum Aggregation {
  Any = 'any',
  Avg = 'avg',
  Max = 'max',
  Min = 'min',
  Sum = 'sum'
}

export type AlarmFilterInput = {
  _id_alarm?: InputMaybe<StringFilterInput>;
  _id_category?: InputMaybe<StringFilterInput>;
  _id_device?: InputMaybe<StringFilterInput>;
  _id_portfolio?: InputMaybe<StringFilterInput>;
  alarmType?: InputMaybe<EnumFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  endTime?: InputMaybe<DateTimeFilterInput>;
  insert_time?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  reviewed?: InputMaybe<BooleanFilterInput>;
  sensorIds?: InputMaybe<StringArrayFilterInput>;
  severity?: InputMaybe<EnumFilterInput>;
  startTime?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<BooleanFilterInput>;
};

/** Severity levels for alarms */
export enum AlarmSeverityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type AuditActor = {
  __typename?: 'AuditActor';
  email?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type AuditLog = {
  __typename?: 'AuditLog';
  _id: Scalars['ID']['output'];
  action: Scalars['String']['output'];
  actor: AuditActor;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  module: Scalars['String']['output'];
  payload?: Maybe<Scalars['JSONObject']['output']>;
  status: AuditLogStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AuditLogPagination = {
  __typename?: 'AuditLogPagination';
  items: Array<AuditLog>;
  totalCount: Scalars['Int']['output'];
};

export enum AuditLogStatus {
  Failure = 'failure',
  Pending = 'pending',
  Success = 'success'
}

export type AuditLogWhereInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  actorUserId?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  module?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AuditLogStatus>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type BooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkExclusionResult = {
  __typename?: 'BulkExclusionResult';
  errors: Array<OperationError>;
  exclusions: Array<ExclusionData>;
  insertedCount: Scalars['Int']['output'];
  mergedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  warnings: Array<OperationWarning>;
};

export type CalcSetting = {
  __typename?: 'CalcSetting';
  _id: Scalars['String']['output'];
  _id_device: Scalars['String']['output'];
  _id_mainAnemometer?: Maybe<Scalars['String']['output']>;
  _id_mainPyranometer?: Maybe<Scalars['String']['output']>;
  _id_mainRainSensor?: Maybe<Scalars['String']['output']>;
  _id_mainThermometer?: Maybe<Scalars['String']['output']>;
  _id_mainWindVane?: Maybe<Scalars['String']['output']>;
  ampmeters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  longTermAnalisis: Scalars['Boolean']['output'];
  shearAnemometers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  statisticSensors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thermometers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CalcSettingPagination = {
  __typename?: 'CalcSettingPagination';
  items: Array<CalcSetting>;
  totalCount: Scalars['Int']['output'];
};

export type CalcSettingWhereInput = {
  _id_device?: InputMaybe<Scalars['String']['input']>;
  _id_mainAnemometer?: InputMaybe<Scalars['String']['input']>;
  _id_mainPyranometer?: InputMaybe<Scalars['String']['input']>;
  _id_mainRainSensor?: InputMaybe<Scalars['String']['input']>;
  _id_mainThermometer?: InputMaybe<Scalars['String']['input']>;
  _id_mainWindVane?: InputMaybe<Scalars['String']['input']>;
  ampmeters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  longTermAnalisis?: InputMaybe<Scalars['Boolean']['input']>;
  shearAnemometers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statisticSensors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thermometers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ChannelType = {
  __typename?: 'ChannelType';
  _id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ChannelTypeWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CheckPeriod = {
  __typename?: 'CheckPeriod';
  _id: Scalars['String']['output'];
  _id_device: Scalars['String']['output'];
  auto: Scalars['Boolean']['output'];
  checked: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  from: Scalars['DateTime']['output'];
  to: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type CheckPeriodCreateInput = {
  _id_device: Scalars['String']['input'];
  checked: Scalars['Boolean']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type CheckPeriodPagination = {
  __typename?: 'CheckPeriodPagination';
  items: Array<CheckPeriod>;
  totalCount: Scalars['Int']['output'];
};

export type CheckPeriodWhereInput = {
  _id_device: Scalars['String']['input'];
};

export type CloneReportInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Condition structure for standard alarms. Fields depend on the alarm category: time/value for sensor_failure, no_data, low_battery; hours/daysOfWeek for no_file_received. */
export type Condition = {
  __typename?: 'Condition';
  /** Days 0=Sun..6=Sat when check applies (no_file_received). Empty = all days */
  daysOfWeek?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** UTC hours 0-23 to check (no_file_received) */
  hours?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Time threshold in minutes (sensor_failure, no_data, low_battery) */
  time?: Maybe<Scalars['Int']['output']>;
  /** Numeric threshold (low_data_coverage, low_battery) */
  value?: Maybe<Scalars['Int']['output']>;
};

/** Input for alarm condition. Use time/value OR hours/daysOfWeek depending on category. */
export type ConditionInput = {
  /** Days [0-6] for no_file_received (optional) */
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** UTC hours [0-23] for no_file_received */
  hours?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Minutes threshold (sensor_failure, no_data, low_battery) */
  time?: InputMaybe<Scalars['Int']['input']>;
  /** Numeric value (low_data_coverage, low_battery) */
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ConfirmSignalMappingsInput = {
  confirmedMappings: Array<ConfirmedMappingInput>;
  deviceTypeId: Scalars['String']['input'];
  loggerManufacturerId: Scalars['String']['input'];
  loggerModelId: Scalars['String']['input'];
};

export type ConfirmedMappingInput = {
  _id_sensorType: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Float']['input']>;
  orientation?: InputMaybe<Scalars['Float']['input']>;
  rawSignalName: Scalars['String']['input'];
  standardSignal: Scalars['String']['input'];
};

export type Country = {
  __typename?: 'Country';
  _id: Scalars['String']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CountryPagination = {
  __typename?: 'CountryPagination';
  items: Array<Country>;
  totalCount: Scalars['Int']['output'];
};

export type CountryWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomPortfolioInput = {
  displayName: Scalars['String']['input'];
  members?: InputMaybe<Array<CustomPortfolioMemberInput>>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateDeviceInput = {
  Offshore?: InputMaybe<Scalars['Boolean']['input']>;
  Onshore?: InputMaybe<Scalars['Boolean']['input']>;
  _id_deviceType: Scalars['String']['input'];
  _id_dictionary?: InputMaybe<Scalars['String']['input']>;
  _id_manufacturer: Scalars['String']['input'];
  _id_mastType?: InputMaybe<Scalars['String']['input']>;
  _id_model: Scalars['String']['input'];
  _id_portfolio?: InputMaybe<Scalars['String']['input']>;
  _id_reference?: InputMaybe<Scalars['String']['input']>;
  _id_site: Scalars['String']['input'];
  averagingPeriod?: InputMaybe<Scalars['Float']['input']>;
  coordinationSystem?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  easting?: InputMaybe<Scalars['Float']['input']>;
  elevation?: InputMaybe<Scalars['Float']['input']>;
  exactHeight?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  installationDate: Scalars['DateTime']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  magneticDeclination?: InputMaybe<Scalars['Float']['input']>;
  monitoringDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  northing?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  sampleFrequency?: InputMaybe<Scalars['Float']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DeviceStatusEnum>;
  timezone: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateExclusionDataInput = {
  _id_device: Scalars['String']['input'];
  _id_portfolio: Scalars['String']['input'];
  _id_sensor: Scalars['String']['input'];
  _id_sensorType: Scalars['String']['input'];
  _id_site: Scalars['String']['input'];
  /** Unix timestamp in milliseconds (UTC instant). */
  end_ts: Scalars['Float']['input'];
  exclusion_type: ExclusionTypeEnum;
  is_adc?: InputMaybe<Scalars['Boolean']['input']>;
  note: Scalars['String']['input'];
  /** Unix timestamp in milliseconds (UTC instant). */
  start_ts: Scalars['Float']['input'];
};

export type CreatePortfolioInput = {
  displayName: Scalars['String']['input'];
};

export type CreateProjectAdminTabInput = {
  _id_currency: Scalars['String']['input'];
  _id_device: Scalars['String']['input'];
  invoiceAmount: Scalars['Float']['input'];
  invoiceFrequency: InvoiceFrequencyEnum;
  legalEntity: Scalars['String']['input'];
  projectNumber: Scalars['String']['input'];
};

export type CreateRawFileInput = {
  _id_device: Scalars['String']['input'];
  _id_logger?: InputMaybe<Scalars['String']['input']>;
  airflow_run?: InputMaybe<Scalars['DateTime']['input']>;
  bucket_path: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  processed_at?: InputMaybe<Scalars['DateTime']['input']>;
  received_at?: InputMaybe<Scalars['DateTime']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReportInput = {
  deviceIds: Array<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  report?: InputMaybe<Scalars['String']['input']>;
  reportType: ReportTypeEnum;
  schedule: ReportScheduleInput;
};

export type CreateUserInput = {
  attributes?: InputMaybe<Scalars['JSONObject']['input']>;
  availableDeviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  downloadDataEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  username: Scalars['String']['input'];
};

export type Currency = {
  __typename?: 'Currency';
  _id: Scalars['String']['output'];
  code: Scalars['String']['output'];
  country: Scalars['String']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type CurrencyPagination = {
  __typename?: 'CurrencyPagination';
  items: Array<Currency>;
  totalCount: Scalars['Int']['output'];
};

export type CurrencyWhereInput = {
  _id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  symbol?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CustomAlarm = {
  __typename?: 'CustomAlarm';
  _id: Scalars['ID']['output'];
  _id_category: Scalars['String']['output'];
  _id_country?: Maybe<Scalars['String']['output']>;
  _id_device: Scalars['String']['output'];
  _id_portfolio: Scalars['String']['output'];
  _id_site: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  severity: AlarmSeverityEnum;
  status: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CustomAlarmCategory = {
  __typename?: 'CustomAlarmCategory';
  _id: Scalars['ID']['output'];
  color: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type CustomAlarmCategoryFilterInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CustomAlarmCategoryInput = {
  color: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
};

export type CustomAlarmCategoryPagination = {
  __typename?: 'CustomAlarmCategoryPagination';
  currentPage: Scalars['Int']['output'];
  items: Array<CustomAlarmCategory>;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CustomAlarmCondition = {
  __typename?: 'CustomAlarmCondition';
  _id: Scalars['ID']['output'];
  _id_custom_alarm: Scalars['String']['output'];
  condition: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  notify: NotifyModeEnum;
  sensorIds: Array<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type CustomAlarmConditionFilterInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_country?: InputMaybe<Scalars['String']['input']>;
  _id_custom_alarm?: InputMaybe<Scalars['String']['input']>;
  notify?: InputMaybe<NotifyModeEnum>;
};

export type CustomAlarmConditionInput = {
  _id_custom_alarm: Scalars['String']['input'];
  condition: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  notify: NotifyModeEnum;
  sensorIds: Array<Scalars['String']['input']>;
};

export type CustomAlarmConditionPagination = {
  __typename?: 'CustomAlarmConditionPagination';
  currentPage: Scalars['Int']['output'];
  items: Array<CustomAlarmCondition>;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CustomAlarmFilterInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _id_country?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _id_device?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _id_portfolio?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _id_site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  severity?: InputMaybe<AlarmSeverityEnum>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomAlarmInput = {
  _id_category: Scalars['String']['input'];
  _id_device: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  severity: AlarmSeverityEnum;
  status: Scalars['Boolean']['input'];
};

export type CustomAlarmPagination = {
  __typename?: 'CustomAlarmPagination';
  currentPage: Scalars['Int']['output'];
  items: Array<CustomAlarm>;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CustomPortfolio = {
  __typename?: 'CustomPortfolio';
  Sites: Array<CustomPortfolioSite>;
  _id: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  private: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CustomPortfolioMemberInput = {
  _id_device: Scalars['String']['input'];
  _id_site: Scalars['String']['input'];
};

export type CustomPortfolioPagination = {
  __typename?: 'CustomPortfolioPagination';
  items: Array<CustomPortfolio>;
  totalCount: Scalars['Int']['output'];
};

export type CustomPortfolioSite = {
  __typename?: 'CustomPortfolioSite';
  Devices: DevicePagination;
  Site: Site;
};


export type CustomPortfolioSiteDevicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomPortfolioWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DataCoverage = {
  __typename?: 'DataCoverage';
  data: Array<DataCoverageData>;
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type DataCoverageAverage = {
  __typename?: 'DataCoverageAverage';
  signal_name: Scalars['String']['output'];
  signal_unit: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type DataCoverageData = {
  __typename?: 'DataCoverageData';
  average: DataCoverageAverage;
  coverage: Scalars['Float']['output'];
  potential_coverage: Scalars['Float']['output'];
  sensor_id: Scalars['ID']['output'];
  sensor_name: Scalars['String']['output'];
  sensor_type: Scalars['String']['output'];
};

export type DateRange = {
  __typename?: 'DateRange';
  endDate: Scalars['Float']['output'];
  startDate: Scalars['Float']['output'];
};

export type DateRangeInput = {
  endDate: Scalars['Float']['input'];
  startDate: Scalars['Float']['input'];
};

export type DateTimeFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DeleteDataResult = {
  __typename?: 'DeleteDataResult';
  coverageRefreshScheduled: Scalars['Boolean']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  partitionsSubmitted: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteUsersInput = {
  ids: Array<Scalars['String']['input']>;
};

export type Device = {
  __typename?: 'Device';
  DeviceManufacturer?: Maybe<DeviceManufacturer>;
  DeviceModel?: Maybe<DeviceModel>;
  DeviceType?: Maybe<DeviceType>;
  Document: DocumentPagination;
  /** List of exclusions associated with this device */
  Exclusions: Exclusion;
  Loggers: LoggerPagination;
  MastType?: Maybe<MastType>;
  Notes: NotePagination;
  Offshore?: Maybe<Scalars['Boolean']['output']>;
  Onshore?: Maybe<Scalars['Boolean']['output']>;
  Portfolio?: Maybe<Portfolio>;
  RawFile: RawFilePagination;
  ReferenceStation?: Maybe<Device>;
  Sensors: SensorPagination;
  Timezone?: Maybe<Timezone>;
  TriggeredAlarms: TriggeredAlarmPagination;
  /** Current weather at the device site (cached 3h per site) */
  Weather?: Maybe<Weather>;
  _id: Scalars['String']['output'];
  _id_deviceType?: Maybe<Scalars['String']['output']>;
  _id_dictionary?: Maybe<Scalars['String']['output']>;
  _id_manufacturer: Scalars['String']['output'];
  _id_mastType?: Maybe<Scalars['String']['output']>;
  _id_model: Scalars['String']['output'];
  _id_portfolio?: Maybe<Scalars['String']['output']>;
  _id_reference?: Maybe<Scalars['String']['output']>;
  _id_site: Scalars['String']['output'];
  averagingPeriod?: Maybe<Scalars['Float']['output']>;
  coordinationSystem?: Maybe<Scalars['String']['output']>;
  /** Country Name of the Device */
  countryName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  easting?: Maybe<Scalars['Float']['output']>;
  elevation?: Maybe<Scalars['Float']['output']>;
  exactHeight?: Maybe<Scalars['Float']['output']>;
  /** Earliest measurement time, shifted by the device winter timezoneOffset */
  firstTs?: Maybe<Scalars['DateTime']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  installationDate: Scalars['DateTime']['output'];
  /** Measurement time of the latest written batch, shifted by the device winter timezoneOffset */
  lastBatchTs?: Maybe<Scalars['DateTime']['output']>;
  /** When a timeseries row was last written, shifted by the device winter timezoneOffset */
  lastInsertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Latest measurement time, shifted by the device winter timezoneOffset */
  lastMonitoringDate?: Maybe<Scalars['DateTime']['output']>;
  /** Latest measurement time, shifted by the device winter timezoneOffset */
  lastTs?: Maybe<Scalars['DateTime']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  magneticDeclination?: Maybe<Scalars['Float']['output']>;
  monitoringDate?: Maybe<Scalars['DateTime']['output']>;
  monitoringEndDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  northing?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** Region Name of the Device (via Site) */
  regionName?: Maybe<Scalars['String']['output']>;
  sampleFrequency?: Maybe<Scalars['Float']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DeviceStatusEnum>;
  timezone: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};


export type DeviceDeviceManufacturerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DeviceManufacturerWhereInput>;
};


export type DeviceDeviceModelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DeviceModelWhereInput>;
};


export type DeviceDeviceTypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DeviceTypeWhereInput>;
};


export type DeviceDocumentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};


export type DeviceExclusionsArgs = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExclusionDataWhereInput>;
};


export type DeviceLoggersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<LoggerWhereInput>;
};


export type DeviceMastTypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<MastTypeWhereInput>;
};


export type DeviceNotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<NoteWhereInput>;
};


export type DeviceRawFileArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};


export type DeviceSensorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SensorWhereInput>;
};


export type DeviceTriggeredAlarmsArgs = {
  filter?: InputMaybe<AlarmFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortDirectionEnum>;
};

export type DeviceManufacturer = {
  __typename?: 'DeviceManufacturer';
  /** Paginated list of device models associated with this manufacturer */
  DeviceModels: DeviceModelPagination;
  _id: Scalars['String']['output'];
  _id_deviceType: Scalars['String']['output'];
  name: Scalars['String']['output'];
};


export type DeviceManufacturerDeviceModelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DeviceModelWhereInput>;
};

export type DeviceManufacturerPagination = {
  __typename?: 'DeviceManufacturerPagination';
  items: Array<DeviceManufacturer>;
  totalCount: Scalars['Int']['output'];
};

export type DeviceManufacturerWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_deviceType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceModel = {
  __typename?: 'DeviceModel';
  _id: Scalars['String']['output'];
  _id_manufacturer: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DeviceModelPagination = {
  __typename?: 'DeviceModelPagination';
  items: Array<DeviceModel>;
  totalCount: Scalars['Int']['output'];
};

export type DeviceModelWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DevicePagination = {
  __typename?: 'DevicePagination';
  items: Array<Device>;
  totalCount: Scalars['Int']['output'];
};

export enum DeviceStatusEnum {
  Active = 'ACTIVE',
  BeingUpdated = 'BEING_UPDATED',
  Decommissioned = 'DECOMMISSIONED',
  Inactive = 'INACTIVE',
  OnHold = 'ON_HOLD',
  Pending = 'PENDING',
  TowerOnly = 'TOWER_ONLY',
  Unknown = 'UNKNOWN'
}

export type DeviceType = {
  __typename?: 'DeviceType';
  _id: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type DeviceTypePagination = {
  __typename?: 'DeviceTypePagination';
  items: Array<DeviceType>;
  totalCount: Scalars['Int']['output'];
};

export type DeviceTypeWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceWhereInput = {
  Offshore?: InputMaybe<Scalars['Boolean']['input']>;
  Onshore?: InputMaybe<Scalars['Boolean']['input']>;
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_country?: InputMaybe<Scalars['String']['input']>;
  _id_deviceType?: InputMaybe<Scalars['String']['input']>;
  _id_dictionary?: InputMaybe<Scalars['String']['input']>;
  _id_manufacturer?: InputMaybe<Scalars['String']['input']>;
  _id_mastType?: InputMaybe<Scalars['String']['input']>;
  _id_model?: InputMaybe<Scalars['String']['input']>;
  _id_portfolio?: InputMaybe<Scalars['String']['input']>;
  _id_reference?: InputMaybe<Scalars['String']['input']>;
  _id_site?: InputMaybe<Scalars['String']['input']>;
  averagingPeriod?: InputMaybe<Scalars['Float']['input']>;
  coordinationSystem?: InputMaybe<Scalars['String']['input']>;
  easting?: InputMaybe<Scalars['Float']['input']>;
  elevation?: InputMaybe<Scalars['Float']['input']>;
  exactHeight?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  installationDate?: InputMaybe<Scalars['DateTime']['input']>;
  is_hide_sensors_references?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  magneticDeclination?: InputMaybe<Scalars['Float']['input']>;
  monitoringDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  northing?: InputMaybe<Scalars['Float']['input']>;
  sampleFrequency?: InputMaybe<Scalars['Float']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DeviceStatusEnum>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type Dictionary = {
  __typename?: 'Dictionary';
  _id: Scalars['String']['output'];
  _id_device: Scalars['String']['output'];
  _id_logger: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  def: Array<DictionaryDef>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DictionaryBulkError = {
  __typename?: 'DictionaryBulkError';
  error: Scalars['String']['output'];
  index: Scalars['Int']['output'];
};

export type DictionaryBulkResult = {
  __typename?: 'DictionaryBulkResult';
  failed?: Maybe<Array<Maybe<DictionaryBulkError>>>;
  failureCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
  successful: Array<Maybe<Dictionary>>;
  totalProcessed: Scalars['Int']['output'];
};

export type DictionaryBulkUpsertInput = {
  continueOnError?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<DictionaryUpsertInput>;
  returnFailures?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DictionaryDef = {
  __typename?: 'DictionaryDef';
  _id: Scalars['String']['output'];
  _id_sensor: Scalars['String']['output'];
  _id_signal: Scalars['String']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  rawSignalName?: Maybe<Scalars['String']['output']>;
  sensorName: Scalars['String']['output'];
  signalName: Scalars['String']['output'];
};

export type DictionaryDefInput = {
  _id_sensor: Scalars['String']['input'];
  _id_signal: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Float']['input']>;
  rawSignalName: Scalars['String']['input'];
  sensorName: Scalars['String']['input'];
  signalName: Scalars['String']['input'];
};

export type DictionaryInput = {
  _id_device: Scalars['String']['input'];
  _id_logger: Scalars['String']['input'];
  def: Array<DictionaryDefInput>;
};

export type DictionaryPagination = {
  __typename?: 'DictionaryPagination';
  items: Array<Dictionary>;
  totalCount: Scalars['Int']['output'];
};

export type DictionarySortConfig = {
  primary: DictionarySortRule;
  secondary?: InputMaybe<DictionarySortRule>;
};

export enum DictionarySortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum DictionarySortFieldEnum {
  Height = 'height',
  Name = 'name'
}

export type DictionarySortRule = {
  direction: DictionarySortDirection;
  field: DictionarySortFieldEnum;
};

export type DictionaryTemplateDownload = {
  __typename?: 'DictionaryTemplateDownload';
  base64: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type DictionaryUploadError = {
  __typename?: 'DictionaryUploadError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  rowIndex?: Maybe<Scalars['Int']['output']>;
};

export type DictionaryUploadResult = {
  __typename?: 'DictionaryUploadResult';
  dictionary?: Maybe<Dictionary>;
  errors: Array<DictionaryUploadError>;
  rowsProcessed: Scalars['Int']['output'];
  rowsSkipped: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  warnings: Array<DictionaryUploadWarning>;
};

export type DictionaryUploadWarning = {
  __typename?: 'DictionaryUploadWarning';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  rowIndex?: Maybe<Scalars['Int']['output']>;
};

export type DictionaryUpsertInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  dictionaryData: DictionaryInput;
};

export type DictionaryWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_device?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _id_logger?: InputMaybe<Scalars['String']['input']>;
};

export type DirSectorInput = {
  sector: WindDirectionSector;
  windVane?: InputMaybe<Scalars['ID']['input']>;
};

export type DirectionalWindShearVariation = {
  __typename?: 'DirectionalWindShearVariation';
  directionSector: Array<Maybe<Scalars['Int']['output']>>;
  frequencyPct: Array<Maybe<Scalars['Float']['output']>>;
  n: Array<Maybe<Scalars['Int']['output']>>;
  shearAlpha: Array<Maybe<Scalars['Float']['output']>>;
};

export type DirectionalWindShearVariationInput = {
  _id_device: Scalars['ID']['input'];
  endTS?: InputMaybe<Scalars['Float']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
};

export type DiurnalVariation = {
  __typename?: 'DiurnalVariation';
  month?: Maybe<Scalars['Int']['output']>;
  signals: Array<Maybe<DiurnalVariationSignal>>;
  year?: Maybe<Scalars['Int']['output']>;
};

export enum DiurnalVariationGranularity {
  Month = 'MONTH',
  Overall = 'OVERALL'
}

export type DiurnalVariationSignal = {
  __typename?: 'DiurnalVariationSignal';
  sensor: Scalars['String']['output'];
  values: Array<Maybe<Scalars['Float']['output']>>;
};

export type DiurnalVariationWhereInput = {
  endTS?: InputMaybe<Scalars['Float']['input']>;
  granularity: DiurnalVariationGranularity;
  sensors: Array<InputMaybe<Scalars['ID']['input']>>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
};

export type DiurnalWindShearVariation = {
  __typename?: 'DiurnalWindShearVariation';
  hour: Array<Maybe<Scalars['Int']['output']>>;
  shearAvg: Array<Maybe<Scalars['Float']['output']>>;
  shearMax: Array<Maybe<Scalars['Float']['output']>>;
  shearMin: Array<Maybe<Scalars['Float']['output']>>;
};

export type DiurnalWindShearVariationInput = {
  _id_device: Scalars['ID']['input'];
  endTS?: InputMaybe<Scalars['Float']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
};

export type Document = {
  __typename?: 'Document';
  _id: Scalars['String']['output'];
  _id_device: Scalars['String']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  storagePath: Scalars['String']['output'];
};

export type DocumentCreateInput = {
  _id_device: Scalars['String']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  storagePath: Scalars['String']['input'];
};

export type DocumentPagination = {
  __typename?: 'DocumentPagination';
  items: Array<Document>;
  totalCount: Scalars['Int']['output'];
};

export type DocumentUpdateInput = {
  _id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type EnumFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Exclusion = {
  __typename?: 'Exclusion';
  exclusions: Array<ExclusionData>;
  sensors: Array<ExclusionSensor>;
  totalCount: Scalars['Int']['output'];
};

export type ExclusionData = {
  __typename?: 'ExclusionData';
  Sensor: Sensor;
  _id: Scalars['String']['output'];
  _id_device: Scalars['String']['output'];
  _id_portfolio: Scalars['String']['output'];
  _id_sensor: Scalars['String']['output'];
  _id_sensorType: Scalars['String']['output'];
  _id_site: Scalars['String']['output'];
  /** Unix timestamp in milliseconds (UTC instant). */
  end_ts: Scalars['Float']['output'];
  exclusion_type: ExclusionTypeEnum;
  is_adc: Scalars['Boolean']['output'];
  /** Unix timestamp in milliseconds (UTC instant). Last mutation time. */
  mut_ts: Scalars['Float']['output'];
  note: Scalars['String']['output'];
  /** Unix timestamp in milliseconds (UTC instant). */
  start_ts: Scalars['Float']['output'];
};

export type ExclusionDataWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter upper bound: Unix timestamp in milliseconds (UTC instant). */
  endTs?: InputMaybe<Scalars['Float']['input']>;
  exclusion_type?: InputMaybe<Array<InputMaybe<ExclusionTypeEnum>>>;
  sensorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter lower bound: Unix timestamp in milliseconds (UTC instant). */
  startTs?: InputMaybe<Scalars['Float']['input']>;
};

export type ExclusionSensor = {
  __typename?: 'ExclusionSensor';
  _id: Scalars['String']['output'];
  _id_device: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ExclusionType = {
  __typename?: 'ExclusionType';
  exclusionTypes: Array<ExclusionTypeData>;
  totalCount: Scalars['Int']['output'];
};

export type ExclusionTypeData = {
  __typename?: 'ExclusionTypeData';
  _id: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum ExclusionTypeEnum {
  ClientRemoval = 'CLIENT_REMOVAL',
  Erroneous = 'ERRONEOUS',
  FamosDataFilter = 'FAMOS_DATA_FILTER',
  Icing = 'ICING',
  InstrumentFailure = 'INSTRUMENT_FAILURE',
  LowAvailability = 'LOW_AVAILABILITY',
  LowQuality = 'LOW_QUALITY',
  Maintenance = 'MAINTENANCE',
  PartialIcing = 'PARTIAL_ICING',
  SensorFailure = 'SENSOR_FAILURE',
  Suspect = 'SUSPECT',
  TiltExceeded = 'TILT_EXCEEDED',
  TowerEffects = 'TOWER_EFFECTS',
  UnrecoverableData = 'UNRECOVERABLE_DATA',
  ZxDeviceFiltering = 'ZX_DEVICE_FILTERING'
}

export type ExclusionTypeWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FreqDistributions = {
  __typename?: 'FreqDistributions';
  binCenters: Array<Scalars['Float']['output']>;
  measuredFrequencies: Array<Scalars['Float']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  scaleParameter: Scalars['Float']['output'];
  shapeParameter: Scalars['Float']['output'];
  weibullFrequencies: Array<Scalars['Float']['output']>;
  weibullX: Array<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export enum FreqDistributionsGranularity {
  Month = 'MONTH',
  Overall = 'OVERALL'
}

export type FreqDistributionsWhereInput = {
  endTS?: InputMaybe<Scalars['Float']['input']>;
  granularity: FreqDistributionsGranularity;
  sensor_id: Scalars['ID']['input'];
  startTS?: InputMaybe<Scalars['Float']['input']>;
};

export type Image = {
  __typename?: 'Image';
  _id: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['String']['output'];
  createdTs: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fileExtension: Scalars['String']['output'];
  name: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  scope?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type ImagePagination = {
  __typename?: 'ImagePagination';
  items: Array<Image>;
  totalCount: Scalars['Int']['output'];
};

export type ImageWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdTs?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileExtension?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export enum InvoiceFrequencyEnum {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export type Logger = {
  __typename?: 'Logger';
  /** Paginated list of Dictionary items associated with this logger */
  Dictionary: DictionaryPagination;
  Notes: NotePagination;
  Timezone?: Maybe<Timezone>;
  _id: Scalars['String']['output'];
  _id_device: Scalars['String']['output'];
  _id_manufacturer: Scalars['String']['output'];
  _id_model: Scalars['String']['output'];
  averagingPeriod: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  installationDate: Scalars['DateTime']['output'];
  matchedFilenameFormat: Scalars['String']['output'];
  sampleFrequency: Scalars['Float']['output'];
  serialNumber: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};


export type LoggerDictionaryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DictionaryWhereInput>;
};


export type LoggerNotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<NoteWhereInput>;
};

export type LoggerBulkError = {
  __typename?: 'LoggerBulkError';
  error: Scalars['String']['output'];
  index: Scalars['Int']['output'];
};

export type LoggerBulkResult = {
  __typename?: 'LoggerBulkResult';
  failed?: Maybe<Array<Maybe<LoggerBulkError>>>;
  failureCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
  successful: Array<Maybe<Logger>>;
  totalProcessed: Scalars['Int']['output'];
};

export type LoggerBulkUpsertInput = {
  continueOnError?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<LoggerUpsertInput>;
  returnFailures?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoggerInput = {
  _id_device: Scalars['String']['input'];
  _id_manufacturer?: InputMaybe<Scalars['String']['input']>;
  _id_model?: InputMaybe<Scalars['String']['input']>;
  averagingPeriod?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  installationDate?: InputMaybe<Scalars['DateTime']['input']>;
  matchedFilenameFormat?: InputMaybe<Scalars['String']['input']>;
  sampleFrequency?: InputMaybe<Scalars['Float']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type LoggerManufacturer = {
  __typename?: 'LoggerManufacturer';
  LoggerModels: LoggerModelPagination;
  _id: Scalars['String']['output'];
  modelIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
};


export type LoggerManufacturerLoggerModelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<LoggerModelWhereInput>;
};

export type LoggerManufacturerPagination = {
  __typename?: 'LoggerManufacturerPagination';
  items: Array<LoggerManufacturer>;
  totalCount: Scalars['Int']['output'];
};

export type LoggerManufacturerWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LoggerModel = {
  __typename?: 'LoggerModel';
  _id: Scalars['String']['output'];
  _id_manufacturer: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LoggerModelPagination = {
  __typename?: 'LoggerModelPagination';
  items: Array<LoggerModel>;
  totalCount: Scalars['Int']['output'];
};

export type LoggerModelWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LoggerPagination = {
  __typename?: 'LoggerPagination';
  items: Array<Logger>;
  totalCount: Scalars['Int']['output'];
};

export type LoggerUpsertInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  loggerData: LoggerInput;
};

export type LoggerWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_device: Scalars['String']['input'];
  _id_manufacturer?: InputMaybe<Scalars['String']['input']>;
  _id_model?: InputMaybe<Scalars['String']['input']>;
  averagingPeriod?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  installationDate?: InputMaybe<Scalars['DateTime']['input']>;
  matchedFilenameFormat?: InputMaybe<Scalars['String']['input']>;
  sampleFrequency?: InputMaybe<Scalars['Float']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type LongTermWsEnergy = {
  __typename?: 'LongTermWSEnergy';
  airDensity?: Maybe<Scalars['Float']['output']>;
  defaultShearValue?: Maybe<Scalars['Float']['output']>;
  estimatedGrossCapacity?: Maybe<Scalars['Float']['output']>;
  estimatedGrossEnergy?: Maybe<Scalars['Float']['output']>;
  hubHeighFrequencyDistribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  hubHeighWindSpeed?: Maybe<Scalars['Float']['output']>;
  hubHeight?: Maybe<Scalars['Float']['output']>;
  longTermHubHeightWindSpeed?: Maybe<Scalars['Float']['output']>;
  merra2?: Maybe<Scalars['String']['output']>;
  powerCurve?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedMean?: Maybe<Scalars['Float']['output']>;
  windSpeedMeanReferenceMast?: Maybe<Scalars['Float']['output']>;
};

export type LongTermWsEnergyInput = {
  _id_device: Scalars['ID']['input'];
  endTS?: InputMaybe<Scalars['Float']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
};

export type ManagedUserPagination = {
  __typename?: 'ManagedUserPagination';
  items: Array<ManagedUserSummary>;
  totalCount: Scalars['Int']['output'];
};

/** Light managed-user row for paginated lists (no portfolio tree) */
export type ManagedUserSummary = {
  __typename?: 'ManagedUserSummary';
  downloadDataEnabled: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  managedBy?: Maybe<Scalars['String']['output']>;
  portfolioIds: Array<Scalars['ID']['output']>;
  role: UserRole;
  username?: Maybe<Scalars['String']['output']>;
};

export type MastShadow = {
  __typename?: 'MastShadow';
  ratio: Array<Maybe<Scalars['Float']['output']>>;
  timestamps: Array<Maybe<Scalars['Float']['output']>>;
  wdDir: Array<Maybe<Scalars['Float']['output']>>;
};

export type MastShadowWhereInput = {
  anemometer1: Scalars['ID']['input'];
  anemometer2: Scalars['ID']['input'];
  endTS: Scalars['Float']['input'];
  lwsCutoff?: InputMaybe<Scalars['Int']['input']>;
  startTS: Scalars['Float']['input'];
  windVane: Scalars['ID']['input'];
};

export type MastType = {
  __typename?: 'MastType';
  _id: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MastTypePagination = {
  __typename?: 'MastTypePagination';
  items: Array<MastType>;
  totalCount: Scalars['Int']['output'];
};

export type MastTypeWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum MatchType {
  Exact = 'EXACT',
  Generic = 'GENERIC',
  Pattern = 'PATTERN',
  Similar = 'SIMILAR'
}

export type MigrationMetadata = {
  __typename?: 'MigrationMetadata';
  device_id?: Maybe<Scalars['String']['output']>;
  portfolio_id?: Maybe<Scalars['String']['output']>;
  sensor_id?: Maybe<Scalars['String']['output']>;
  signals?: Maybe<Array<Maybe<MigrationMetadataSignal>>>;
};

export type MigrationMetadataInput = {
  device_id?: InputMaybe<Scalars['String']['input']>;
  portfolio_id?: InputMaybe<Scalars['String']['input']>;
  sensor_id?: InputMaybe<Scalars['String']['input']>;
  signals?: InputMaybe<Array<InputMaybe<MigrationMetadataSignalInput>>>;
};

export type MigrationMetadataSignal = {
  __typename?: 'MigrationMetadataSignal';
  cloudName?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type MigrationMetadataSignalInput = {
  cloudName?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type MountingType = {
  __typename?: 'MountingType';
  _id: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MountingTypePagination = {
  __typename?: 'MountingTypePagination';
  items: Array<MountingType>;
  totalCount: Scalars['Int']['output'];
};

export type MountingTypeWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MoveDeviceResult = {
  __typename?: 'MoveDeviceResult';
  copiedPartitions: Array<Scalars['String']['output']>;
  copyScheduled: Scalars['Boolean']['output'];
  coverageCopied: Scalars['Boolean']['output'];
  device: Device;
  exclusionsCopied: Scalars['Boolean']['output'];
  fromPortfolioId: Scalars['String']['output'];
  fromPortfolioName: Scalars['String']['output'];
  fromSiteId: Scalars['String']['output'];
  fromSiteName: Scalars['String']['output'];
  merraMoved: Array<Scalars['String']['output']>;
  merraSkipped: Array<Scalars['String']['output']>;
  samePortfolioCosmetic: Scalars['Boolean']['output'];
  skippedSameLocation: Scalars['Boolean']['output'];
  statusBeforeMove?: Maybe<Scalars['String']['output']>;
  toPortfolioId: Scalars['String']['output'];
  toPortfolioName: Scalars['String']['output'];
  toSiteId: Scalars['String']['output'];
  toSiteName: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addCustomPortfolioMembers?: Maybe<CustomPortfolio>;
  bulkUpsertDictionary: DictionaryBulkResult;
  bulkUpsertLogger: LoggerBulkResult;
  cloneReport: Report;
  confirmSignalMappings: SignalTemplateMapping;
  createCalcSetting?: Maybe<CalcSetting>;
  createCheckPeriod: CheckPeriodPagination;
  createCountry: Country;
  createCustomAlarm: CustomAlarm;
  createCustomAlarmCategory: CustomAlarmCategory;
  createCustomAlarmCondition: CustomAlarmCondition;
  createCustomPortfolio: CustomPortfolio;
  createDevice: Device;
  createDeviceManufacturer: DeviceManufacturer;
  createDeviceModel: DeviceModel;
  createDeviceReference: Device;
  createDeviceType: DeviceType;
  createDictionary: Array<Dictionary>;
  createDocument: Array<Document>;
  createExclusionType?: Maybe<ExclusionType>;
  /** Create exclusions in bulk. Input start_ts and end_ts are Unix timestamps in milliseconds (UTC instants). */
  createExclusions?: Maybe<BulkExclusionResult>;
  /** Create exclusions in bulk with detailed reporting. Input start_ts and end_ts are Unix timestamps in milliseconds (UTC instants). */
  createExclusionsWithReport?: Maybe<BulkExclusionResult>;
  createLogger: Array<Logger>;
  createLoggerManufacturer: LoggerManufacturer;
  createLoggerModel: LoggerModel;
  createMastType: MastType;
  createMountingType: MountingType;
  createNote: Note;
  createPortfolio: Portfolio;
  createPowerCurveSetting?: Maybe<PowerCurveSetting>;
  createProjectAdminTab?: Maybe<ProjectAdminTab>;
  createRawFiles: Array<RawFile>;
  createRegion: Region;
  createReport: Report;
  createSensor: Sensor;
  createSensorType: SensorType;
  createSensorsBatch: Array<Maybe<Sensor>>;
  createServiceCase: ServiceCase;
  createSignal: Signal;
  createSignalSubtype: SignalSubtype;
  createSite: Site;
  /** Create a standard alarm. For no_file_received: one device, condition.hours [0-23], condition.daysOfWeek [0-6] optional. No duplicate (device, hours, daysOfWeek). */
  createStandardAlarm: StandardAlarmDataCreateResult;
  createStandardAlarmCategory: StandardAlarmCategory;
  createUser: Scalars['String']['output'];
  createVarType: VarType;
  deleteCalcSetting?: Maybe<CalcSetting>;
  deleteCheckPeriod: CheckPeriodPagination;
  deleteCountry?: Maybe<Country>;
  deleteCustomAlarm: Scalars['Boolean']['output'];
  deleteCustomAlarmCategory: Scalars['Boolean']['output'];
  deleteCustomAlarmCondition: Scalars['Boolean']['output'];
  deleteCustomAlarms: Scalars['Boolean']['output'];
  deleteCustomPortfolio?: Maybe<CustomPortfolio>;
  /** Delete timeseries rows for a device, selected sensors, and UTC time range. Queues a lightweight ClickHouse DELETE per (quarter, year, portfolio) partition, then schedules DATA_COVERAGE_DAILY refresh on Q_RP_DATA_COVERAGE_DAILY_REFRESH. Hidden from Client; Admin and Analyst only. */
  deleteData: DeleteDataResult;
  deleteDevice?: Maybe<Device>;
  deleteDeviceManufacturer?: Maybe<DeviceManufacturer>;
  deleteDeviceModel?: Maybe<DeviceModel>;
  deleteDeviceType?: Maybe<DeviceType>;
  deleteDictionary?: Maybe<Dictionary>;
  deleteDocument?: Maybe<Document>;
  deleteExclusion?: Maybe<Scalars['Boolean']['output']>;
  deleteExclusionType?: Maybe<ExclusionType>;
  deleteExclusions?: Maybe<Scalars['Boolean']['output']>;
  deleteLogger?: Maybe<Logger>;
  deleteLoggerManufacturer?: Maybe<LoggerManufacturer>;
  deleteLoggerModel?: Maybe<LoggerModel>;
  deleteMastType?: Maybe<MastType>;
  deleteMountingType?: Maybe<MountingType>;
  deleteNote?: Maybe<Note>;
  deletePortfolio?: Maybe<Portfolio>;
  deletePowerCurveSetting?: Maybe<PowerCurveSetting>;
  deleteProjectAdminTab?: Maybe<ProjectAdminTab>;
  deleteRawFile: Scalars['Boolean']['output'];
  deleteRawFiles: Scalars['Boolean']['output'];
  deleteRegion?: Maybe<Region>;
  deleteReport: Scalars['Boolean']['output'];
  deleteSensor?: Maybe<Sensor>;
  deleteSensorType?: Maybe<SensorType>;
  deleteServiceCase: Scalars['Boolean']['output'];
  deleteSignal?: Maybe<Signal>;
  deleteSignalSubtype?: Maybe<SignalSubtype>;
  deleteSite?: Maybe<Site>;
  /** Delete a standard alarm by ID. */
  deleteStandardAlarm?: Maybe<Scalars['Boolean']['output']>;
  deleteStandardAlarmCategory?: Maybe<Scalars['Boolean']['output']>;
  /** Delete multiple standard alarms by IDs. */
  deleteStandardAlarms: Scalars['Boolean']['output'];
  deleteUsers: Scalars['Boolean']['output'];
  deleteVarType?: Maybe<VarType>;
  /** Reparent a device to an existing site (and that site’s portfolio). Superadmin only. Does not change roleName. Optional copyHistoricalData copies ClickHouse timeseries, exclusions, and DATA_COVERAGE_DAILY in the background (copyScheduled). Poll device.status and auditLogs module=device action=copy_historical_data. After a logical-only move, the same mutation with copyHistoricalData true copies from the previous origin. MERRA children follow the parent unless the destination already has the same name (merraSkipped). Same-portfolio site moves always rewrite _id_site. */
  moveDevice: MoveDeviceResult;
  parsePowerCurveDataFile: Array<PowerCurvePreview>;
  parseSensorFile: Array<Sensor>;
  /** Rebuild Mongo userDirectory from Keycloak (SUPERADMIN) */
  reconcileUserDirectory: ReconcileUserDirectoryResult;
  removeCustomPortfolioMembers?: Maybe<CustomPortfolio>;
  removeTwoFA: Scalars['Boolean']['output'];
  restoreDevice?: Maybe<Device>;
  restorePortfolio?: Maybe<Portfolio>;
  restoreSite?: Maybe<Site>;
  sendReportNow: Scalars['Boolean']['output'];
  sendResetPasswordEmail: Scalars['Boolean']['output'];
  sendTwoFASetupEmail: Scalars['Boolean']['output'];
  updateCalcSetting?: Maybe<CalcSetting>;
  updateCountry?: Maybe<Country>;
  updateCustomAlarm?: Maybe<CustomAlarm>;
  updateCustomAlarmCategory?: Maybe<CustomAlarmCategory>;
  updateCustomAlarmCondition?: Maybe<CustomAlarmCondition>;
  updateCustomPortfolio?: Maybe<CustomPortfolio>;
  updateDevice?: Maybe<Device>;
  updateDeviceManufacturer?: Maybe<DeviceManufacturer>;
  updateDeviceModel?: Maybe<DeviceModel>;
  updateDeviceType?: Maybe<DeviceType>;
  updateDocument: Document;
  updateExclusion?: Maybe<Scalars['Boolean']['output']>;
  updateExclusionType?: Maybe<ExclusionType>;
  /** Update exclusions in bulk. Input start_ts and end_ts are Unix timestamps in milliseconds (UTC instants). */
  updateExclusions?: Maybe<Scalars['Boolean']['output']>;
  updateLoggerManufacturer?: Maybe<LoggerManufacturer>;
  updateLoggerModel?: Maybe<LoggerModel>;
  updateMastType?: Maybe<MastType>;
  updateMountingType?: Maybe<MountingType>;
  updateNote?: Maybe<Note>;
  updatePortfolio?: Maybe<Portfolio>;
  updatePowerCurveSetting?: Maybe<PowerCurveSetting>;
  updateProjectAdminTab?: Maybe<ProjectAdminTab>;
  updateRegion?: Maybe<Region>;
  updateReport: Report;
  updateSensor?: Maybe<Sensor>;
  updateSensorType?: Maybe<SensorType>;
  updateServiceCase?: Maybe<ServiceCase>;
  updateSignal?: Maybe<Signal>;
  updateSignalSubtype?: Maybe<SignalSubtype>;
  updateSite?: Maybe<Site>;
  /** Update an existing standard alarm. */
  updateStandardAlarm?: Maybe<Scalars['Boolean']['output']>;
  updateStandardAlarmCategory?: Maybe<StandardAlarmCategory>;
  updateTriggeredAlarm?: Maybe<TriggeredAlarm>;
  updateUser: Scalars['String']['output'];
  updateVarType?: Maybe<VarType>;
  uploadDictionary: DictionaryUploadResult;
  /** Import exclusions from CSV. Date columns (startDate, endDate, created) are interpreted in the target device IANA timezone and stored as UTC in ClickHouse. */
  uploadExclusions?: Maybe<BulkExclusionResult>;
  upsertDictionary: Array<Maybe<Dictionary>>;
  upsertLogger: Array<Logger>;
};


export type MutationAddCustomPortfolioMembersArgs = {
  _id: Scalars['String']['input'];
  members: Array<CustomPortfolioMemberInput>;
};


export type MutationBulkUpsertDictionaryArgs = {
  data: DictionaryBulkUpsertInput;
};


export type MutationBulkUpsertLoggerArgs = {
  data: LoggerBulkUpsertInput;
};


export type MutationCloneReportArgs = {
  id: Scalars['String']['input'];
  input: CloneReportInput;
};


export type MutationConfirmSignalMappingsArgs = {
  data: ConfirmSignalMappingsInput;
};


export type MutationCreateCalcSettingArgs = {
  _id_device: Scalars['String']['input'];
  _id_mainAnemometer?: InputMaybe<Scalars['String']['input']>;
  _id_mainPyranometer?: InputMaybe<Scalars['String']['input']>;
  _id_mainRainSensor?: InputMaybe<Scalars['String']['input']>;
  _id_mainThermometer?: InputMaybe<Scalars['String']['input']>;
  _id_mainWindVane?: InputMaybe<Scalars['String']['input']>;
  ampmeters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  longTermAnalisis: Scalars['Boolean']['input'];
  shearAnemometers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statisticSensors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thermometers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateCheckPeriodArgs = {
  data: CheckPeriodCreateInput;
};


export type MutationCreateCountryArgs = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateCustomAlarmArgs = {
  input: CustomAlarmInput;
};


export type MutationCreateCustomAlarmCategoryArgs = {
  input: CustomAlarmCategoryInput;
};


export type MutationCreateCustomAlarmConditionArgs = {
  input: CustomAlarmConditionInput;
};


export type MutationCreateCustomPortfolioArgs = {
  input: CreateCustomPortfolioInput;
};


export type MutationCreateDeviceArgs = {
  data: CreateDeviceInput;
};


export type MutationCreateDeviceManufacturerArgs = {
  _id_deviceType: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateDeviceModelArgs = {
  _id_manufacturer: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateDeviceReferenceArgs = {
  where: ReferenceWhereInput;
};


export type MutationCreateDeviceTypeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateDictionaryArgs = {
  data: Array<DictionaryInput>;
};


export type MutationCreateDocumentArgs = {
  input: Array<DocumentCreateInput>;
};


export type MutationCreateExclusionTypeArgs = {
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateExclusionsArgs = {
  newExclusions?: InputMaybe<Array<CreateExclusionDataInput>>;
};


export type MutationCreateExclusionsWithReportArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  newExclusions?: InputMaybe<Array<CreateExclusionDataInput>>;
};


export type MutationCreateLoggerArgs = {
  data: Array<LoggerInput>;
};


export type MutationCreateLoggerManufacturerArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateLoggerModelArgs = {
  _id_manufacturer: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateMastTypeArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateMountingTypeArgs = {
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateNoteArgs = {
  _id_reference: Scalars['String']['input'];
  actionDate: Scalars['DateTime']['input'];
  referenceType: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type MutationCreatePortfolioArgs = {
  input: CreatePortfolioInput;
};


export type MutationCreatePowerCurveSettingArgs = {
  _id_calc_settings: Scalars['String']['input'];
  _id_device: Scalars['String']['input'];
  _id_reference_mast?: InputMaybe<Scalars['String']['input']>;
  hubHeight: Scalars['Float']['input'];
  overrideShearAlpha: Scalars['Boolean']['input'];
  powerCurveAirDensity: Scalars['Float']['input'];
  powercurve: Array<Scalars['Float']['input']>;
  ratedPower: Scalars['Float']['input'];
  shearValue?: InputMaybe<Scalars['Float']['input']>;
  siteAirDensity: Scalars['Float']['input'];
  templateName: Scalars['String']['input'];
};


export type MutationCreateProjectAdminTabArgs = {
  input: CreateProjectAdminTabInput;
};


export type MutationCreateRawFilesArgs = {
  files: Array<CreateRawFileInput>;
};


export type MutationCreateRegionArgs = {
  _id_country?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationCreateSensorArgs = {
  _id_device: Scalars['String']['input'];
  _id_mountingType?: InputMaybe<Scalars['String']['input']>;
  _id_reference?: InputMaybe<Scalars['String']['input']>;
  _id_sensorType: Scalars['String']['input'];
  boomToRotorDistance?: InputMaybe<Scalars['Float']['input']>;
  calibrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  calibrationFacility?: InputMaybe<Scalars['String']['input']>;
  deadbandOrientation?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  diameter?: InputMaybe<Scalars['Float']['input']>;
  functioning?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  iecCompliant?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  loggerOffset?: InputMaybe<Scalars['Float']['input']>;
  loggerScale?: InputMaybe<Scalars['Float']['input']>;
  mastDiameterAtInstrument?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Float']['input']>;
  orientation?: InputMaybe<Scalars['Float']['input']>;
  scale?: InputMaybe<Scalars['Float']['input']>;
  sensorModel?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationCreateSensorTypeArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSensorsBatchArgs = {
  data: Array<SensorInput>;
};


export type MutationCreateServiceCaseArgs = {
  input: ServiceCaseCreateInput;
};


export type MutationCreateSignalArgs = {
  _id_sensorType: Scalars['String']['input'];
  _id_subType: Scalars['String']['input'];
  _id_varType: Scalars['String']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  unit: Scalars['String']['input'];
};


export type MutationCreateSignalSubtypeArgs = {
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateSiteArgs = {
  _id_country: Scalars['String']['input'];
  _id_portfolio: Scalars['String']['input'];
  _id_region?: InputMaybe<Scalars['String']['input']>;
  boundary: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateStandardAlarmArgs = {
  input: StandardAlarmInput;
};


export type MutationCreateStandardAlarmCategoryArgs = {
  input: StandardAlarmCategoryInput;
};


export type MutationCreateUserArgs = {
  data: CreateUserInput;
};


export type MutationCreateVarTypeArgs = {
  name: Scalars['String']['input'];
};


export type MutationDeleteCalcSettingArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteCheckPeriodArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_device?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationDeleteCountryArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteCustomAlarmArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteCustomAlarmCategoryArgs = {
  _id: Scalars['String']['input'];
  reassignToCategoryId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteCustomAlarmConditionArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteCustomAlarmsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteCustomPortfolioArgs = {
  _id: Scalars['String']['input'];
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteDataArgs = {
  _id_device: Scalars['String']['input'];
  from: Scalars['Float']['input'];
  sensors: Array<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};


export type MutationDeleteDeviceArgs = {
  _id: Scalars['String']['input'];
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteDeviceManufacturerArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteDeviceModelArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteDeviceTypeArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteDictionaryArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteDocumentArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteExclusionArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteExclusionTypeArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteExclusionsArgs = {
  exclusionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationDeleteLoggerArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteLoggerManufacturerArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteLoggerModelArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteMastTypeArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteMountingTypeArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteNoteArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeletePortfolioArgs = {
  _id: Scalars['String']['input'];
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeletePowerCurveSettingArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteProjectAdminTabArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteRawFileArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteRawFilesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteRegionArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteReportArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSensorArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteSensorTypeArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteServiceCaseArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSignalArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteSignalSubtypeArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteSiteArgs = {
  _id: Scalars['String']['input'];
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteStandardAlarmArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteStandardAlarmCategoryArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteStandardAlarmsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteUsersArgs = {
  data: DeleteUsersInput;
};


export type MutationDeleteVarTypeArgs = {
  _id: Scalars['String']['input'];
};


export type MutationMoveDeviceArgs = {
  _id_device: Scalars['String']['input'];
  _id_site: Scalars['String']['input'];
  copyHistoricalData?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationParsePowerCurveDataFileArgs = {
  file: Scalars['File']['input'];
};


export type MutationParseSensorFileArgs = {
  file: Scalars['File']['input'];
  idDevice: Scalars['String']['input'];
};


export type MutationRemoveCustomPortfolioMembersArgs = {
  _id: Scalars['String']['input'];
  deviceIds: Array<Scalars['String']['input']>;
};


export type MutationRestoreDeviceArgs = {
  _id: Scalars['String']['input'];
};


export type MutationRestorePortfolioArgs = {
  _id: Scalars['String']['input'];
};


export type MutationRestoreSiteArgs = {
  _id: Scalars['String']['input'];
};


export type MutationSendReportNowArgs = {
  _id: Scalars['String']['input'];
  emailList: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationUpdateCalcSettingArgs = {
  _id: Scalars['String']['input'];
  _id_device?: InputMaybe<Scalars['String']['input']>;
  _id_mainAnemometer?: InputMaybe<Scalars['String']['input']>;
  _id_mainPyranometer?: InputMaybe<Scalars['String']['input']>;
  _id_mainRainSensor?: InputMaybe<Scalars['String']['input']>;
  _id_mainThermometer?: InputMaybe<Scalars['String']['input']>;
  _id_mainWindVane?: InputMaybe<Scalars['String']['input']>;
  ampmeters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  longTermAnalisis?: InputMaybe<Scalars['Boolean']['input']>;
  shearAnemometers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statisticSensors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thermometers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateCountryArgs = {
  _id: Scalars['String']['input'];
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateCustomAlarmArgs = {
  _id: Scalars['String']['input'];
  input: UpdateCustomAlarmInput;
};


export type MutationUpdateCustomAlarmCategoryArgs = {
  _id: Scalars['String']['input'];
  input: UpdateCustomAlarmCategoryInput;
};


export type MutationUpdateCustomAlarmConditionArgs = {
  _id: Scalars['String']['input'];
  input: UpdateCustomAlarmConditionInput;
};


export type MutationUpdateCustomPortfolioArgs = {
  _id: Scalars['String']['input'];
  input: UpdateCustomPortfolioInput;
};


export type MutationUpdateDeviceArgs = {
  _id: Scalars['String']['input'];
  data: UpdateDeviceInput;
};


export type MutationUpdateDeviceManufacturerArgs = {
  _id: Scalars['String']['input'];
  _id_deviceType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDeviceModelArgs = {
  _id: Scalars['String']['input'];
  _id_manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDeviceTypeArgs = {
  _id: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDocumentArgs = {
  input: DocumentUpdateInput;
};


export type MutationUpdateExclusionArgs = {
  _id: Scalars['String']['input'];
  updatedExclusion: CreateExclusionDataInput;
};


export type MutationUpdateExclusionTypeArgs = {
  _id: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateExclusionsArgs = {
  updatedExclusions?: InputMaybe<Array<UpdateExclusionDataInput>>;
};


export type MutationUpdateLoggerManufacturerArgs = {
  _id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLoggerModelArgs = {
  _id: Scalars['String']['input'];
  _id_manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMastTypeArgs = {
  _id: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateMountingTypeArgs = {
  _id: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateNoteArgs = {
  _id: Scalars['String']['input'];
  _id_reference?: InputMaybe<Scalars['String']['input']>;
  actionDate: Scalars['DateTime']['input'];
  referenceType?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePortfolioArgs = {
  _id: Scalars['String']['input'];
  input: UpdatePortfolioInput;
};


export type MutationUpdatePowerCurveSettingArgs = {
  _id: Scalars['String']['input'];
  _id_calc_settings?: InputMaybe<Scalars['String']['input']>;
  _id_device?: InputMaybe<Scalars['String']['input']>;
  _id_reference_mast?: InputMaybe<Scalars['String']['input']>;
  hubHeight?: InputMaybe<Scalars['Float']['input']>;
  overrideShearAlpha?: InputMaybe<Scalars['Boolean']['input']>;
  powerCurveAirDensity?: InputMaybe<Scalars['Float']['input']>;
  powercurve?: InputMaybe<Array<Scalars['Float']['input']>>;
  ratedPower?: InputMaybe<Scalars['Float']['input']>;
  shearValue?: InputMaybe<Scalars['Float']['input']>;
  siteAirDensity?: InputMaybe<Scalars['Float']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProjectAdminTabArgs = {
  _id: Scalars['String']['input'];
  input: UpdateProjectAdminTabInput;
};


export type MutationUpdateRegionArgs = {
  _id: Scalars['String']['input'];
  _id_country?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationUpdateReportArgs = {
  id: Scalars['String']['input'];
  input: UpdateReportInput;
};


export type MutationUpdateSensorArgs = {
  _id: Scalars['String']['input'];
  _id_device?: InputMaybe<Scalars['String']['input']>;
  _id_mountingType?: InputMaybe<Scalars['String']['input']>;
  _id_reference?: InputMaybe<Scalars['String']['input']>;
  _id_sensorType?: InputMaybe<Scalars['String']['input']>;
  boomToRotorDistance?: InputMaybe<Scalars['Float']['input']>;
  calibrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  calibrationFacility?: InputMaybe<Scalars['String']['input']>;
  deadbandOrientation?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  diameter?: InputMaybe<Scalars['Float']['input']>;
  functioning?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  iecCompliant?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  loggerOffset?: InputMaybe<Scalars['Float']['input']>;
  loggerScale?: InputMaybe<Scalars['Float']['input']>;
  mastDiameterAtInstrument?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  orientation?: InputMaybe<Scalars['Float']['input']>;
  scale?: InputMaybe<Scalars['Float']['input']>;
  sensorModel?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationUpdateSensorTypeArgs = {
  _id: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateServiceCaseArgs = {
  id: Scalars['String']['input'];
  input: ServiceCaseUpdateInput;
};


export type MutationUpdateSignalArgs = {
  _id: Scalars['String']['input'];
  _id_sensorType?: InputMaybe<Scalars['String']['input']>;
  _id_subType?: InputMaybe<Scalars['String']['input']>;
  _id_varType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSignalSubtypeArgs = {
  _id: Scalars['String']['input'];
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateSiteArgs = {
  _id: Scalars['String']['input'];
  _id_region?: InputMaybe<Scalars['String']['input']>;
  boundary?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateStandardAlarmArgs = {
  _id: Scalars['String']['input'];
  input: UpdateStandardAlarmInput;
};


export type MutationUpdateStandardAlarmCategoryArgs = {
  _id: Scalars['String']['input'];
  input: StandardAlarmCategoryInput;
};


export type MutationUpdateTriggeredAlarmArgs = {
  alarm: UpdateTriggeredAlarmInput;
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
};


export type MutationUpdateVarTypeArgs = {
  _id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUploadDictionaryArgs = {
  _id_device: Scalars['String']['input'];
  _id_logger: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  file: Scalars['File']['input'];
};


export type MutationUploadExclusionsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  file: Scalars['File']['input'];
  parseDatetimesAsStandardTime?: InputMaybe<Scalars['Boolean']['input']>;
  targetDevice?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertDictionaryArgs = {
  data: Array<DictionaryUpsertInput>;
};


export type MutationUpsertLoggerArgs = {
  data: Array<LoggerUpsertInput>;
};

export type Note = {
  __typename?: 'Note';
  _id: Scalars['String']['output'];
  _id_reference: Scalars['String']['output'];
  actionDate: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  referenceType: Scalars['String']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type NotePagination = {
  __typename?: 'NotePagination';
  items: Array<Note>;
  totalCount: Scalars['Int']['output'];
};

export type NoteWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_reference?: InputMaybe<Scalars['String']['input']>;
  actionDate?: InputMaybe<Scalars['DateTime']['input']>;
  referenceType?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export enum NotifyModeEnum {
  Always = 'always',
  Once = 'once'
}

export type OperationError = {
  __typename?: 'OperationError';
  code: Scalars['String']['output'];
  details?: Maybe<Scalars['JSONObject']['output']>;
  /** Human-readable UTC datetime derived from stored instants. */
  endDate?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex?: Maybe<Scalars['Int']['output']>;
  sensorId?: Maybe<Scalars['String']['output']>;
  sensorName?: Maybe<Scalars['String']['output']>;
  /** Human-readable UTC datetime derived from stored instants. */
  startDate?: Maybe<Scalars['String']['output']>;
};

export type OperationWarning = {
  __typename?: 'OperationWarning';
  code: Scalars['String']['output'];
  details?: Maybe<Scalars['JSONObject']['output']>;
  /** Human-readable UTC datetime derived from stored instants. */
  endDate?: Maybe<Scalars['String']['output']>;
  exclusionId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex?: Maybe<Scalars['Int']['output']>;
  sensorId?: Maybe<Scalars['String']['output']>;
  sensorName?: Maybe<Scalars['String']['output']>;
  /** Human-readable UTC datetime derived from stored instants. */
  startDate?: Maybe<Scalars['String']['output']>;
};

export type Portfolio = {
  __typename?: 'Portfolio';
  Devices?: Maybe<DevicePagination>;
  Sites: SitePagination;
  _id: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type PortfolioDevicesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DeviceWhereInput>;
};


export type PortfolioSitesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SiteWhereInput>;
};

export type PortfolioAccess = {
  __typename?: 'PortfolioAccess';
  Portfolios?: Maybe<PortfolioPagination>;
};


export type PortfolioAccessPortfoliosArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PortfolioWhereInput>;
};

export type PortfolioPagination = {
  __typename?: 'PortfolioPagination';
  items: Array<Portfolio>;
  totalCount: Scalars['Int']['output'];
};

export type PortfolioWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PowerCurvePreview = {
  __typename?: 'PowerCurvePreview';
  hubHeight: Scalars['Float']['output'];
  powerCurveAirDensity: Scalars['Float']['output'];
  powercurve: Array<Scalars['Float']['output']>;
  ratedPower: Scalars['Float']['output'];
  siteAirDensity: Scalars['Float']['output'];
  templateName: Scalars['String']['output'];
};

export type PowerCurveSetting = {
  __typename?: 'PowerCurveSetting';
  _id: Scalars['String']['output'];
  _id_calc_settings: Scalars['String']['output'];
  _id_device: Scalars['String']['output'];
  _id_reference_mast?: Maybe<Scalars['String']['output']>;
  hubHeight: Scalars['Float']['output'];
  overrideShearAlpha: Scalars['Boolean']['output'];
  powerCurveAirDensity: Scalars['Float']['output'];
  powercurve: Array<Scalars['Float']['output']>;
  ratedPower: Scalars['Float']['output'];
  shearValue?: Maybe<Scalars['Float']['output']>;
  siteAirDensity: Scalars['Float']['output'];
  templateName: Scalars['String']['output'];
};

export type PowerCurveSettingPagination = {
  __typename?: 'PowerCurveSettingPagination';
  items: Array<PowerCurveSetting>;
  totalCount: Scalars['Int']['output'];
};

export type PowerCurveSettingWhereInput = {
  _id_calc_settings?: InputMaybe<Scalars['String']['input']>;
  _id_device?: InputMaybe<Scalars['String']['input']>;
  _id_reference_mast?: InputMaybe<Scalars['String']['input']>;
  hubHeight?: InputMaybe<Scalars['Float']['input']>;
  overrideShearAlpha?: InputMaybe<Scalars['Boolean']['input']>;
  powerCurveAirDensity?: InputMaybe<Scalars['Float']['input']>;
  powercurve?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  ratedPower?: InputMaybe<Scalars['Float']['input']>;
  shearValue?: InputMaybe<Scalars['Float']['input']>;
  siteAirDensity?: InputMaybe<Scalars['Float']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectAdminTab = {
  __typename?: 'ProjectAdminTab';
  /** Currency details based on _id_currency reference */
  Currency?: Maybe<Currency>;
  _id: Scalars['String']['output'];
  _id_currency: Scalars['String']['output'];
  _id_device: Scalars['String']['output'];
  _id_portfolio: Scalars['String']['output'];
  _id_site: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  invoiceAmount: Scalars['Float']['output'];
  invoiceFrequency: InvoiceFrequencyEnum;
  legalEntity: Scalars['String']['output'];
  projectNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProjectAdminTabPagination = {
  __typename?: 'ProjectAdminTabPagination';
  items: Array<ProjectAdminTab>;
  totalCount: Scalars['Int']['output'];
};

export type ProjectAdminTabWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_currency?: InputMaybe<Scalars['String']['input']>;
  _id_device?: InputMaybe<Scalars['String']['input']>;
  _id_portfolio?: InputMaybe<Scalars['String']['input']>;
  _id_site?: InputMaybe<Scalars['String']['input']>;
  invoiceAmount?: InputMaybe<Scalars['Float']['input']>;
  invoiceFrequency?: InputMaybe<InvoiceFrequencyEnum>;
  legalEntity?: InputMaybe<Scalars['String']['input']>;
  projectNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  CalcSetting: CalcSettingPagination;
  ChannelType: Array<Maybe<ChannelType>>;
  Country: CountryPagination;
  Currency: CurrencyPagination;
  CustomAlarm: CustomAlarmPagination;
  CustomAlarmCategory: CustomAlarmCategoryPagination;
  CustomAlarmCondition: CustomAlarmConditionPagination;
  CustomPortfolio: CustomPortfolioPagination;
  DataCoverage?: Maybe<Array<Maybe<DataCoverage>>>;
  Device: DevicePagination;
  DeviceManufacturer: DeviceManufacturerPagination;
  DeviceModel: DeviceModelPagination;
  DeviceType: DeviceTypePagination;
  Dictionary: DictionaryPagination;
  DiurnalVariation?: Maybe<Array<Maybe<DiurnalVariation>>>;
  Document: DocumentPagination;
  Exclusion: Exclusion;
  ExclusionType: ExclusionType;
  FreqDistributions: Array<FreqDistributions>;
  GetCheckPeriod: CheckPeriodPagination;
  Images: ImagePagination;
  Logger: LoggerPagination;
  LoggerManufacturer: LoggerManufacturerPagination;
  LoggerModel: LoggerModelPagination;
  MastShadow: MastShadow;
  MastType: MastTypePagination;
  MountingType: MountingTypePagination;
  Note: NotePagination;
  Portfolio: PortfolioPagination;
  PowerCurveSetting: PowerCurveSettingPagination;
  RawFile: RawFilePagination;
  Region: RegionPagination;
  Reports: ReportsConnection;
  Sensor: SensorPagination;
  SensorCorrelation: SensorCorrelation;
  SensorType: SensorTypePagination;
  Signal: SignalPagination;
  SignalSubtype: SignalSubtypePagination;
  Site: SitePagination;
  SiteCoverage?: Maybe<Array<Maybe<SiteCoverage>>>;
  /** List standard alarms with filters. Filter by _id_category for no_file_received alarms. */
  StandardAlarm: StandardAlarmPagination;
  StandardAlarmCategory: StandardAlarmCategoryPagination;
  Timeseries: Array<Timeseries>;
  Timezone: TimezonePagination;
  TriggeredAlarms: TriggeredAlarmPagination;
  VarType: VarTypePagination;
  WindRoses: Array<WindRoses>;
  /** List mutation audit trail. Hidden from Client. Analyst+ can read. Filter by module, action, actor, device, site, user. */
  auditLogs: AuditLogPagination;
  downloadDictionaryTemplate: DictionaryTemplateDownload;
  getDirectionalWindShearVariation?: Maybe<DirectionalWindShearVariation>;
  getDiurnalWindShearVariation?: Maybe<DiurnalWindShearVariation>;
  getSeasonalWindShearVariation: Array<SeasonalWindShearVariation>;
  getTurbulenceIntensity: Array<TurbulenceIntensity>;
  getTurbulenceWDIRIntensity: Array<TurbulenceWdirIntensity>;
  longTermWSEnergy?: Maybe<LongTermWsEnergy>;
  /** Fat managed-user detail (portfolio tree) for the editor */
  managedUser: UserDetails;
  projectAdminTab?: Maybe<ProjectAdminTab>;
  projectAdminTabs: ProjectAdminTabPagination;
  securityPreferences: SecurityPreferences;
  serviceCase?: Maybe<ServiceCase>;
  serviceCases: ServiceCasePagination;
  suggestRawSignals: Array<SensorSignalSuggestions>;
  /** Get current user permissions and accessible resources */
  userPermissions: UserPermissions;
  verticalWindProfile?: Maybe<VerticalWindProfile>;
};


export type QueryCalcSettingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<CalcSettingWhereInput>;
};


export type QueryChannelTypeArgs = {
  where?: InputMaybe<ChannelTypeWhereInput>;
};


export type QueryCountryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<CountryWhereInput>;
};


export type QueryCurrencyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<CurrencyWhereInput>;
};


export type QueryCustomAlarmArgs = {
  filters?: InputMaybe<CustomAlarmFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomAlarmCategoryArgs = {
  filters?: InputMaybe<CustomAlarmCategoryFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomAlarmConditionArgs = {
  filters?: InputMaybe<CustomAlarmConditionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomPortfolioArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<CustomPortfolioWhereInput>;
};


export type QueryDataCoverageArgs = {
  device_id: Scalars['ID']['input'];
};


export type QueryDeviceArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DeviceWhereInput>;
};


export type QueryDeviceManufacturerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DeviceManufacturerWhereInput>;
};


export type QueryDeviceModelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DeviceModelWhereInput>;
};


export type QueryDeviceTypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DeviceTypeWhereInput>;
};


export type QueryDictionaryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortConfig?: InputMaybe<DictionarySortConfig>;
  where: DictionaryWhereInput;
};


export type QueryDiurnalVariationArgs = {
  device_id: Scalars['String']['input'];
  where: DiurnalVariationWhereInput;
};


export type QueryDocumentArgs = {
  _id_device: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExclusionArgs = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExclusionDataWhereInput>;
};


export type QueryExclusionTypeArgs = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ExclusionTypeWhereInput>;
};


export type QueryFreqDistributionsArgs = {
  device_id: Scalars['String']['input'];
  where: FreqDistributionsWhereInput;
};


export type QueryGetCheckPeriodArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where: CheckPeriodWhereInput;
};


export type QueryImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ImageWhereInput>;
};


export type QueryLoggerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where: LoggerWhereInput;
};


export type QueryLoggerManufacturerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<LoggerManufacturerWhereInput>;
};


export type QueryLoggerModelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<LoggerModelWhereInput>;
};


export type QueryMastShadowArgs = {
  device_id: Scalars['ID']['input'];
  where: MastShadowWhereInput;
};


export type QueryMastTypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<MastTypeWhereInput>;
};


export type QueryMountingTypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<MountingTypeWhereInput>;
};


export type QueryNoteArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<NoteWhereInput>;
};


export type QueryPortfolioArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PortfolioWhereInput>;
};


export type QueryPowerCurveSettingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PowerCurveSettingWhereInput>;
};


export type QueryRawFileArgs = {
  _id_device: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRegionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<RegionWhereInput>;
};


export type QueryReportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReportOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportWhereInput>;
};


export type QuerySensorArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where: SensorWhereInput;
};


export type QuerySensorCorrelationArgs = {
  device_id: Scalars['ID']['input'];
  where: SensorCorrelationWhereInput;
};


export type QuerySensorTypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SensorTypeWhereInput>;
};


export type QuerySignalArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SignalWhereInput>;
};


export type QuerySignalSubtypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SignalSubtypeWhereInput>;
};


export type QuerySiteArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SiteWhereInput>;
};


export type QuerySiteCoverageArgs = {
  device_ids: Array<Scalars['ID']['input']>;
  yearFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStandardAlarmArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<StandardAlarmFilterInput>;
};


export type QueryStandardAlarmCategoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<StandardAlarmCategoryWhereInput>;
};


export type QueryTimeseriesArgs = {
  device_id: Scalars['String']['input'];
  where: TimeseriesWhereInput;
};


export type QueryTimezoneArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<TimezoneWhereInput>;
};


export type QueryTriggeredAlarmsArgs = {
  filter?: InputMaybe<AlarmFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortDirectionEnum>;
};


export type QueryVarTypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<VarTypeWhereInput>;
};


export type QueryWindRosesArgs = {
  device_id: Scalars['String']['input'];
  where: WindRosesWhereInput;
};


export type QueryAuditLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuditLogWhereInput>;
};


export type QueryDownloadDictionaryTemplateArgs = {
  _id_device: Scalars['String']['input'];
};


export type QueryGetDirectionalWindShearVariationArgs = {
  input?: InputMaybe<DirectionalWindShearVariationInput>;
};


export type QueryGetDiurnalWindShearVariationArgs = {
  input?: InputMaybe<DiurnalWindShearVariationInput>;
};


export type QueryGetSeasonalWindShearVariationArgs = {
  input: SeasonalWindShearVariationInput;
};


export type QueryGetTurbulenceIntensityArgs = {
  input: TurbulenceIntensityInput;
};


export type QueryGetTurbulenceWdirIntensityArgs = {
  input: TurbulenceWdirIntensityInput;
};


export type QueryLongTermWsEnergyArgs = {
  input?: InputMaybe<LongTermWsEnergyInput>;
};


export type QueryManagedUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectAdminTabArgs = {
  _id: Scalars['String']['input'];
};


export type QueryProjectAdminTabsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProjectAdminTabWhereInput>;
};


export type QueryServiceCaseArgs = {
  id: Scalars['String']['input'];
};


export type QueryServiceCasesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ServiceCaseWhereInput>;
};


export type QuerySuggestRawSignalsArgs = {
  data: SuggestRawSignalsInput;
};


export type QueryVerticalWindProfileArgs = {
  input?: InputMaybe<VerticalWindProfileInput>;
};

export type RawFile = {
  __typename?: 'RawFile';
  _id: Scalars['String']['output'];
  _id_device: Scalars['String']['output'];
  _id_logger: Scalars['String']['output'];
  airflow_run?: Maybe<Scalars['DateTime']['output']>;
  bucket_path: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  processed_at?: Maybe<Scalars['DateTime']['output']>;
  received_at: Scalars['DateTime']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
};

export type RawFilePagination = {
  __typename?: 'RawFilePagination';
  items: Array<RawFile>;
  totalCount: Scalars['Int']['output'];
};

export type ReconcileUserDirectoryResult = {
  __typename?: 'ReconcileUserDirectoryResult';
  deleted: Scalars['Int']['output'];
  upserted: Scalars['Int']['output'];
};

export type ReferenceWhereInput = {
  _id_device?: InputMaybe<Scalars['String']['input']>;
};

export type Region = {
  __typename?: 'Region';
  _id: Scalars['String']['output'];
  _id_country?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type RegionPagination = {
  __typename?: 'RegionPagination';
  items: Array<Region>;
  totalCount: Scalars['Int']['output'];
};

export type RegionWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_country?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Report = {
  __typename?: 'Report';
  _id: Scalars['String']['output'];
  _id_deviceType: Scalars['String']['output'];
  _id_portfolio: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  creatorName?: Maybe<Scalars['String']['output']>;
  deviceIds: Array<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  report?: Maybe<Scalars['String']['output']>;
  reportType: ReportTypeEnum;
  schedule: ReportSchedule;
  siteIds: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ReportOrderByInput = {
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ReportSchedule = {
  __typename?: 'ReportSchedule';
  autoUpdate: Scalars['Boolean']['output'];
  dateRange: DateRange;
  emailList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstDays?: Maybe<Array<Maybe<Scalars['Boolean']['output']>>>;
  footer?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  hour?: Maybe<Array<Maybe<Scalars['Boolean']['output']>>>;
  level?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logoName?: Maybe<Scalars['String']['output']>;
  schedule: Scalars['String']['output'];
  weekDays?: Maybe<Array<Maybe<Scalars['Boolean']['output']>>>;
};

export type ReportScheduleInput = {
  autoUpdate: Scalars['Boolean']['input'];
  dateRange: DateRangeInput;
  emailList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstDays?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  footer?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  hour?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  level?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  logoName?: InputMaybe<Scalars['String']['input']>;
  schedule: Scalars['String']['input'];
  weekDays?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type ReportScheduleUpdateInput = {
  autoUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  emailList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstDays?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  footer?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  hour?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  level?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  logoName?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  weekDays?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** Report type enum */
export enum ReportTypeEnum {
  Report = 'REPORT',
  Template = 'TEMPLATE'
}

export type ReportWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_deviceType?: InputMaybe<Scalars['String']['input']>;
  _id_portfolio?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<ReportTypeEnum>;
  siteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReportsConnection = {
  __typename?: 'ReportsConnection';
  data: Array<Report>;
  total: Scalars['Int']['output'];
};

export type ScLwsCutoffInput = {
  anemometer?: InputMaybe<Scalars['ID']['input']>;
  cut: Scalars['Float']['input'];
};

export type ScSecondSensorInput = {
  device_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  signal: SignalEnum;
};

export type ScSensorInput = {
  id: Scalars['ID']['input'];
  signal: SignalEnum;
};

export type SeasonalWindShearVariation = {
  __typename?: 'SeasonalWindShearVariation';
  all?: Maybe<Scalars['Float']['output']>;
  april?: Maybe<Scalars['Float']['output']>;
  august?: Maybe<Scalars['Float']['output']>;
  december?: Maybe<Scalars['Float']['output']>;
  february?: Maybe<Scalars['Float']['output']>;
  hour: Scalars['Int']['output'];
  january?: Maybe<Scalars['Float']['output']>;
  july?: Maybe<Scalars['Float']['output']>;
  june?: Maybe<Scalars['Float']['output']>;
  march?: Maybe<Scalars['Float']['output']>;
  may?: Maybe<Scalars['Float']['output']>;
  november?: Maybe<Scalars['Float']['output']>;
  october?: Maybe<Scalars['Float']['output']>;
  september?: Maybe<Scalars['Float']['output']>;
};

export type SeasonalWindShearVariationInput = {
  _id_device: Scalars['ID']['input'];
  years?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SecurityPreferences = {
  __typename?: 'SecurityPreferences';
  twoFAEnabled: Scalars['Boolean']['output'];
};

export type Sensor = {
  __typename?: 'Sensor';
  SensorType: SensorTypePagination;
  Signals: SignalPagination;
  _id: Scalars['String']['output'];
  _id_device: Scalars['String']['output'];
  _id_mountingType?: Maybe<Scalars['String']['output']>;
  _id_reference?: Maybe<Scalars['String']['output']>;
  _id_sensorType: Scalars['String']['output'];
  boomToRotorDistance?: Maybe<Scalars['Float']['output']>;
  calibrationDate?: Maybe<Scalars['DateTime']['output']>;
  calibrationFacility?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deadbandOrientation?: Maybe<Scalars['Float']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  diameter?: Maybe<Scalars['Float']['output']>;
  functioning?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  iecCompliant?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  loggerOffset?: Maybe<Scalars['Float']['output']>;
  loggerScale?: Maybe<Scalars['Float']['output']>;
  mastDiameterAtInstrument?: Maybe<Scalars['Float']['output']>;
  migrationMetadata?: Maybe<MigrationMetadata>;
  name: Scalars['String']['output'];
  offset: Scalars['Float']['output'];
  orientation?: Maybe<Scalars['Float']['output']>;
  scale: Scalars['Float']['output'];
  sensorModel?: Maybe<Scalars['String']['output']>;
  sensorTypeName?: Maybe<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};


export type SensorSensorTypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SensorTypeWhereInput>;
};


export type SensorSignalsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SignalWhereInput>;
};

export type SensorCorrelation = {
  __typename?: 'SensorCorrelation';
  pearsonCorr?: Maybe<Scalars['Float']['output']>;
  sensor1Values: Array<Maybe<Scalars['Float']['output']>>;
  sensor2Values: Array<Maybe<Scalars['Float']['output']>>;
  timestamps: Array<Maybe<Scalars['Float']['output']>>;
};

export type SensorCorrelationWhereInput = {
  dirSector?: InputMaybe<DirSectorInput>;
  endTS: Scalars['Float']['input'];
  lwsCutoff?: InputMaybe<ScLwsCutoffInput>;
  sensor1: ScSensorInput;
  sensor2: ScSecondSensorInput;
  startTS: Scalars['Float']['input'];
};

export type SensorInput = {
  _id_device: Scalars['String']['input'];
  _id_mountingType?: InputMaybe<Scalars['String']['input']>;
  _id_reference?: InputMaybe<Scalars['String']['input']>;
  _id_sensorType: Scalars['String']['input'];
  boomToRotorDistance?: InputMaybe<Scalars['Float']['input']>;
  calibrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  calibrationFacility?: InputMaybe<Scalars['String']['input']>;
  deadbandOrientation?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  diameter?: InputMaybe<Scalars['Float']['input']>;
  functioning?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  iecCompliant?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  loggerOffset?: InputMaybe<Scalars['Float']['input']>;
  loggerScale?: InputMaybe<Scalars['Float']['input']>;
  mastDiameterAtInstrument?: InputMaybe<Scalars['Float']['input']>;
  migrationMetadata?: InputMaybe<MigrationMetadataInput>;
  name: Scalars['String']['input'];
  offset: Scalars['Float']['input'];
  orientation?: InputMaybe<Scalars['Float']['input']>;
  scale: Scalars['Float']['input'];
  sensorModel?: InputMaybe<Scalars['String']['input']>;
  serialNumber: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SensorMap = {
  __typename?: 'SensorMap';
  _id_sensorType: Scalars['String']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  orientation?: Maybe<Scalars['Float']['output']>;
  sensorUsageCount: Scalars['Int']['output'];
  signalMappings: Array<SignalMapping>;
};

export type SensorPagination = {
  __typename?: 'SensorPagination';
  items: Array<Sensor>;
  totalCount: Scalars['Int']['output'];
};

export type SensorSignalSuggestions = {
  __typename?: 'SensorSignalSuggestions';
  _id_sensorType: Scalars['String']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  orientation?: Maybe<Scalars['Float']['output']>;
  signalSuggestions: Array<StandardSignalSuggestions>;
};

export type SensorType = {
  __typename?: 'SensorType';
  _id: Scalars['String']['output'];
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export enum SensorTypeNameEnum {
  AmpMeter = 'AMP_METER',
  Anemometer = 'ANEMOMETER',
  Barometer = 'BAROMETER',
  CurrentDirection = 'CURRENT_DIRECTION',
  CurrentSpeed = 'CURRENT_SPEED',
  DeviceDirection = 'DEVICE_DIRECTION',
  DevicePitch = 'DEVICE_PITCH',
  DeviceRoll = 'DEVICE_ROLL',
  Hygrometer = 'HYGROMETER',
  Other = 'OTHER',
  Pyranometer = 'PYRANOMETER',
  Pyrheliometer = 'PYRHELIOMETER',
  RainGauge = 'RAIN_GAUGE',
  Thermometer = 'THERMOMETER',
  VerticalAnemometer = 'VERTICAL_ANEMOMETER',
  Voltmeter = 'VOLTMETER',
  WaterConductivity = 'WATER_CONDUCTIVITY',
  WaterPressure = 'WATER_PRESSURE',
  WaterSalinity = 'WATER_SALINITY',
  WaveDirection = 'WAVE_DIRECTION',
  WaveHeight = 'WAVE_HEIGHT',
  WavePeriod = 'WAVE_PERIOD',
  WindVane = 'WIND_VANE'
}

export type SensorTypePagination = {
  __typename?: 'SensorTypePagination';
  items: Array<SensorType>;
  totalCount: Scalars['Int']['output'];
};

export type SensorTypeWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type SensorWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_device: Scalars['String']['input'];
  _id_mountingType?: InputMaybe<Scalars['String']['input']>;
  _id_reference?: InputMaybe<Scalars['String']['input']>;
  _id_sensorType?: InputMaybe<Scalars['String']['input']>;
  boomToRotorDistance?: InputMaybe<Scalars['Float']['input']>;
  calibrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  calibrationFacility?: InputMaybe<Scalars['String']['input']>;
  deadbandOrientation?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  diameter?: InputMaybe<Scalars['Float']['input']>;
  functioning?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  iecCompliant?: InputMaybe<Scalars['String']['input']>;
  is_hide_sensors_references?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  loggerOffset?: InputMaybe<Scalars['Float']['input']>;
  loggerScale?: InputMaybe<Scalars['Float']['input']>;
  mastDiameterAtInstrument?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  orientation?: InputMaybe<Scalars['Float']['input']>;
  scale?: InputMaybe<Scalars['Float']['input']>;
  sensorModel?: InputMaybe<Scalars['String']['input']>;
  sensorTypeName?: InputMaybe<SensorTypeNameEnum>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ServiceCase = {
  __typename?: 'ServiceCase';
  Country: ServiceCaseCountry;
  _id: Scalars['String']['output'];
  _id_country: Scalars['String']['output'];
  _id_device?: Maybe<Scalars['String']['output']>;
  _id_portfolio?: Maybe<Scalars['String']['output']>;
  _id_site: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Array<Scalars['String']['output']>>;
  priority?: Maybe<ServiceCasePriority>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ServiceCaseCountry = {
  __typename?: 'ServiceCaseCountry';
  name: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
};

export type ServiceCaseCreateInput = {
  _id_device: Scalars['String']['input'];
  createdOn: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Array<Scalars['String']['input']>>;
  priority?: InputMaybe<ServiceCasePriority>;
  status: Scalars['String']['input'];
};

export type ServiceCasePagination = {
  __typename?: 'ServiceCasePagination';
  items: Array<ServiceCase>;
  totalCount: Scalars['Int']['output'];
};

export enum ServiceCasePriority {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type ServiceCaseUpdateInput = {
  _id_country?: InputMaybe<Scalars['String']['input']>;
  _id_device?: InputMaybe<Scalars['String']['input']>;
  _id_portfolio?: InputMaybe<Scalars['String']['input']>;
  _id_site?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Array<Scalars['String']['input']>>;
  priority?: InputMaybe<ServiceCasePriority>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceCaseWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_country?: InputMaybe<Scalars['String']['input']>;
  _id_device?: InputMaybe<Scalars['String']['input']>;
  _id_portfolio?: InputMaybe<Scalars['String']['input']>;
  _id_site?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<ServiceCasePriority>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type Signal = {
  __typename?: 'Signal';
  _id: Scalars['String']['output'];
  _id_sensorType: Scalars['String']['output'];
  _id_subType: Scalars['String']['output'];
  _id_varType: Scalars['String']['output'];
  description: Scalars['String']['output'];
  isMainSignal?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export enum SignalEnum {
  AAvg = 'A_avg',
  AMax = 'A_max',
  AMin = 'A_min',
  AStd = 'A_std',
  Avl = 'Avl',
  Azimuth = 'Azimuth',
  CalcSign = 'CalcSign',
  CnrAvg = 'Cnr_avg',
  CnrMax = 'Cnr_max',
  CnrMin = 'Cnr_min',
  CnrStd = 'Cnr_std',
  CurDirAvg = 'CurDir_avg',
  CurDirMax = 'CurDir_max',
  CurDirMin = 'CurDir_min',
  CurDirStd = 'CurDir_std',
  CurProfDir = 'CurProfDir',
  CurProfSpd = 'CurProfSpd',
  CurSpdAvg = 'CurSpd_avg',
  CurSpdMax = 'CurSpd_max',
  CurSpdMin = 'CurSpd_min',
  CurSpdStd = 'CurSpd_std',
  DevDir = 'DevDir',
  DevPthAvg = 'DevPth_avg',
  DevPthMax = 'DevPth_max',
  DevPthMin = 'DevPth_min',
  DevPthStd = 'DevPth_std',
  DevRolAvg = 'DevRol_avg',
  DevRolMax = 'DevRol_max',
  DevRolMin = 'DevRol_min',
  DevRolStd = 'DevRol_std',
  HumAvg = 'Hum_avg',
  HumMax = 'Hum_max',
  HumMin = 'Hum_min',
  HumStd = 'Hum_std',
  InfAngAvg = 'InfAng_avg',
  InfAngMax = 'InfAng_max',
  InfAngMin = 'InfAng_min',
  InfAngStd = 'InfAng_std',
  InsolAvg = 'Insol_avg',
  InsolMax = 'Insol_max',
  InsolMin = 'Insol_min',
  InsolStd = 'Insol_std',
  IrrDctAvg = 'IrrDct_avg',
  IrrDctMax = 'IrrDct_max',
  IrrDctMin = 'IrrDct_min',
  IrrDctStd = 'IrrDct_std',
  OtherAvg = 'Other_avg',
  OtherMax = 'Other_max',
  OtherMin = 'Other_min',
  OtherStd = 'Other_std',
  Pkt = 'Pkt',
  PktCnt = 'PktCnt',
  PresAvg = 'Pres_avg',
  PresMax = 'Pres_max',
  PresMin = 'Pres_min',
  PresStd = 'Pres_std',
  RnFllAvg = 'RnFll_avg',
  RnFllMax = 'RnFll_max',
  RnFllMin = 'RnFll_min',
  RnFllStd = 'RnFll_std',
  SnrAvg = 'Snr_avg',
  SnrMax = 'Snr_max',
  SnrMin = 'Snr_min',
  SnrStd = 'Snr_std',
  SpecBrdn = 'SpecBrdn',
  Tilt = 'Tilt',
  TiltAvg = 'Tilt_avg',
  TiltMax = 'Tilt_max',
  TiltMin = 'Tilt_min',
  TiltStd = 'Tilt_std',
  TmpAvg = 'Tmp_avg',
  TmpMax = 'Tmp_max',
  TmpMin = 'Tmp_min',
  TmpStd = 'Tmp_std',
  VAvg = 'V_avg',
  VMax = 'V_max',
  VMin = 'V_min',
  VStd = 'V_std',
  VerWdSpdAvg = 'VerWdSpd_avg',
  VerWdSpdMax = 'VerWdSpd_max',
  VerWdSpdMin = 'VerWdSpd_min',
  VerWdSpdStd = 'VerWdSpd_std',
  WavDir = 'WavDir',
  WavDirSwe = 'WavDirSwe',
  WavDirWd = 'WavDirWd',
  WavHei = 'WavHei',
  WavHeiSwe = 'WavHeiSwe',
  WavHeiWd = 'WavHeiWd',
  WavHeiMax = 'WavHei_max',
  WavHiHzDir = 'WavHiHzDir',
  WavHiPer = 'WavHiPer',
  WavPer = 'WavPer',
  WavPerPk = 'WavPerPk',
  WavPerPkDir = 'WavPerPkDir',
  WavPerZer = 'WavPerZer',
  WavPerZerEst = 'WavPerZerEst',
  WavPerZerSweEst = 'WavPerZerSweEst',
  WavPerZerWdEst = 'WavPerZerWdEst',
  WdDirAvg = 'WdDir_avg',
  WdDirMax = 'WdDir_max',
  WdDirMin = 'WdDir_min',
  WdDirStd = 'WdDir_std',
  WdSpdAvg = 'WdSpd_avg',
  WdSpdMax = 'WdSpd_max',
  WdSpdMin = 'WdSpd_min',
  WdSpdStd = 'WdSpd_std',
  WipOpCnt = 'WipOpCnt',
  WtrCndctAvg = 'WtrCndct_avg',
  WtrCndctMax = 'WtrCndct_max',
  WtrCndctMin = 'WtrCndct_min',
  WtrCndctStd = 'WtrCndct_std',
  WtrPresAvg = 'WtrPres_avg',
  WtrPresMax = 'WtrPres_max',
  WtrPresMin = 'WtrPres_min',
  WtrPresStd = 'WtrPres_std',
  WtrSlntAvg = 'WtrSlnt_avg',
  WtrSlntMax = 'WtrSlnt_max',
  WtrSlntMin = 'WtrSlnt_min',
  WtrSlntStd = 'WtrSlnt_std',
  WtrTmpAvg = 'WtrTmp_avg',
  WtrTmpMax = 'WtrTmp_max',
  WtrTmpMin = 'WtrTmp_min',
  WtrTmpStd = 'WtrTmp_std'
}

export type SignalMapping = {
  __typename?: 'SignalMapping';
  confidence: Scalars['Float']['output'];
  lastUsed: Scalars['DateTime']['output'];
  rawSignalName: Scalars['String']['output'];
  standardSignal: Scalars['String']['output'];
};

export type SignalMappingSensorInput = {
  _id_sensorType: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  orientation?: InputMaybe<Scalars['Float']['input']>;
  signals: Array<Scalars['String']['input']>;
};

export type SignalPagination = {
  __typename?: 'SignalPagination';
  items: Array<Signal>;
  totalCount: Scalars['Int']['output'];
};

export type SignalSubtype = {
  __typename?: 'SignalSubtype';
  _id: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SignalSubtypePagination = {
  __typename?: 'SignalSubtypePagination';
  items: Array<SignalSubtype>;
  totalCount: Scalars['Int']['output'];
};

export type SignalSubtypeWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SignalSuggestion = {
  __typename?: 'SignalSuggestion';
  confidence: Scalars['Float']['output'];
  lastUsed?: Maybe<Scalars['DateTime']['output']>;
  matchType: MatchType;
  rawSignal: Scalars['String']['output'];
};

export type SignalTemplateMapping = {
  __typename?: 'SignalTemplateMapping';
  _id: Scalars['String']['output'];
  _id_deviceType: Scalars['String']['output'];
  _id_loggerManufacturer: Scalars['String']['output'];
  _id_loggerModel: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  metadata: SignalTemplateMappingMetadata;
  sensorMaps: Array<SensorMap>;
  totalValidations: Scalars['Int']['output'];
};

export type SignalTemplateMappingMetadata = {
  __typename?: 'SignalTemplateMappingMetadata';
  confirmedBy: Array<Scalars['String']['output']>;
  firstSeen: Scalars['DateTime']['output'];
  lastConfirmed: Scalars['DateTime']['output'];
};

export type SignalWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_sensorType?: InputMaybe<Scalars['String']['input']>;
  _id_subType?: InputMaybe<Scalars['String']['input']>;
  _id_varType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isMainSignal?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type Site = {
  __typename?: 'Site';
  /** Paginated list of devices associated with this site */
  Devices: DevicePagination;
  _id: Scalars['String']['output'];
  _id_country: Scalars['String']['output'];
  _id_portfolio: Scalars['String']['output'];
  _id_region?: Maybe<Scalars['String']['output']>;
  boundary?: Maybe<Scalars['GeoJSON']['output']>;
  /** Country Name of the Site */
  country?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Region Name of the Site */
  regionName?: Maybe<Scalars['String']['output']>;
};


export type SiteDevicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DeviceWhereInput>;
};

export type SiteCoverage = {
  __typename?: 'SiteCoverage';
  coverages: Array<SiteCoverageData>;
  device_id: Scalars['ID']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
};

export type SiteCoverageData = {
  __typename?: 'SiteCoverageData';
  data: Array<DataCoverageData>;
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type SitePagination = {
  __typename?: 'SitePagination';
  items: Array<Site>;
  totalCount: Scalars['Int']['output'];
};

export type SiteWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_country?: InputMaybe<Scalars['String']['input']>;
  _id_portfolio?: InputMaybe<Scalars['String']['input']>;
  _id_region?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

/** Category of standard alarm (e.g. sensor_failure, no_data, low_battery, no_file_received). Defines the condition structure for alarms of this type. */
export type StandardAlarmCategory = {
  __typename?: 'StandardAlarmCategory';
  _id: Scalars['ID']['output'];
  color: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type StandardAlarmCategoryInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
};

export type StandardAlarmCategoryPagination = {
  __typename?: 'StandardAlarmCategoryPagination';
  categories: Array<Maybe<StandardAlarmCategory>>;
  totalCount: Scalars['Int']['output'];
};

export type StandardAlarmCategoryWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A standard alarm: configurable rule for devices. When conditions are met, alerts can be triggered. Condition structure depends on category (e.g. no_file_received uses hours and daysOfWeek). */
export type StandardAlarmData = {
  __typename?: 'StandardAlarmData';
  /** Alarm ID */
  _id: Scalars['String']['output'];
  /** Country ID */
  _id_country: Scalars['String']['output'];
  /** Portfolio ID */
  _id_portfolio: Scalars['String']['output'];
  /** Site ID */
  _id_site: Scalars['String']['output'];
  /** Alarm category (sensor_failure, no_data, low_data_coverage, low_battery, no_file_received) */
  category: StandardAlarmCategory;
  /** Category-specific condition (time/value or hours/daysOfWeek) */
  condition: Condition;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /** Device IDs this alarm applies to */
  deviceIds: Array<Scalars['String']['output']>;
  /** User-facing name */
  displayName: Scalars['String']['output'];
  /** Internal normalized name */
  name: Scalars['String']['output'];
  severity: AlarmSeverityEnum;
  status: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** Result of creating a standard alarm. Returns the new alarm _id. */
export type StandardAlarmDataCreateResult = {
  __typename?: 'StandardAlarmDataCreateResult';
  _id: Scalars['String']['output'];
};

export type StandardAlarmFilterInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _id_country?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _id_portfolio?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _id_site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Array<InputMaybe<AlarmSeverityEnum>>>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input to create a standard alarm. For no_file_received: use exactly one device, condition.hours required, condition.daysOfWeek optional. */
export type StandardAlarmInput = {
  _id_category: Scalars['String']['input'];
  condition: ConditionInput;
  description?: InputMaybe<Scalars['String']['input']>;
  deviceIds: Array<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  severity: AlarmSeverityEnum;
  status: Scalars['Boolean']['input'];
};

/** Paginated list of standard alarms. */
export type StandardAlarmPagination = {
  __typename?: 'StandardAlarmPagination';
  alarms: Array<Maybe<StandardAlarmData>>;
  currentPage: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type StandardSignalSuggestions = {
  __typename?: 'StandardSignalSuggestions';
  standardSignal: Scalars['String']['output'];
  suggestions: Array<SignalSuggestion>;
};

export type StringArrayFilterInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  containsAll?: InputMaybe<Array<Scalars['String']['input']>>;
  containsAny?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StringFilterInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  regex?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestRawSignalsInput = {
  deviceTypeId: Scalars['String']['input'];
  loggerManufacturerId: Scalars['String']['input'];
  loggerModelId: Scalars['String']['input'];
  sensors: Array<SignalMappingSensorInput>;
};

export type Timeseries = {
  __typename?: 'Timeseries';
  sensor: Scalars['ID']['output'];
  signal: Scalars['String']['output'];
  timestamps: Array<Maybe<Scalars['Float']['output']>>;
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type TimeseriesSignalsWhereInput = {
  sensor_id: Scalars['ID']['input'];
  signal: SignalEnum;
};

export type TimeseriesWhereInput = {
  agg?: InputMaybe<Aggregation>;
  endTS: Scalars['Float']['input'];
  granularityMs?: InputMaybe<Scalars['Float']['input']>;
  sensorSignal: Array<InputMaybe<TimeseriesSignalsWhereInput>>;
  startTS: Scalars['Float']['input'];
};

export type Timezone = {
  __typename?: 'Timezone';
  _id: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  offset?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
  timezoneOffset?: Maybe<Scalars['String']['output']>;
};

export type TimezonePagination = {
  __typename?: 'TimezonePagination';
  items: Array<Timezone>;
  totalCount: Scalars['Int']['output'];
};

export type TimezoneWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
};

export type TriggeredAlarm = {
  __typename?: 'TriggeredAlarm';
  Sensors: SensorPagination;
  _id_alarm: Scalars['String']['output'];
  _id_category: Scalars['String']['output'];
  _id_device: Scalars['String']['output'];
  _id_portfolio: Scalars['String']['output'];
  alarmType?: Maybe<TriggeredAlarmTypeEnum>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  insert_time: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  reviewed: Scalars['Boolean']['output'];
  sensorIds: Array<Scalars['String']['output']>;
  severity?: Maybe<TriggeredAlarmSeverityEnum>;
  startTime: Scalars['DateTime']['output'];
  status: Scalars['Boolean']['output'];
};


export type TriggeredAlarmSensorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SensorWhereInput>;
};

export type TriggeredAlarmPagination = {
  __typename?: 'TriggeredAlarmPagination';
  items: Array<TriggeredAlarm>;
  totalCount: Scalars['Int']['output'];
};

export enum TriggeredAlarmSeverityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum TriggeredAlarmTypeEnum {
  CustomAlarm = 'custom_alarm',
  LowBattery = 'low_battery',
  LowDataCoverage = 'low_data_coverage',
  NoData = 'no_data',
  NoFileReceived = 'no_file_received',
  Security = 'security',
  SensorFailure = 'sensor_failure'
}

export type TurbulenceIntensity = {
  __typename?: 'TurbulenceIntensity';
  Datapoints?: Maybe<Array<Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>>>;
  IECClassA?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  IECClassB?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  IECClassC?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  meanPlus128SD?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  meanTI?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedBins?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type TurbulenceIntensityInput = {
  _id_device: Scalars['ID']['input'];
};

export type TurbulenceWdirIntensity = {
  __typename?: 'TurbulenceWDIRIntensity';
  Datapoints?: Maybe<Array<Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>>>;
  meanPlus128SD?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  meanTI?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionBins?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type TurbulenceWdirIntensityInput = {
  _id_device: Scalars['ID']['input'];
};

export type UpdateCustomAlarmCategoryInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomAlarmConditionInput = {
  _id_custom_alarm?: InputMaybe<Scalars['String']['input']>;
  _id_device?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  notify?: InputMaybe<NotifyModeEnum>;
  sensorIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCustomAlarmInput = {
  _id_category?: InputMaybe<Scalars['String']['input']>;
  _id_device?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<AlarmSeverityEnum>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCustomPortfolioInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDeviceInput = {
  Offshore?: InputMaybe<Scalars['Boolean']['input']>;
  Onshore?: InputMaybe<Scalars['Boolean']['input']>;
  _id_deviceType?: InputMaybe<Scalars['String']['input']>;
  _id_dictionary?: InputMaybe<Scalars['String']['input']>;
  _id_manufacturer?: InputMaybe<Scalars['String']['input']>;
  _id_mastType?: InputMaybe<Scalars['String']['input']>;
  _id_model?: InputMaybe<Scalars['String']['input']>;
  averagingPeriod?: InputMaybe<Scalars['Float']['input']>;
  coordinationSystem?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  easting?: InputMaybe<Scalars['Float']['input']>;
  elevation?: InputMaybe<Scalars['Float']['input']>;
  exactHeight?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  installationDate?: InputMaybe<Scalars['DateTime']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  magneticDeclination?: InputMaybe<Scalars['Float']['input']>;
  monitoringDate?: InputMaybe<Scalars['DateTime']['input']>;
  monitoringEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  northing?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  sampleFrequency?: InputMaybe<Scalars['Float']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DeviceStatusEnum>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateExclusionDataInput = {
  _id: Scalars['String']['input'];
  _id_device: Scalars['String']['input'];
  _id_portfolio: Scalars['String']['input'];
  _id_sensor: Scalars['String']['input'];
  _id_sensorType: Scalars['String']['input'];
  _id_site: Scalars['String']['input'];
  /** Unix timestamp in milliseconds (UTC instant). */
  end_ts: Scalars['Float']['input'];
  exclusion_type: ExclusionTypeEnum;
  is_adc?: InputMaybe<Scalars['Boolean']['input']>;
  note: Scalars['String']['input'];
  /** Unix timestamp in milliseconds (UTC instant). */
  start_ts: Scalars['Float']['input'];
};

export type UpdatePortfolioInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProjectAdminTabInput = {
  _id_currency?: InputMaybe<Scalars['String']['input']>;
  _id_device?: InputMaybe<Scalars['String']['input']>;
  invoiceAmount?: InputMaybe<Scalars['Float']['input']>;
  invoiceFrequency?: InputMaybe<InvoiceFrequencyEnum>;
  legalEntity?: InputMaybe<Scalars['String']['input']>;
  projectNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReportInput = {
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<ReportTypeEnum>;
  schedule?: InputMaybe<ReportScheduleUpdateInput>;
};

/** Input to update a standard alarm. All fields are optional. */
export type UpdateStandardAlarmInput = {
  _id_category?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<ConditionInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<AlarmSeverityEnum>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTriggeredAlarmInput = {
  _id_alarm: Scalars['String']['input'];
  _id_category: Scalars['String']['input'];
  _id_device: Scalars['String']['input'];
  _id_portfolio: Scalars['String']['input'];
  alarmType?: InputMaybe<TriggeredAlarmTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  reviewed: Scalars['Boolean']['input'];
  sensorIds: Array<Scalars['String']['input']>;
  severity?: InputMaybe<TriggeredAlarmSeverityEnum>;
  startTime: Scalars['DateTime']['input'];
  status: Scalars['Boolean']['input'];
};

export type UpdateUserInput = {
  attributes?: InputMaybe<Scalars['JSONObject']['input']>;
  availableDeviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  downloadDataEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
};

/** Detailed user information with permissions */
export type UserDetails = {
  __typename?: 'UserDetails';
  accessiblePortfolios?: Maybe<PortfolioAccess>;
  downloadDataEnabled: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  role: UserRole;
  username?: Maybe<Scalars['String']['output']>;
};

/** Filters for managed users query */
export type UserFiltersInput = {
  /** Filter by email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Filter by first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by portfolio IDs (user must have any of these portfolios) */
  portfolioIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by user roles */
  roles?: InputMaybe<Array<UserRole>>;
  /** Filter by username */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Current authenticated user from token */
export type UserInfo = {
  __typename?: 'UserInfo';
  delegatedBy?: Maybe<Scalars['String']['output']>;
  downloadDataEnabled?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  managedBy?: Maybe<Scalars['String']['output']>;
  role: UserRole;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** User permissions and accessible resources */
export type UserPermissions = {
  __typename?: 'UserPermissions';
  /** Custom portfolios visible to the current user. Separate from accessibleResources.Portfolios. */
  accessibleCustomPortfolios: CustomPortfolioPagination;
  accessibleResources: PortfolioAccess;
  /** Paginated light list of users in the viewer managed_by cone */
  managedUsers: ManagedUserPagination;
  userInfo: UserInfo;
};


/** User permissions and accessible resources */
export type UserPermissionsManagedUsersArgs = {
  filters?: InputMaybe<UserFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** User role types */
export enum UserRole {
  Admin = 'ADMIN',
  Analyst = 'ANALYST',
  Client = 'CLIENT',
  Superadmin = 'SUPERADMIN'
}

export type VarType = {
  __typename?: 'VarType';
  _id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type VarTypePagination = {
  __typename?: 'VarTypePagination';
  items: Array<VarType>;
  totalCount: Scalars['Int']['output'];
};

export type VarTypeWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type VerticalWindProfile = {
  __typename?: 'VerticalWindProfile';
  fittedProfile: Array<WindPoint>;
  observedPoints: Array<WindPoint>;
  referenceHeight: Scalars['Float']['output'];
  referenceSpeed: Scalars['Float']['output'];
  shearCoefficient: Scalars['Float']['output'];
};

export type VerticalWindProfileInput = {
  _id_device: Scalars['ID']['input'];
  endTS?: InputMaybe<Scalars['Float']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
};

export type Weather = {
  __typename?: 'Weather';
  icon?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  weather?: Maybe<Scalars['String']['output']>;
  windDirection?: Maybe<Scalars['Float']['output']>;
  windSpeed?: Maybe<Scalars['Float']['output']>;
};

export enum WindDirectionSector {
  All = 'All',
  Deg0 = 'Deg0',
  Deg30 = 'Deg30',
  Deg60 = 'Deg60',
  Deg90 = 'Deg90',
  Deg120 = 'Deg120',
  Deg150 = 'Deg150',
  Deg180 = 'Deg180',
  Deg210 = 'Deg210',
  Deg240 = 'Deg240',
  Deg270 = 'Deg270',
  Deg300 = 'Deg300',
  Deg330 = 'Deg330'
}

export type WindPoint = {
  __typename?: 'WindPoint';
  height: Scalars['Float']['output'];
  windSpeed: Scalars['Float']['output'];
};

export type WindRoses = {
  __typename?: 'WindRoses';
  bins: Array<WindRosesBin>;
  month?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type WindRosesBin = {
  __typename?: 'WindRosesBin';
  bin: Scalars['Int']['output'];
  data: Array<WindRosesBinData>;
};

export type WindRosesBinData = {
  __typename?: 'WindRosesBinData';
  percentage: Scalars['Float']['output'];
  range: WindRosesRange;
};

export enum WindRosesGranularity {
  Month = 'MONTH',
  Overall = 'OVERALL'
}

export enum WindRosesRange {
  Range_0_3 = 'RANGE_0_3',
  Range_3_6 = 'RANGE_3_6',
  Range_6_9 = 'RANGE_6_9',
  RangePlus_9 = 'RANGE_PLUS_9'
}

export type WindRosesWhereInput = {
  anemometer: Scalars['ID']['input'];
  endTS?: InputMaybe<Scalars['Float']['input']>;
  granularity: WindRosesGranularity;
  startTS?: InputMaybe<Scalars['Float']['input']>;
  windVane: Scalars['ID']['input'];
};

export type GetCorrelationDataQueryVariables = Exact<{
  idDevice: Scalars['ID']['input'];
  sensor2Device: Scalars['ID']['input'];
  startDate: Scalars['Float']['input'];
  endDate: Scalars['Float']['input'];
  sensor1: Scalars['ID']['input'];
  sensor2: Scalars['ID']['input'];
  signal1: SignalEnum;
  signal2: SignalEnum;
  lwsCutoffInput?: InputMaybe<ScLwsCutoffInput>;
  dirSectorInput?: InputMaybe<DirSectorInput>;
}>;


export type GetCorrelationDataQuery = { __typename?: 'Query', SensorCorrelation: { __typename?: 'SensorCorrelation', sensor1Values: Array<number | null>, sensor2Values: Array<number | null>, timestamps: Array<number | null>, pearsonCorr?: number | null } };

export type GetDataCoverageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDataCoverageQuery = { __typename?: 'Query', DataCoverage?: Array<{ __typename?: 'DataCoverage', month: number, year: number, data: Array<{ __typename?: 'DataCoverageData', coverage: number, potential_coverage: number, sensor_id: string, sensor_name: string, sensor_type: string, average: { __typename?: 'DataCoverageAverage', signal_name: string, signal_unit: string, value?: number | null } }> } | null> | null };

export type GetDeviceSensorQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDeviceSensorQuery = { __typename?: 'Query', Device: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', Sensors: { __typename?: 'SensorPagination', items: Array<{ __typename?: 'Sensor', startDate?: any | null, serialNumber: string, sensorTypeName?: string | null, sensorModel?: string | null, scale: number, orientation?: number | null, offset: number, name: string, mastDiameterAtInstrument?: number | null, loggerScale?: number | null, loggerOffset?: number | null, length?: number | null, iecCompliant?: string | null, height?: number | null, functioning?: boolean | null, diameter?: number | null, description?: string | null, deadbandOrientation?: number | null, calibrationFacility?: string | null, calibrationDate?: any | null, boomToRotorDistance?: number | null, _id_mountingType?: string | null, _id_sensorType: string, _id_device: string, _id: string, SensorType: { __typename?: 'SensorTypePagination', items: Array<{ __typename?: 'SensorType', displayName?: string | null, _id: string }> } }> } }> } };

export type GetDiurnalVariationQueryVariables = Exact<{
  device_id: Scalars['String']['input'];
  sensors: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
  endTS?: InputMaybe<Scalars['Float']['input']>;
  granularity: DiurnalVariationGranularity;
}>;


export type GetDiurnalVariationQuery = { __typename?: 'Query', DiurnalVariation?: Array<{ __typename?: 'DiurnalVariation', month?: number | null, year?: number | null, signals: Array<{ __typename?: 'DiurnalVariationSignal', sensor: string, values: Array<number | null> } | null> } | null> | null };

export type GetExclusionDataQueryVariables = Exact<{
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  startTs?: InputMaybe<Scalars['Float']['input']>;
  endTs?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  sensorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  exclusion_type?: InputMaybe<Array<InputMaybe<ExclusionTypeEnum>> | InputMaybe<ExclusionTypeEnum>>;
}>;


export type GetExclusionDataQuery = { __typename?: 'Query', Exclusion: { __typename?: 'Exclusion', totalCount: number, exclusions: Array<{ __typename?: 'ExclusionData', _id: string, _id_sensor: string, _id_sensorType: string, end_ts: number, exclusion_type: ExclusionTypeEnum, note: string, start_ts: number, mut_ts: number, Sensor: { __typename?: 'Sensor', name: string } }> } };

export type DeleteExclusionsMutationVariables = Exact<{
  exclusionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteExclusionsMutation = { __typename?: 'Mutation', deleteExclusions?: boolean | null };

export type CreateExclusionsMutationVariables = Exact<{
  data?: InputMaybe<Array<CreateExclusionDataInput> | CreateExclusionDataInput>;
}>;


export type CreateExclusionsMutation = { __typename?: 'Mutation', createExclusions?: { __typename?: 'BulkExclusionResult', success: boolean, insertedCount: number, skippedCount: number, mergedCount: number, warnings: Array<{ __typename?: 'OperationWarning', code: string, message: string, sensorName?: string | null, sensorId?: string | null, startDate?: string | null, endDate?: string | null }>, errors: Array<{ __typename?: 'OperationError', code: string, message: string, rowIndex?: number | null }>, exclusions: Array<{ __typename?: 'ExclusionData', start_ts: number, exclusion_type: ExclusionTypeEnum, end_ts: number, _id_site: string, _id_sensorType: string, _id_sensor: string, _id_portfolio: string, _id_device: string, _id: string, note: string }> } | null };

export type UploadExclusionsMutationVariables = Exact<{
  targetDevice?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['File']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UploadExclusionsMutation = { __typename?: 'Mutation', uploadExclusions?: { __typename?: 'BulkExclusionResult', success: boolean, insertedCount: number, skippedCount: number, mergedCount: number, warnings: Array<{ __typename?: 'OperationWarning', code: string, message: string, sensorName?: string | null, sensorId?: string | null, startDate?: string | null, endDate?: string | null }>, errors: Array<{ __typename?: 'OperationError', code: string, message: string, rowIndex?: number | null }> } | null };

export type GetExclusionSensorsQueryVariables = Exact<{
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetExclusionSensorsQuery = { __typename?: 'Query', Exclusion: { __typename?: 'Exclusion', totalCount: number, sensors: Array<{ __typename?: 'ExclusionSensor', name: string, _id_device: string, _id: string }> } };

export type GetFreqDistributionsQueryVariables = Exact<{
  device_id: Scalars['String']['input'];
  sensor_id: Scalars['ID']['input'];
  startTS?: InputMaybe<Scalars['Float']['input']>;
  endTS?: InputMaybe<Scalars['Float']['input']>;
  granularity: FreqDistributionsGranularity;
}>;


export type GetFreqDistributionsQuery = { __typename?: 'Query', FreqDistributions: Array<{ __typename?: 'FreqDistributions', measuredFrequencies: Array<number>, weibullFrequencies: Array<number>, weibullX: Array<number>, binCenters: Array<number>, month?: number | null, scaleParameter: number, shapeParameter: number, year?: number | null }> };

export type GetInfoDevicesListQueryVariables = Exact<{
  _id_portfolio: Scalars['String']['input'];
}>;


export type GetInfoDevicesListQuery = { __typename?: 'Query', Site: { __typename?: 'SitePagination', items: Array<{ __typename?: 'Site', _id: string, name: string, country?: string | null, Devices: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', _id: string, displayName: string, height?: number | null, exactHeight?: number | null, width?: number | null, timezone: string, status?: DeviceStatusEnum | null, latitude: number, longitude: number, monitoringDate?: any | null, monitoringEndDate?: any | null, DeviceType?: { __typename?: 'DeviceType', displayName?: string | null } | null, Loggers: { __typename?: 'LoggerPagination', items: Array<{ __typename?: 'Logger', timezone: string }> }, Sensors: { __typename?: 'SensorPagination', totalCount: number, items: Array<{ __typename?: 'Sensor', _id: string, name: string, height?: number | null, orientation?: number | null, _id_sensorType: string, startDate?: any | null, deadbandOrientation?: number | null, serialNumber: string, scale: number, loggerOffset?: number | null, loggerScale?: number | null, offset: number, functioning?: boolean | null, iecCompliant?: string | null, sensorModel?: string | null, _id_reference?: string | null }> }, Notes: { __typename?: 'NotePagination', totalCount: number } }> } }> }, SensorType: { __typename?: 'SensorTypePagination', items: Array<{ __typename?: 'SensorType', _id: string, displayName?: string | null }> } };

export type GetDeviceNotesQueryVariables = Exact<{
  _id_reference?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDeviceNotesQuery = { __typename?: 'Query', Note: { __typename?: 'NotePagination', items: Array<{ __typename?: 'Note', _id: string, _id_reference: string, actionDate: any, text: string }> } };

export type GetLongTermWsEnergyQueryVariables = Exact<{
  id_device: Scalars['ID']['input'];
}>;


export type GetLongTermWsEnergyQuery = { __typename?: 'Query', longTermWSEnergy?: { __typename?: 'LongTermWSEnergy', windSpeedMean?: number | null, merra2?: string | null, longTermHubHeightWindSpeed?: number | null, hubHeight?: number | null, hubHeighWindSpeed?: number | null, estimatedGrossEnergy?: number | null, estimatedGrossCapacity?: number | null, defaultShearValue?: number | null, airDensity?: number | null, hubHeighFrequencyDistribution?: Array<number | null> | null, powerCurve?: Array<number | null> | null, windSpeedMeanReferenceMast?: number | null } | null };

export type GetSensorsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSensorsQuery = { __typename?: 'Query', anemometer: { __typename?: 'SensorPagination', items: Array<{ __typename?: 'Sensor', _id: string, name: string }> }, wind_vane: { __typename?: 'SensorPagination', items: Array<{ __typename?: 'Sensor', _id: string, name: string }> } };

export type MastShadowQueryVariables = Exact<{
  _id_device: Scalars['ID']['input'];
  startTS: Scalars['Float']['input'];
  endTS: Scalars['Float']['input'];
  anemometer1: Scalars['ID']['input'];
  anemometer2: Scalars['ID']['input'];
  windVane: Scalars['ID']['input'];
  lwsCutoff?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MastShadowQuery = { __typename?: 'Query', MastShadow: { __typename?: 'MastShadow', ratio: Array<number | null>, wdDir: Array<number | null>, timestamps: Array<number | null> } };

export type GetPortfolioSitesWeatherQueryVariables = Exact<{
  _id_portfolio: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPortfolioSitesWeatherQuery = { __typename?: 'Query', Site: { __typename?: 'SitePagination', totalCount: number, items: Array<{ __typename?: 'Site', name: string, _id: string, country?: string | null, Devices: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', Weather?: { __typename?: 'Weather', icon?: string | null, temperature?: number | null, weather?: string | null, windDirection?: number | null, windSpeed?: number | null } | null }> } }> } };

export type GetCountrySitesWeatherQueryVariables = Exact<{
  _id_portfolio: Scalars['String']['input'];
  _id_country: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCountrySitesWeatherQuery = { __typename?: 'Query', Site: { __typename?: 'SitePagination', totalCount: number, items: Array<{ __typename?: 'Site', name: string, _id: string, country?: string | null, Devices: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', Weather?: { __typename?: 'Weather', icon?: string | null, temperature?: number | null, weather?: string | null, windDirection?: number | null, windSpeed?: number | null } | null }> } }> } };

export type GetDeviceWeatherQueryVariables = Exact<{
  _id: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDeviceWeatherQuery = { __typename?: 'Query', Site: { __typename?: 'SitePagination', totalCount: number, items: Array<{ __typename?: 'Site', _id: string, Devices: { __typename?: 'DevicePagination', totalCount: number, items: Array<{ __typename?: 'Device', name: string, displayName: string, _id: string, Weather?: { __typename?: 'Weather', icon?: string | null, temperature?: number | null, weather?: string | null, windDirection?: number | null, windSpeed?: number | null } | null }> } }> } };

export type GetPortfolioStandardAlarmsQueryVariables = Exact<{
  _id_portfolio: Scalars['String']['input'];
}>;


export type GetPortfolioStandardAlarmsQuery = { __typename?: 'Query', Device: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', displayName: string, TriggeredAlarms: { __typename?: 'TriggeredAlarmPagination', items: Array<{ __typename?: 'TriggeredAlarm', _id_alarm: string, _id_category: string, _id_device: string, alarmType?: TriggeredAlarmTypeEnum | null, description?: string | null, severity?: TriggeredAlarmSeverityEnum | null, startTime: any, reviewed: boolean, Sensors: { __typename?: 'SensorPagination', totalCount: number } }> } }> }, CustomAlarmCategory: { __typename?: 'CustomAlarmCategoryPagination', items: Array<{ __typename?: 'CustomAlarmCategory', _id: string, color: string, displayName: string }> }, StandardAlarmCategory: { __typename?: 'StandardAlarmCategoryPagination', categories: Array<{ __typename?: 'StandardAlarmCategory', _id: string, color: string, displayName: string } | null> } };

export type GetCountryStandardAlarmsQueryVariables = Exact<{
  _id_country: Scalars['String']['input'];
}>;


export type GetCountryStandardAlarmsQuery = { __typename?: 'Query', Device: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', displayName: string, TriggeredAlarms: { __typename?: 'TriggeredAlarmPagination', items: Array<{ __typename?: 'TriggeredAlarm', _id_alarm: string, _id_category: string, _id_device: string, alarmType?: TriggeredAlarmTypeEnum | null, description?: string | null, severity?: TriggeredAlarmSeverityEnum | null, startTime: any, reviewed: boolean, Sensors: { __typename?: 'SensorPagination', totalCount: number } }> } }> }, CustomAlarmCategory: { __typename?: 'CustomAlarmCategoryPagination', items: Array<{ __typename?: 'CustomAlarmCategory', _id: string, color: string, displayName: string }> }, StandardAlarmCategory: { __typename?: 'StandardAlarmCategoryPagination', categories: Array<{ __typename?: 'StandardAlarmCategory', _id: string, color: string, displayName: string } | null> } };

export type GetSiteStandardAlarmsQueryVariables = Exact<{
  _id_site: Scalars['String']['input'];
}>;


export type GetSiteStandardAlarmsQuery = { __typename?: 'Query', Device: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', displayName: string, TriggeredAlarms: { __typename?: 'TriggeredAlarmPagination', items: Array<{ __typename?: 'TriggeredAlarm', _id_alarm: string, _id_category: string, _id_device: string, alarmType?: TriggeredAlarmTypeEnum | null, description?: string | null, severity?: TriggeredAlarmSeverityEnum | null, startTime: any, reviewed: boolean, Sensors: { __typename?: 'SensorPagination', totalCount: number } }> } }> }, CustomAlarmCategory: { __typename?: 'CustomAlarmCategoryPagination', items: Array<{ __typename?: 'CustomAlarmCategory', _id: string, color: string, displayName: string }> }, StandardAlarmCategory: { __typename?: 'StandardAlarmCategoryPagination', categories: Array<{ __typename?: 'StandardAlarmCategory', _id: string, color: string, displayName: string } | null> } };

export type GetDeviceTriggeredAlarmsQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type GetDeviceTriggeredAlarmsQuery = { __typename?: 'Query', Device: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', TriggeredAlarms: { __typename?: 'TriggeredAlarmPagination', items: Array<{ __typename?: 'TriggeredAlarm', _id_alarm: string, _id_device: string, _id_category: string, _id_portfolio: string, alarmType?: TriggeredAlarmTypeEnum | null, description?: string | null, severity?: TriggeredAlarmSeverityEnum | null, startTime: any, endTime?: any | null, duration?: number | null, sensorIds: Array<string>, name: string, reviewed: boolean, status: boolean, Sensors: { __typename?: 'SensorPagination', totalCount: number, items: Array<{ __typename?: 'Sensor', _id: string, name: string }> } }> } }> }, CustomAlarmCategory: { __typename?: 'CustomAlarmCategoryPagination', items: Array<{ __typename?: 'CustomAlarmCategory', _id: string, color: string, displayName: string }> }, StandardAlarmCategory: { __typename?: 'StandardAlarmCategoryPagination', categories: Array<{ __typename?: 'StandardAlarmCategory', _id: string, color: string, displayName: string } | null> } };

export type UpdateTriggeredAlarmMutationVariables = Exact<{
  _id_alarm: Scalars['String']['input'];
  _id_device: Scalars['String']['input'];
  _id_category: Scalars['String']['input'];
  _id_portfolio: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
  sensorIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
  reviewed: Scalars['Boolean']['input'];
  alarmType?: InputMaybe<TriggeredAlarmTypeEnum>;
  severity?: InputMaybe<TriggeredAlarmSeverityEnum>;
}>;


export type UpdateTriggeredAlarmMutation = { __typename?: 'Mutation', updateTriggeredAlarm?: { __typename?: 'TriggeredAlarm', name: string } | null };

export type GetSiteCoverageQueryVariables = Exact<{
  device_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  yearFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSiteCoverageQuery = { __typename?: 'Query', SiteCoverage?: Array<{ __typename?: 'SiteCoverage', device_id: string, displayName?: string | null, coverages: Array<{ __typename?: 'SiteCoverageData', year: number, month: number, data: Array<{ __typename?: 'DataCoverageData', sensor_id: string, sensor_type: string, sensor_name: string, coverage: number, average: { __typename?: 'DataCoverageAverage', signal_name: string, signal_unit: string, value?: number | null } }> }> } | null> | null };

export type GetServiceCasesQueryVariables = Exact<{
  _id_device?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetServiceCasesQuery = { __typename?: 'Query', serviceCases: { __typename?: 'ServiceCasePagination', items: Array<{ __typename?: 'ServiceCase', _id: string, _id_country: string, _id_device?: string | null, _id_portfolio?: string | null, _id_site: string, createdAt: any, description?: string | null, note?: Array<string> | null, priority?: ServiceCasePriority | null, status: string, updatedAt: any }> } };

export type GetAllCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCountriesQuery = { __typename?: 'Query', Country: { __typename?: 'CountryPagination', items: Array<{ __typename?: 'Country', _id: string, name: string }> } };

export type GetAllSitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSitesQuery = { __typename?: 'Query', Site: { __typename?: 'SitePagination', items: Array<{ __typename?: 'Site', _id: string, name: string }> } };

export type GetVerticalWindProfileQueryVariables = Exact<{
  _id_device: Scalars['ID']['input'];
}>;


export type GetVerticalWindProfileQuery = { __typename?: 'Query', verticalWindProfile?: { __typename?: 'VerticalWindProfile', referenceHeight: number, referenceSpeed: number, shearCoefficient: number, fittedProfile: Array<{ __typename?: 'WindPoint', height: number, windSpeed: number }>, observedPoints: Array<{ __typename?: 'WindPoint', height: number, windSpeed: number }> } | null };

export type GetDirectionalWindShearVariationQueryVariables = Exact<{
  _id_device: Scalars['ID']['input'];
}>;


export type GetDirectionalWindShearVariationQuery = { __typename?: 'Query', getDirectionalWindShearVariation?: { __typename?: 'DirectionalWindShearVariation', n: Array<number | null>, shearAlpha: Array<number | null>, directionSector: Array<number | null>, frequencyPct: Array<number | null> } | null };

export type GetDiurnalWindShearVariationQueryVariables = Exact<{
  _id_device: Scalars['ID']['input'];
}>;


export type GetDiurnalWindShearVariationQuery = { __typename?: 'Query', getDiurnalWindShearVariation?: { __typename?: 'DiurnalWindShearVariation', hour: Array<number | null>, shearMin: Array<number | null>, shearAvg: Array<number | null>, shearMax: Array<number | null> } | null };

export type GetSeasonalWindShearVariationQueryVariables = Exact<{
  _id_device: Scalars['ID']['input'];
  years?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type GetSeasonalWindShearVariationQuery = { __typename?: 'Query', getSeasonalWindShearVariation: Array<{ __typename?: 'SeasonalWindShearVariation', hour: number, january?: number | null, february?: number | null, march?: number | null, april?: number | null, may?: number | null, june?: number | null, july?: number | null, august?: number | null, september?: number | null, october?: number | null, november?: number | null, december?: number | null, totals?: number | null }> };

export type GetFirstAndLastDataDatesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetFirstAndLastDataDatesQuery = { __typename?: 'Query', Device: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', lastMonitoringDate?: any | null, monitoringDate: any }> } };

export type GetSensorsByTypeQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSensorsByTypeQuery = { __typename?: 'Query', Sensor: { __typename?: 'SensorPagination', items: Array<{ __typename?: 'Sensor', _id: string, _id_device: string, name: string, sensorTypeName?: string | null, _id_sensorType: string, Signals: { __typename?: 'SignalPagination', items: Array<{ __typename?: 'Signal', _id: string, name: string, unit: string }> } }> } };

export type GetScatterMastShadowDataQueryVariables = Exact<{
  idDevice: Scalars['ID']['input'];
  startDate: Scalars['Float']['input'];
  endDate: Scalars['Float']['input'];
  anemometer1: Scalars['ID']['input'];
  anemometer2: Scalars['ID']['input'];
  windVane: Scalars['ID']['input'];
  cutOff?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetScatterMastShadowDataQuery = { __typename?: 'Query', MastShadow: { __typename?: 'MastShadow', ratio: Array<number | null>, timestamps: Array<number | null>, wdDir: Array<number | null> } };

export type GetScatterCorrelationDataQueryVariables = Exact<{
  idDevice: Scalars['ID']['input'];
  startDate: Scalars['Float']['input'];
  endDate: Scalars['Float']['input'];
  sensor1: Scalars['ID']['input'];
  sensor2: Scalars['ID']['input'];
  sensor3: Scalars['ID']['input'];
  cutOff: Scalars['Float']['input'];
  signal: SignalEnum;
}>;


export type GetScatterCorrelationDataQuery = { __typename?: 'Query', SensorCorrelation: { __typename?: 'SensorCorrelation', sensor1Values: Array<number | null>, sensor2Values: Array<number | null>, timestamps: Array<number | null> } };

export type GetTimeseriesDataQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
  startTS: Scalars['Float']['input'];
  endTS: Scalars['Float']['input'];
  timeseriesSignals: Array<InputMaybe<TimeseriesSignalsWhereInput>> | InputMaybe<TimeseriesSignalsWhereInput>;
}>;


export type GetTimeseriesDataQuery = { __typename?: 'Query', Timeseries: Array<{ __typename?: 'Timeseries', signal: string, sensor: string, values?: Array<number | null> | null, timestamps: Array<number | null> }> };

export type GetTurbulenceIntensityQueryVariables = Exact<{
  _id_device: Scalars['ID']['input'];
}>;


export type GetTurbulenceIntensityQuery = { __typename?: 'Query', getTurbulenceIntensity: Array<{ __typename?: 'TurbulenceIntensity', windSpeedBins?: Array<number | null> | null, meanTI?: Array<number | null> | null, meanPlus128SD?: Array<number | null> | null, IECClassA?: Array<number | null> | null, IECClassB?: Array<number | null> | null, IECClassC?: Array<number | null> | null, Datapoints?: Array<Array<Array<number | null> | null> | null> | null }> };

export type GetTurbulenceWdirIntensityQueryVariables = Exact<{
  _id_device: Scalars['ID']['input'];
}>;


export type GetTurbulenceWdirIntensityQuery = { __typename?: 'Query', getTurbulenceWDIRIntensity: Array<{ __typename?: 'TurbulenceWDIRIntensity', windDirectionBins?: Array<number | null> | null, meanTI?: Array<number | null> | null, meanPlus128SD?: Array<number | null> | null, Datapoints?: Array<Array<Array<number | null> | null> | null> | null }> };

export type GetCheckPeriodsQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type GetCheckPeriodsQuery = { __typename?: 'Query', GetCheckPeriod: { __typename?: 'CheckPeriodPagination', items: Array<{ __typename?: 'CheckPeriod', _id: string, _id_device: string, createdAt: any, updatedAt: any, createdBy: string, from: any, to: any, updatedBy: string, checked: boolean, auto: boolean }> } };

export type DeleteCheckPeriodMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type DeleteCheckPeriodMutation = { __typename?: 'Mutation', deleteCheckPeriod: { __typename?: 'CheckPeriodPagination', items: Array<{ __typename?: 'CheckPeriod', _id: string, _id_device: string, from: any, to: any, checked: boolean, createdBy: string }> } };

export type GetWindRosesQueryVariables = Exact<{
  device_id: Scalars['String']['input'];
  anemometer: Scalars['ID']['input'];
  windVane: Scalars['ID']['input'];
  startTS?: InputMaybe<Scalars['Float']['input']>;
  endTS?: InputMaybe<Scalars['Float']['input']>;
  granularity: WindRosesGranularity;
}>;


export type GetWindRosesQuery = { __typename?: 'Query', WindRoses: Array<{ __typename?: 'WindRoses', month?: number | null, year?: number | null, bins: Array<{ __typename?: 'WindRosesBin', bin: number, data: Array<{ __typename?: 'WindRosesBinData', percentage: number, range: WindRosesRange }> }> }> };

export type GetImagesQueryVariables = Exact<{
  scope?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetImagesQuery = { __typename?: 'Query', Images: { __typename?: 'ImagePagination', items: Array<{ __typename?: 'Image', _id: string, createdBy: string, description?: string | null, name: string, originalName: string, fileExtension: string, scope?: string | null, size: number, username: string }> } };

export type GetReportSensorsInfoQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type GetReportSensorsInfoQuery = { __typename?: 'Query', Sensor: { __typename?: 'SensorPagination', items: Array<{ __typename?: 'Sensor', _id: string, _id_reference?: string | null, sensorTypeName?: string | null, name: string, height?: number | null, orientation?: number | null, sensorModel?: string | null, startDate?: any | null, deadbandOrientation?: number | null, serialNumber: string, scale: number, offset: number, loggerScale?: number | null, loggerOffset?: number | null }> } };

export type GetReportDeviceInfoQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type GetReportDeviceInfoQuery = { __typename?: 'Query', Device: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', Onshore?: boolean | null, installationDate: any, monitoringDate?: any | null, status?: DeviceStatusEnum | null, serialNumber?: string | null, magneticDeclination?: number | null, latitude: number, longitude: number, width?: number | null, height?: number | null, elevation?: number | null, exactHeight?: number | null, Timezone?: { __typename?: 'Timezone', displayName?: string | null } | null, DeviceManufacturer?: { __typename?: 'DeviceManufacturer', name: string } | null, DeviceModel?: { __typename?: 'DeviceModel', name: string } | null, MastType?: { __typename?: 'MastType', displayName?: string | null } | null }> } };

export type GetTemplatesQueryVariables = Exact<{
  _id_portfolio: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReportOrderByInput>;
}>;


export type GetTemplatesQuery = { __typename?: 'Query', Reports: { __typename?: 'ReportsConnection', total: number, data: Array<{ __typename?: 'Report', _id: string, _id_deviceType: string, _id_portfolio: string, createdBy: string, creatorName?: string | null, createdAt: any, deviceIds: Array<string>, displayName: string, name: string, report?: string | null, reportType: ReportTypeEnum, siteIds: Array<string>, updatedAt: any, updatedBy: string, schedule: { __typename?: 'ReportSchedule', weekDays?: Array<boolean | null> | null, schedule: string, logoName?: string | null, logo?: string | null, hour?: Array<boolean | null> | null, level?: string | null, header?: string | null, footer?: string | null, firstDays?: Array<boolean | null> | null, emailList?: Array<string | null> | null, autoUpdate: boolean, dateRange: { __typename?: 'DateRange', endDate: number, startDate: number } } }> } };

export type GetReportsQueryVariables = Exact<{
  _id_portfolio: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReportOrderByInput>;
}>;


export type GetReportsQuery = { __typename?: 'Query', Reports: { __typename?: 'ReportsConnection', total: number, data: Array<{ __typename?: 'Report', _id: string, _id_deviceType: string, _id_portfolio: string, createdBy: string, creatorName?: string | null, createdAt: any, deviceIds: Array<string>, displayName: string, name: string, report?: string | null, reportType: ReportTypeEnum, siteIds: Array<string>, updatedAt: any, updatedBy: string, schedule: { __typename?: 'ReportSchedule', weekDays?: Array<boolean | null> | null, schedule: string, logoName?: string | null, logo?: string | null, hour?: Array<boolean | null> | null, level?: string | null, header?: string | null, footer?: string | null, firstDays?: Array<boolean | null> | null, emailList?: Array<string | null> | null, autoUpdate: boolean, dateRange: { __typename?: 'DateRange', endDate: number, startDate: number } } }> } };

export type GetReportQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetReportQuery = { __typename?: 'Query', Reports: { __typename?: 'ReportsConnection', data: Array<{ __typename?: 'Report', _id: string, _id_deviceType: string, createdBy: string, createdAt: any, deviceIds: Array<string>, creatorName?: string | null, displayName: string, name: string, report?: string | null, reportType: ReportTypeEnum, _id_portfolio: string, siteIds: Array<string>, updatedAt: any, updatedBy: string, schedule: { __typename?: 'ReportSchedule', autoUpdate: boolean, emailList?: Array<string | null> | null, firstDays?: Array<boolean | null> | null, footer?: string | null, header?: string | null, level?: string | null, hour?: Array<boolean | null> | null, logo?: string | null, logoName?: string | null, schedule: string, weekDays?: Array<boolean | null> | null, dateRange: { __typename?: 'DateRange', endDate: number, startDate: number } } }> } };

export type CreateReportMutationVariables = Exact<{
  input: CreateReportInput;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport: { __typename?: 'Report', _id_deviceType: string, _id: string, _id_portfolio: string, createdAt: any, createdBy: string, creatorName?: string | null, displayName: string, deviceIds: Array<string>, report?: string | null, name: string, reportType: ReportTypeEnum, siteIds: Array<string>, updatedAt: any, updatedBy: string, schedule: { __typename?: 'ReportSchedule', autoUpdate: boolean, emailList?: Array<string | null> | null, firstDays?: Array<boolean | null> | null, footer?: string | null, header?: string | null, hour?: Array<boolean | null> | null, level?: string | null, logo?: string | null, logoName?: string | null, schedule: string, weekDays?: Array<boolean | null> | null, dateRange: { __typename?: 'DateRange', endDate: number, startDate: number } } } };

export type DeleteReportMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteReportMutation = { __typename?: 'Mutation', deleteReport: boolean };

export type UpdateReportMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateReportInput;
}>;


export type UpdateReportMutation = { __typename?: 'Mutation', updateReport: { __typename?: 'Report', _id_deviceType: string, _id: string, _id_portfolio: string, createdAt: any, createdBy: string, creatorName?: string | null, displayName: string, deviceIds: Array<string>, report?: string | null, name: string, reportType: ReportTypeEnum, siteIds: Array<string>, updatedAt: any, updatedBy: string, schedule: { __typename?: 'ReportSchedule', autoUpdate: boolean, emailList?: Array<string | null> | null, firstDays?: Array<boolean | null> | null, footer?: string | null, header?: string | null, hour?: Array<boolean | null> | null, level?: string | null, logo?: string | null, logoName?: string | null, schedule: string, weekDays?: Array<boolean | null> | null, dateRange: { __typename?: 'DateRange', endDate: number, startDate: number } } } };

export type SendReportNowMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  emailList: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type SendReportNowMutation = { __typename?: 'Mutation', sendReportNow: boolean };

export type GetAllTemplatesCreatorAndTypesQueryVariables = Exact<{
  _id_portfolio: Scalars['String']['input'];
}>;


export type GetAllTemplatesCreatorAndTypesQuery = { __typename?: 'Query', Reports: { __typename?: 'ReportsConnection', data: Array<{ __typename?: 'Report', _id_deviceType: string, creatorName?: string | null, createdBy: string }> } };

export type GetAllReportDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllReportDevicesQuery = { __typename?: 'Query', Device: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', _id: string, displayName: string }> } };

export type GetDeviceTimezoneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDeviceTimezoneQuery = { __typename?: 'Query', Device: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', Timezone?: { __typename?: 'Timezone', timezoneOffset?: string | null } | null }> } };

export type GetStandardAlarmsQueryVariables = Exact<{
  _id_portfolio?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  _id_site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  _id_country?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  _id_category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetStandardAlarmsQuery = { __typename?: 'Query', StandardAlarm: { __typename?: 'StandardAlarmPagination', alarms: Array<{ __typename?: 'StandardAlarmData', _id: string, _id_country: string, _id_portfolio: string, _id_site: string, createdAt: string, description?: string | null, deviceIds: Array<string>, displayName: string, name: string, severity: AlarmSeverityEnum, updatedAt: string, active: boolean, category: { __typename?: 'StandardAlarmCategory', _id: string, color: string, displayName: string, name: string }, condition: { __typename?: 'Condition', time?: number | null, value?: number | null } } | null> }, Site: { __typename?: 'SitePagination', items: Array<{ __typename?: 'Site', name: string, _id: string }> }, Device: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', _id: string, displayName: string }> } };

export type GetStandardCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStandardCategoriesQuery = { __typename?: 'Query', StandardAlarmCategory: { __typename?: 'StandardAlarmCategoryPagination', categories: Array<{ __typename?: 'StandardAlarmCategory', _id: string, color: string, displayName: string, name: string, description?: string | null } | null> } };

export type CreateStandardAlarmMutationVariables = Exact<{
  deviceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  _id_category: Scalars['String']['input'];
  condition: ConditionInput;
  severity: AlarmSeverityEnum;
  status: Scalars['Boolean']['input'];
}>;


export type CreateStandardAlarmMutation = { __typename?: 'Mutation', createStandardAlarm: { __typename?: 'StandardAlarmDataCreateResult', _id: string } };

export type UpdateStandardAlarmMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  deviceIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  _id_category?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<ConditionInput>;
  severity?: InputMaybe<AlarmSeverityEnum>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateStandardAlarmMutation = { __typename?: 'Mutation', updateStandardAlarm?: boolean | null };

export type DeleteStandardAlarmMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type DeleteStandardAlarmMutation = { __typename?: 'Mutation', deleteStandardAlarm?: boolean | null };

export type DeleteStandardAlarmsMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteStandardAlarmsMutation = { __typename?: 'Mutation', deleteStandardAlarms: boolean };

export type CreateCustomAlarmMutationVariables = Exact<{
  _id_device: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  _id_category: Scalars['String']['input'];
  severity: AlarmSeverityEnum;
  status: Scalars['Boolean']['input'];
}>;


export type CreateCustomAlarmMutation = { __typename?: 'Mutation', createCustomAlarm: { __typename?: 'CustomAlarm', _id: string } };

export type CreateCustomAlarmConditionMutationVariables = Exact<{
  _id_custom_alarm: Scalars['String']['input'];
  condition: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  sensorIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  notify: NotifyModeEnum;
}>;


export type CreateCustomAlarmConditionMutation = { __typename?: 'Mutation', createCustomAlarmCondition: { __typename?: 'CustomAlarmCondition', _id: string } };

export type GetCustomAlarmCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomAlarmCategoriesQuery = { __typename?: 'Query', CustomAlarmCategory: { __typename?: 'CustomAlarmCategoryPagination', items: Array<{ __typename?: 'CustomAlarmCategory', _id: string, color: string, displayName: string, name: string }> } };

export type CreateCustomAlarmCategoryMutationVariables = Exact<{
  color: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
}>;


export type CreateCustomAlarmCategoryMutation = { __typename?: 'Mutation', createCustomAlarmCategory: { __typename?: 'CustomAlarmCategory', _id: string, color: string, name: string, displayName: string } };

export type DeleteCustomAlarmCategoryMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  reassignToCategoryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteCustomAlarmCategoryMutation = { __typename?: 'Mutation', deleteCustomAlarmCategory: boolean };

export type UpdateCustomAlarmCategoryMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  color: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
}>;


export type UpdateCustomAlarmCategoryMutation = { __typename?: 'Mutation', updateCustomAlarmCategory?: { __typename?: 'CustomAlarmCategory', _id: string } | null };

export type GetCustomAlarmsQueryVariables = Exact<{
  _id_portfolio?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  _id_site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  _id_country?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  _id_category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetCustomAlarmsQuery = { __typename?: 'Query', CustomAlarm: { __typename?: 'CustomAlarmPagination', items: Array<{ __typename?: 'CustomAlarm', _id: string, _id_category: string, _id_device: string, _id_portfolio: string, _id_country?: string | null, _id_site: string, createdAt: string, description?: string | null, displayName: string, name: string, severity: AlarmSeverityEnum, updatedAt: string, active: boolean }> }, Site: { __typename?: 'SitePagination', items: Array<{ __typename?: 'Site', name: string, _id: string }> }, Device: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', _id: string, displayName: string }> }, CustomAlarmCategory: { __typename?: 'CustomAlarmCategoryPagination', items: Array<{ __typename?: 'CustomAlarmCategory', _id: string, color: string, displayName: string }> } };

export type GetDeviceCustomAlarmsIdsQueryVariables = Exact<{
  _id_device: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type GetDeviceCustomAlarmsIdsQuery = { __typename?: 'Query', CustomAlarm: { __typename?: 'CustomAlarmPagination', items: Array<{ __typename?: 'CustomAlarm', _id: string }> } };

export type GetCustomAlarmsByCategoryQueryVariables = Exact<{
  _id_category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetCustomAlarmsByCategoryQuery = { __typename?: 'Query', CustomAlarm: { __typename?: 'CustomAlarmPagination', totalCount: number } };

export type DeleteCustomAlarmMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type DeleteCustomAlarmMutation = { __typename?: 'Mutation', deleteCustomAlarm: boolean };

export type DeleteCustomAlarmsMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteCustomAlarmsMutation = { __typename?: 'Mutation', deleteCustomAlarms: boolean };

export type GetCustomAlarmConditionQueryVariables = Exact<{
  _id_custom_alarm: Scalars['String']['input'];
}>;


export type GetCustomAlarmConditionQuery = { __typename?: 'Query', CustomAlarmCondition: { __typename?: 'CustomAlarmConditionPagination', items: Array<{ __typename?: 'CustomAlarmCondition', _id: string, _id_custom_alarm: string, condition: string, count: number, sensorIds: Array<string> }> } };

export type UpdateCustomAlarmMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  _id_device?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  _id_category?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<AlarmSeverityEnum>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateCustomAlarmMutation = { __typename?: 'Mutation', updateCustomAlarm?: { __typename?: 'CustomAlarm', _id: string } | null };

export type UpdateCustomAlarmConditionMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  _id_custom_alarm: Scalars['String']['input'];
  condition: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  sensorIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  notify: NotifyModeEnum;
}>;


export type UpdateCustomAlarmConditionMutation = { __typename?: 'Mutation', updateCustomAlarmCondition?: { __typename?: 'CustomAlarmCondition', _id: string } | null };

export type GetCalcSettingQueryVariables = Exact<{
  _id_device: Scalars['String']['input'];
}>;


export type GetCalcSettingQuery = { __typename?: 'Query', CalcSetting: { __typename?: 'CalcSettingPagination', items: Array<{ __typename?: 'CalcSetting', _id: string, _id_device: string, _id_mainAnemometer?: string | null, _id_mainWindVane?: string | null, _id_mainPyranometer?: string | null, _id_mainThermometer?: string | null, _id_mainRainSensor?: string | null, longTermAnalisis: boolean, shearAnemometers?: Array<string | null> | null, statisticSensors?: Array<string | null> | null, thermometers?: Array<string | null> | null, ampmeters?: Array<string | null> | null }> } };

export type CreateCalcSettingMutationVariables = Exact<{
  _id_device: Scalars['String']['input'];
  _id_mainAnemometer?: InputMaybe<Scalars['String']['input']>;
  _id_mainWindVane?: InputMaybe<Scalars['String']['input']>;
  _id_mainPyranometer?: InputMaybe<Scalars['String']['input']>;
  _id_mainThermometer?: InputMaybe<Scalars['String']['input']>;
  _id_mainRainSensor?: InputMaybe<Scalars['String']['input']>;
  longTermAnalisis: Scalars['Boolean']['input'];
  shearAnemometers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  statisticSensors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  thermometers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  ampmeters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateCalcSettingMutation = { __typename?: 'Mutation', createCalcSetting?: { __typename?: 'CalcSetting', _id: string, _id_device: string, _id_mainAnemometer?: string | null, _id_mainWindVane?: string | null, _id_mainPyranometer?: string | null, _id_mainThermometer?: string | null, _id_mainRainSensor?: string | null, longTermAnalisis: boolean, shearAnemometers?: Array<string | null> | null, statisticSensors?: Array<string | null> | null, thermometers?: Array<string | null> | null, ampmeters?: Array<string | null> | null } | null };

export type UpdateCalcSettingMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  _id_device?: InputMaybe<Scalars['String']['input']>;
  _id_mainAnemometer?: InputMaybe<Scalars['String']['input']>;
  _id_mainWindVane?: InputMaybe<Scalars['String']['input']>;
  _id_mainPyranometer?: InputMaybe<Scalars['String']['input']>;
  _id_mainThermometer?: InputMaybe<Scalars['String']['input']>;
  _id_mainRainSensor?: InputMaybe<Scalars['String']['input']>;
  longTermAnalisis?: InputMaybe<Scalars['Boolean']['input']>;
  shearAnemometers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  statisticSensors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  thermometers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  ampmeters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UpdateCalcSettingMutation = { __typename?: 'Mutation', updateCalcSetting?: { __typename?: 'CalcSetting', _id: string, _id_device: string, _id_mainAnemometer?: string | null, _id_mainWindVane?: string | null, _id_mainPyranometer?: string | null, _id_mainThermometer?: string | null, _id_mainRainSensor?: string | null, longTermAnalisis: boolean, shearAnemometers?: Array<string | null> | null, statisticSensors?: Array<string | null> | null, thermometers?: Array<string | null> | null, ampmeters?: Array<string | null> | null } | null };

export type CreatePowerCurveSettingMutationVariables = Exact<{
  _id_calc_settings: Scalars['String']['input'];
  _id_device: Scalars['String']['input'];
  _id_reference_mast?: InputMaybe<Scalars['String']['input']>;
  hubHeight: Scalars['Float']['input'];
  overrideShearAlpha: Scalars['Boolean']['input'];
  powercurve: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
  powerCurveAirDensity: Scalars['Float']['input'];
  ratedPower: Scalars['Float']['input'];
  siteAirDensity: Scalars['Float']['input'];
  templateName: Scalars['String']['input'];
  shearValue?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CreatePowerCurveSettingMutation = { __typename?: 'Mutation', createPowerCurveSetting?: { __typename?: 'PowerCurveSetting', _id: string, _id_calc_settings: string, _id_device: string, _id_reference_mast?: string | null, hubHeight: number, overrideShearAlpha: boolean, powerCurveAirDensity: number, powercurve: Array<number>, ratedPower: number, siteAirDensity: number, templateName: string } | null };

export type UpdatePowerCurveSettingMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  _id_calc_settings?: InputMaybe<Scalars['String']['input']>;
  _id_device?: InputMaybe<Scalars['String']['input']>;
  _id_reference_mast?: InputMaybe<Scalars['String']['input']>;
  hubHeight?: InputMaybe<Scalars['Float']['input']>;
  overrideShearAlpha?: InputMaybe<Scalars['Boolean']['input']>;
  powercurve?: InputMaybe<Array<Scalars['Float']['input']> | Scalars['Float']['input']>;
  powerCurveAirDensity?: InputMaybe<Scalars['Float']['input']>;
  ratedPower?: InputMaybe<Scalars['Float']['input']>;
  siteAirDensity?: InputMaybe<Scalars['Float']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
  shearValue?: InputMaybe<Scalars['Float']['input']>;
}>;


export type UpdatePowerCurveSettingMutation = { __typename?: 'Mutation', updatePowerCurveSetting?: { __typename?: 'PowerCurveSetting', _id: string, _id_calc_settings: string, _id_device: string, hubHeight: number, overrideShearAlpha: boolean, powerCurveAirDensity: number, powercurve: Array<number>, ratedPower: number, siteAirDensity: number, templateName: string, shearValue?: number | null } | null };

export type PowerCurveSettingQueryVariables = Exact<{
  _id_device: Scalars['String']['input'];
}>;


export type PowerCurveSettingQuery = { __typename?: 'Query', PowerCurveSetting: { __typename?: 'PowerCurveSettingPagination', items: Array<{ __typename?: 'PowerCurveSetting', _id: string, _id_calc_settings: string, _id_device: string, _id_reference_mast?: string | null, hubHeight: number, overrideShearAlpha: boolean, powerCurveAirDensity: number, powercurve: Array<number>, ratedPower: number, siteAirDensity: number, templateName: string, shearValue?: number | null }> } };

export type ParsePowerCurveDataFileMutationVariables = Exact<{
  file: Scalars['File']['input'];
}>;


export type ParsePowerCurveDataFileMutation = { __typename?: 'Mutation', parsePowerCurveDataFile: Array<{ __typename?: 'PowerCurvePreview', hubHeight: number, powerCurveAirDensity: number, powercurve: Array<number>, ratedPower: number, siteAirDensity: number, templateName: string }> };

export type DeletePowerCurveSettingMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type DeletePowerCurveSettingMutation = { __typename?: 'Mutation', deletePowerCurveSetting?: { __typename?: 'PowerCurveSetting', _id: string, _id_calc_settings: string, _id_device: string, hubHeight: number, overrideShearAlpha: boolean, powerCurveAirDensity: number, powercurve: Array<number>, ratedPower: number, siteAirDensity: number, templateName: string } | null };

export type GetDocumentsQueryVariables = Exact<{
  _id_device: Array<Scalars['String']['input']> | Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDocumentsQuery = { __typename?: 'Query', Document: { __typename?: 'DocumentPagination', totalCount: number, items: Array<{ __typename?: 'Document', _id: string, _id_device: string, name: string, storagePath: string, note?: string | null }> } };

export type GetAllDocumentsQueryVariables = Exact<{
  _id_device: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetAllDocumentsQuery = { __typename?: 'Query', Document: { __typename?: 'DocumentPagination', items: Array<{ __typename?: 'Document', _id: string, _id_device: string, name: string, storagePath: string, note?: string | null }> } };

export type GetDocumentsCountQueryVariables = Exact<{
  _id_device: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetDocumentsCountQuery = { __typename?: 'Query', Document: { __typename?: 'DocumentPagination', totalCount: number } };

export type GetRawDataQueryVariables = Exact<{
  _id_device: Array<Scalars['String']['input']> | Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRawDataQuery = { __typename?: 'Query', RawFile: { __typename?: 'RawFilePagination', totalCount: number, items: Array<{ __typename?: 'RawFile', _id: string, filename: string, received_at: any, bucket_path: string, size?: number | null }> } };

export type GetRawDataCountQueryVariables = Exact<{
  _id_device: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetRawDataCountQuery = { __typename?: 'Query', RawFile: { __typename?: 'RawFilePagination', totalCount: number } };

export type CreateDocumentMutationVariables = Exact<{
  _id_device: Scalars['String']['input'];
  name: Scalars['String']['input'];
  storagePath: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateDocumentMutation = { __typename?: 'Mutation', createDocument: Array<{ __typename?: 'Document', _id: string, _id_device: string, name: string, storagePath: string, note?: string | null }> };

export type DeleteDocumentMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument?: { __typename?: 'Document', _id: string, _id_device: string, name: string, storagePath: string } | null };

export type UpdateDocumentMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  note: Scalars['String']['input'];
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument: { __typename?: 'Document', _id: string, _id_device: string, name: string, storagePath: string, note?: string | null } };

export type GetLoggerManufacturerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoggerManufacturerQuery = { __typename?: 'Query', LoggerManufacturer: { __typename?: 'LoggerManufacturerPagination', items: Array<{ __typename?: 'LoggerManufacturer', _id: string, name: string }> } };

export type GetLoggerModelQueryVariables = Exact<{
  id_manufacturer?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLoggerModelQuery = { __typename?: 'Query', LoggerModel: { __typename?: 'LoggerModelPagination', items: Array<{ __typename?: 'LoggerModel', _id: string, name: string }> } };

export type CreateLoggerMutationVariables = Exact<{
  newLogger: Array<LoggerInput> | LoggerInput;
}>;


export type CreateLoggerMutation = { __typename?: 'Mutation', createLogger: Array<{ __typename?: 'Logger', _id: string, _id_device: string, _id_manufacturer: string, _id_model: string, enabled: boolean, averagingPeriod: number, sampleFrequency: number, matchedFilenameFormat: string, installationDate: any, serialNumber: string, timezone: string }> };

export type CreateDictionaryMutationVariables = Exact<{
  newDictionary: Array<DictionaryInput> | DictionaryInput;
}>;


export type CreateDictionaryMutation = { __typename?: 'Mutation', createDictionary: Array<{ __typename?: 'Dictionary', _id: string, _id_device: string, _id_logger: string, def: Array<{ __typename?: 'DictionaryDef', _id: string, _id_signal: string, _id_sensor: string, sensorName: string, signalName: string, rawSignalName?: string | null }> }> };

export type UpsertLoggerMutationVariables = Exact<{
  upsertLogger: Array<LoggerUpsertInput> | LoggerUpsertInput;
}>;


export type UpsertLoggerMutation = { __typename?: 'Mutation', upsertLogger: Array<{ __typename?: 'Logger', _id: string, _id_device: string, _id_manufacturer: string, _id_model: string, enabled: boolean, averagingPeriod: number, sampleFrequency: number, matchedFilenameFormat: string, installationDate: any, serialNumber: string, timezone: string, Dictionary: { __typename?: 'DictionaryPagination', items: Array<{ __typename?: 'Dictionary', _id: string, _id_device: string, _id_logger: string, def: Array<{ __typename?: 'DictionaryDef', _id: string, _id_sensor: string, _id_signal: string, rawSignalName?: string | null, sensorName: string, signalName: string }> }> } }> };

export type UpsertDictionaryMutationVariables = Exact<{
  upsertDictionary: Array<DictionaryUpsertInput> | DictionaryUpsertInput;
}>;


export type UpsertDictionaryMutation = { __typename?: 'Mutation', upsertDictionary: Array<{ __typename?: 'Dictionary', _id: string, _id_device: string, _id_logger: string, def: Array<{ __typename?: 'DictionaryDef', _id: string, _id_signal: string, _id_sensor: string, sensorName: string, signalName: string, rawSignalName?: string | null }> } | null> };

export type DeleteLoggerMutationVariables = Exact<{
  idLogger: Scalars['String']['input'];
}>;


export type DeleteLoggerMutation = { __typename?: 'Mutation', deleteLogger?: { __typename?: 'Logger', _id: string } | null };

export type DeleteDictionaryMutationVariables = Exact<{
  idDictionary: Scalars['String']['input'];
}>;


export type DeleteDictionaryMutation = { __typename?: 'Mutation', deleteDictionary?: { __typename?: 'Dictionary', _id: string } | null };

export type ParseSensorFileMutationVariables = Exact<{
  idDevice: Scalars['String']['input'];
  file: Scalars['File']['input'];
}>;


export type ParseSensorFileMutation = { __typename?: 'Mutation', parseSensorFile: Array<{ __typename?: 'Sensor', _id: string, _id_device: string, _id_sensorType: string, _id_mountingType?: string | null, boomToRotorDistance?: number | null, calibrationDate?: any | null, calibrationFacility?: string | null, deadbandOrientation?: number | null, description?: string | null, diameter?: number | null, serialNumber: string, startDate?: any | null, sensorModel?: string | null, scale: number, orientation?: number | null, offset: number, name: string, mastDiameterAtInstrument?: number | null, loggerScale?: number | null, loggerOffset?: number | null, length?: number | null, iecCompliant?: string | null, height?: number | null, functioning?: boolean | null }> };

export type GetSensorTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSensorTypeQuery = { __typename?: 'Query', SensorType: { __typename?: 'SensorTypePagination', items: Array<{ __typename?: 'SensorType', _id: string, category?: string | null, description?: string | null, name?: string | null, unit?: string | null, displayName?: string | null }> } };

export type CreateSensorsBatchMutationVariables = Exact<{
  data: Array<SensorInput> | SensorInput;
}>;


export type CreateSensorsBatchMutation = { __typename?: 'Mutation', createSensorsBatch: Array<{ __typename?: 'Sensor', _id: string, _id_device: string, _id_sensorType: string, _id_mountingType?: string | null, _id_reference?: string | null, boomToRotorDistance?: number | null, sensorTypeName?: string | null, calibrationDate?: any | null, calibrationFacility?: string | null, deadbandOrientation?: number | null, description?: string | null, diameter?: number | null, serialNumber: string, startDate?: any | null, sensorModel?: string | null, scale: number, orientation?: number | null, offset: number, name: string, mastDiameterAtInstrument?: number | null, loggerScale?: number | null, loggerOffset?: number | null, length?: number | null, iecCompliant?: string | null, height?: number | null, functioning?: boolean | null, Signals: { __typename?: 'SignalPagination', items: Array<{ __typename?: 'Signal', _id: string, _id_subType: string, _id_sensorType: string, _id_varType: string, name: string, description: string, unit: string }> } } | null> };

export type GetMountingTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMountingTypeQuery = { __typename?: 'Query', MountingType: { __typename?: 'MountingTypePagination', items: Array<{ __typename?: 'MountingType', _id: string, displayName: string, name: string }> } };

export type DeleteSensorMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type DeleteSensorMutation = { __typename?: 'Mutation', deleteSensor?: { __typename?: 'Sensor', _id: string, _id_device: string, _id_sensorType: string, _id_mountingType?: string | null, boomToRotorDistance?: number | null, sensorTypeName?: string | null, calibrationDate?: any | null, calibrationFacility?: string | null, deadbandOrientation?: number | null, description?: string | null, diameter?: number | null, serialNumber: string, startDate?: any | null, sensorModel?: string | null, scale: number, orientation?: number | null, offset: number, name: string, mastDiameterAtInstrument?: number | null, loggerScale?: number | null, loggerOffset?: number | null, length?: number | null, iecCompliant?: string | null, height?: number | null, functioning?: boolean | null, Signals: { __typename?: 'SignalPagination', items: Array<{ __typename?: 'Signal', _id: string, _id_subType: string, _id_sensorType: string, _id_varType: string, name: string, description: string, unit: string }> } } | null };

export type UpdateSensorMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  _id_device?: InputMaybe<Scalars['String']['input']>;
  _id_mountingType?: InputMaybe<Scalars['String']['input']>;
  _id_sensorType?: InputMaybe<Scalars['String']['input']>;
  boomToRotorDistance?: InputMaybe<Scalars['Float']['input']>;
  calibrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  calibrationFacility?: InputMaybe<Scalars['String']['input']>;
  deadbandOrientation?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  diameter?: InputMaybe<Scalars['Float']['input']>;
  functioning?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  iecCompliant?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  loggerOffset?: InputMaybe<Scalars['Float']['input']>;
  loggerScale?: InputMaybe<Scalars['Float']['input']>;
  mastDiameterAtInstrument?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  orientation?: InputMaybe<Scalars['Float']['input']>;
  scale?: InputMaybe<Scalars['Float']['input']>;
  sensorModel?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UpdateSensorMutation = { __typename?: 'Mutation', updateSensor?: { __typename?: 'Sensor', _id: string, _id_device: string, _id_sensorType: string, _id_mountingType?: string | null, boomToRotorDistance?: number | null, sensorTypeName?: string | null, calibrationDate?: any | null, calibrationFacility?: string | null, deadbandOrientation?: number | null, description?: string | null, diameter?: number | null, serialNumber: string, startDate?: any | null, sensorModel?: string | null, scale: number, orientation?: number | null, offset: number, name: string, mastDiameterAtInstrument?: number | null, loggerScale?: number | null, loggerOffset?: number | null, length?: number | null, iecCompliant?: string | null, height?: number | null, functioning?: boolean | null, Signals: { __typename?: 'SignalPagination', items: Array<{ __typename?: 'Signal', _id: string, _id_subType: string, _id_sensorType: string, _id_varType: string, name: string, description: string, unit: string }> } } | null };

export type GetNavigationDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNavigationDataQuery = { __typename?: 'Query', Portfolio: { __typename?: 'PortfolioPagination', items: Array<{ __typename?: 'Portfolio', _id: string, displayName: string, Sites: { __typename?: 'SitePagination', items: Array<{ __typename?: 'Site', _id: string, _id_country: string, _id_portfolio: string, _id_region?: string | null, name: string, country?: string | null, regionName?: string | null, Devices: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', _id: string, _id_deviceType?: string | null, _id_site: string, name: string, displayName: string, lat: number, lon: number, DeviceType?: { __typename?: 'DeviceType', displayName?: string | null } | null, Timezone?: { __typename?: 'Timezone', timezoneOffset?: string | null } | null }> } }> } }> } };

export type GetPortfolioQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type GetPortfolioQuery = { __typename?: 'Query', Portfolio: { __typename?: 'PortfolioPagination', items: Array<{ __typename?: 'Portfolio', _id: string, displayName: string, Sites: { __typename?: 'SitePagination', totalCount: number, items: Array<{ __typename?: 'Site', _id: string, _id_country: string, country?: string | null, _id_portfolio: string, _id_region?: string | null, regionName?: string | null, boundary?: any | null, name: string, Devices: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', _id: string, _id_deviceType?: string | null, name: string, displayName: string, ReferenceStation?: { __typename?: 'Device', displayName: string, name: string, _id: string, _id_deviceType?: string | null } | null }> } }> } }> } };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'Query', Country: { __typename?: 'CountryPagination', items: Array<{ __typename?: 'Country', name: string, code: string, _id: string }> } };

export type CreatePortfolioMutationVariables = Exact<{
  displayName: Scalars['String']['input'];
}>;


export type CreatePortfolioMutation = { __typename?: 'Mutation', createPortfolio: { __typename?: 'Portfolio', _id: string, displayName: string } };

export type DeletePortfolioMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeletePortfolioMutation = { __typename?: 'Mutation', deletePortfolio?: { __typename?: 'Portfolio', _id: string, displayName: string } | null };

export type CreateSiteMutationVariables = Exact<{
  id_country: Scalars['String']['input'];
  id_portfolio: Scalars['String']['input'];
  name: Scalars['String']['input'];
  boundary: Scalars['String']['input'];
  _id_region?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSiteMutation = { __typename?: 'Mutation', createSite: { __typename?: 'Site', _id_country: string, _id_portfolio: string, _id_region?: string | null, name: string } };

export type DeleteSiteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteSiteMutation = { __typename?: 'Mutation', deleteSite?: { __typename?: 'Site', _id: string, _id_country: string, _id_portfolio: string, name: string } | null };

export type GetDeviceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDeviceTypesQuery = { __typename?: 'Query', DeviceType: { __typename?: 'DeviceTypePagination', items: Array<{ __typename?: 'DeviceType', _id: string, name: string }> } };

export type UpdateSiteMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSiteMutation = { __typename?: 'Mutation', updateSite?: { __typename?: 'Site', _id: string, _id_country: string, _id_portfolio: string, boundary?: any | null, name: string } | null };

export type GetMastTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMastTypeQuery = { __typename?: 'Query', MastType: { __typename?: 'MastTypePagination', items: Array<{ __typename?: 'MastType', _id: string, name?: string | null }> } };

export type GetDeviceManufacturerAndModelQueryVariables = Exact<{
  id_deviceType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDeviceManufacturerAndModelQuery = { __typename?: 'Query', DeviceManufacturer: { __typename?: 'DeviceManufacturerPagination', items: Array<{ __typename?: 'DeviceManufacturer', _id: string, name: string, DeviceModels: { __typename?: 'DeviceModelPagination', items: Array<{ __typename?: 'DeviceModel', _id: string, name: string }> } }> } };

export type CreateDeviceMutationVariables = Exact<{
  _id_deviceType: Scalars['String']['input'];
  _id_site: Scalars['String']['input'];
  _id_manufacturer: Scalars['String']['input'];
  _id_model: Scalars['String']['input'];
  _id_mastType?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  installationDate: Scalars['DateTime']['input'];
  monitoringDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeviceStatusEnum>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  magneticDeclination?: InputMaybe<Scalars['Float']['input']>;
  Onshore?: InputMaybe<Scalars['Boolean']['input']>;
  Offshore?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  exactHeight?: InputMaybe<Scalars['Float']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  elevation?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  easting?: InputMaybe<Scalars['Float']['input']>;
  northing?: InputMaybe<Scalars['Float']['input']>;
  coordinationSystem?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
}>;


export type CreateDeviceMutation = { __typename?: 'Mutation', createDevice: { __typename?: 'Device', Offshore?: boolean | null, Onshore?: boolean | null, _id: string, _id_deviceType?: string | null, _id_manufacturer: string, _id_mastType?: string | null, _id_model: string, _id_site: string, coordinationSystem?: string | null, easting?: number | null, exactHeight?: number | null, elevation?: number | null, height?: number | null, installationDate: any, latitude: number, longitude: number, magneticDeclination?: number | null, status?: DeviceStatusEnum | null, monitoringDate?: any | null, name: string, displayName: string, northing?: number | null, serialNumber?: string | null, timezone: string, width?: number | null, Notes: { __typename?: 'NotePagination', items: Array<{ __typename?: 'Note', _id: string, _id_reference: string, referenceType: string, text: string, actionDate: any }> }, Timezone?: { __typename?: 'Timezone', timezoneOffset?: string | null } | null, Sensors: { __typename?: 'SensorPagination', items: Array<{ __typename?: 'Sensor', _id: string, _id_device: string, _id_sensorType: string, _id_mountingType?: string | null, _id_reference?: string | null, boomToRotorDistance?: number | null, sensorTypeName?: string | null, calibrationDate?: any | null, calibrationFacility?: string | null, deadbandOrientation?: number | null, description?: string | null, diameter?: number | null, serialNumber: string, startDate?: any | null, sensorModel?: string | null, scale: number, orientation?: number | null, offset: number, name: string, mastDiameterAtInstrument?: number | null, loggerScale?: number | null, loggerOffset?: number | null, length?: number | null, iecCompliant?: string | null, height?: number | null, functioning?: boolean | null, Signals: { __typename?: 'SignalPagination', items: Array<{ __typename?: 'Signal', _id: string, _id_subType: string, _id_sensorType: string, _id_varType: string, name: string, description: string, unit: string }> } }> }, Loggers: { __typename?: 'LoggerPagination', items: Array<{ __typename?: 'Logger', _id: string, _id_device: string, _id_manufacturer: string, _id_model: string, enabled: boolean, averagingPeriod: number, sampleFrequency: number, matchedFilenameFormat: string, installationDate: any, serialNumber: string, timezone: string, Dictionary: { __typename?: 'DictionaryPagination', items: Array<{ __typename?: 'Dictionary', _id: string, _id_device: string, _id_logger: string, def: Array<{ __typename?: 'DictionaryDef', _id: string, _id_signal: string, _id_sensor: string, sensorName: string, signalName: string, rawSignalName?: string | null }> }> } }> } } };

export type UpdateDeviceMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  _id_deviceType?: InputMaybe<Scalars['String']['input']>;
  _id_manufacturer?: InputMaybe<Scalars['String']['input']>;
  _id_model?: InputMaybe<Scalars['String']['input']>;
  _id_mastType?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  installationDate?: InputMaybe<Scalars['DateTime']['input']>;
  monitoringDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeviceStatusEnum>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  magneticDeclination?: InputMaybe<Scalars['Float']['input']>;
  Onshore?: InputMaybe<Scalars['Boolean']['input']>;
  Offshore?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  exactHeight?: InputMaybe<Scalars['Float']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  elevation?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  easting?: InputMaybe<Scalars['Float']['input']>;
  northing?: InputMaybe<Scalars['Float']['input']>;
  coordinationSystem?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDeviceMutation = { __typename?: 'Mutation', updateDevice?: { __typename?: 'Device', _id: string } | null };

export type DeleteDeviceMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type DeleteDeviceMutation = { __typename?: 'Mutation', deleteDevice?: { __typename?: 'Device', _id: string } | null };

export type GetTimezoneQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimezoneQuery = { __typename?: 'Query', Timezone: { __typename?: 'TimezonePagination', items: Array<{ __typename?: 'Timezone', timezone: string, displayName?: string | null, timezoneOffset?: string | null }> } };

export type UpdatePortfolioMutationVariables = Exact<{
  id: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
}>;


export type UpdatePortfolioMutation = { __typename?: 'Mutation', updatePortfolio?: { __typename?: 'Portfolio', _id: string, displayName: string } | null };

export type GetNotesQueryVariables = Exact<{
  _id_reference?: InputMaybe<Scalars['String']['input']>;
  referenceType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetNotesQuery = { __typename?: 'Query', Note: { __typename?: 'NotePagination', items: Array<{ __typename?: 'Note', _id: string, _id_reference: string, actionDate: any, referenceType: string, text: string }> } };

export type CreateNoteMutationVariables = Exact<{
  _id_reference: Scalars['String']['input'];
  referenceType: Scalars['String']['input'];
  text: Scalars['String']['input'];
  actionDate: Scalars['DateTime']['input'];
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote: { __typename?: 'Note', _id: string, _id_reference: string, actionDate: any, referenceType: string, text: string } };

export type DeleteNoteMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type DeleteNoteMutation = { __typename?: 'Mutation', deleteNote?: { __typename?: 'Note', _id: string, _id_reference: string, actionDate: any, referenceType: string, text: string } | null };

export type UpdateNoteMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  _id_reference?: InputMaybe<Scalars['String']['input']>;
  referenceType?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  actionDate: Scalars['DateTime']['input'];
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote?: { __typename?: 'Note', _id: string, _id_reference: string, actionDate: any, referenceType: string, text: string } | null };

export type GetPortfolioListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPortfolioListQuery = { __typename?: 'Query', Portfolio: { __typename?: 'PortfolioPagination', totalCount: number, items: Array<{ __typename?: 'Portfolio', displayName: string, _id: string, Sites: { __typename?: 'SitePagination', totalCount: number, items: Array<{ __typename?: 'Site', name: string, country?: string | null, _id_country: string, _id: string, Devices: { __typename?: 'DevicePagination', totalCount: number } }> } }> } };

export type GetDeviceQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type GetDeviceQuery = { __typename?: 'Query', Device: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', Offshore?: boolean | null, Onshore?: boolean | null, _id: string, _id_deviceType?: string | null, _id_manufacturer: string, _id_mastType?: string | null, _id_model: string, _id_site: string, coordinationSystem?: string | null, easting?: number | null, exactHeight?: number | null, elevation?: number | null, height?: number | null, installationDate: any, latitude: number, longitude: number, magneticDeclination?: number | null, status?: DeviceStatusEnum | null, monitoringDate?: any | null, name: string, displayName: string, northing?: number | null, serialNumber?: string | null, timezone: string, width?: number | null, Notes: { __typename?: 'NotePagination', items: Array<{ __typename?: 'Note', _id: string, _id_reference: string, referenceType: string, text: string, actionDate: any }> }, Sensors: { __typename?: 'SensorPagination', items: Array<{ __typename?: 'Sensor', _id: string, _id_device: string, _id_sensorType: string, _id_mountingType?: string | null, _id_reference?: string | null, boomToRotorDistance?: number | null, sensorTypeName?: string | null, calibrationDate?: any | null, calibrationFacility?: string | null, deadbandOrientation?: number | null, description?: string | null, diameter?: number | null, serialNumber: string, startDate?: any | null, sensorModel?: string | null, scale: number, orientation?: number | null, offset: number, name: string, mastDiameterAtInstrument?: number | null, loggerScale?: number | null, loggerOffset?: number | null, length?: number | null, iecCompliant?: string | null, height?: number | null, functioning?: boolean | null, Signals: { __typename?: 'SignalPagination', items: Array<{ __typename?: 'Signal', _id: string, _id_subType: string, _id_sensorType: string, _id_varType: string, name: string, description: string, unit: string }> } }> }, Loggers: { __typename?: 'LoggerPagination', items: Array<{ __typename?: 'Logger', _id: string, _id_device: string, _id_manufacturer: string, _id_model: string, enabled: boolean, averagingPeriod: number, sampleFrequency: number, matchedFilenameFormat: string, installationDate: any, serialNumber: string, timezone: string, Dictionary: { __typename?: 'DictionaryPagination', items: Array<{ __typename?: 'Dictionary', _id: string, _id_device: string, _id_logger: string, def: Array<{ __typename?: 'DictionaryDef', _id: string, _id_signal: string, _id_sensor: string, sensorName: string, signalName: string, rawSignalName?: string | null }> }> } }> } }> } };

export type GetPortfolioByNameQueryVariables = Exact<{
  displayName: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPortfolioByNameQuery = { __typename?: 'Query', Portfolio: { __typename?: 'PortfolioPagination', totalCount: number, items: Array<{ __typename?: 'Portfolio', _id: string, displayName: string, Sites: { __typename?: 'SitePagination', totalCount: number, items: Array<{ __typename?: 'Site', _id: string, _id_country: string, country?: string | null, _id_portfolio: string, boundary?: any | null, name: string, Devices: { __typename?: 'DevicePagination', totalCount: number } }> } }> } };

export type GetSiteQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSiteQuery = { __typename?: 'Query', Site: { __typename?: 'SitePagination', items: Array<{ __typename?: 'Site', _id: string, country?: string | null, name: string, Devices: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', displayName: string, ReferenceStation?: { __typename?: 'Device', displayName: string } | null }> } }> } };

export type CreateDeviceManufacturerMutationVariables = Exact<{
  _id_deviceType: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateDeviceManufacturerMutation = { __typename?: 'Mutation', createDeviceManufacturer: { __typename?: 'DeviceManufacturer', _id: string, name: string } };

export type CreateDeviceModelMutationVariables = Exact<{
  _id_manufacturer: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateDeviceModelMutation = { __typename?: 'Mutation', createDeviceModel: { __typename?: 'DeviceModel', _id: string, name: string } };

export type CreateLoggerManufacturerMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateLoggerManufacturerMutation = { __typename?: 'Mutation', createLoggerManufacturer: { __typename?: 'LoggerManufacturer', _id: string, name: string } };

export type CreateLoggerModelMutationVariables = Exact<{
  _id_manufacturer: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateLoggerModelMutation = { __typename?: 'Mutation', createLoggerModel: { __typename?: 'LoggerModel', _id: string, name: string } };

export type GetDeviceInfoQueryVariables = Exact<{
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  deviceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetDeviceInfoQuery = { __typename?: 'Query', Reports: { __typename?: 'ReportsConnection', total: number }, CustomAlarm: { __typename?: 'CustomAlarmPagination', totalCount: number }, StandardAlarm: { __typename?: 'StandardAlarmPagination', totalCount: number } };

export type GetCountryRegionsQueryVariables = Exact<{
  _id_country: Scalars['String']['input'];
}>;


export type GetCountryRegionsQuery = { __typename?: 'Query', Region: { __typename?: 'RegionPagination', items: Array<{ __typename?: 'Region', _id: string, code: string, description?: string | null, name: string }> } };

export type CreateProjectAdminTabMutationVariables = Exact<{
  _id_device: Scalars['String']['input'];
  _id_currency: Scalars['String']['input'];
  projectNumber: Scalars['String']['input'];
  invoiceFrequency: InvoiceFrequencyEnum;
  invoiceAmount: Scalars['Float']['input'];
  legalEntity: Scalars['String']['input'];
}>;


export type CreateProjectAdminTabMutation = { __typename?: 'Mutation', createProjectAdminTab?: { __typename?: 'ProjectAdminTab', _id: string, projectNumber: string, invoiceAmount: number, legalEntity: string, invoiceFrequency: InvoiceFrequencyEnum, createdAt: any } | null };

export type UpdateProjectAdminTabMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  _id_device?: InputMaybe<Scalars['String']['input']>;
  _id_currency?: InputMaybe<Scalars['String']['input']>;
  projectNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceFrequency?: InputMaybe<InvoiceFrequencyEnum>;
  invoiceAmount?: InputMaybe<Scalars['Float']['input']>;
  legalEntity?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProjectAdminTabMutation = { __typename?: 'Mutation', updateProjectAdminTab?: { __typename?: 'ProjectAdminTab', _id: string, projectNumber: string, invoiceAmount: number, legalEntity: string, invoiceFrequency: InvoiceFrequencyEnum, updatedAt: any } | null };

export type GetProjectAdminTabQueryVariables = Exact<{
  _id_device: Scalars['String']['input'];
}>;


export type GetProjectAdminTabQuery = { __typename?: 'Query', projectAdminTabs: { __typename?: 'ProjectAdminTabPagination', items: Array<{ __typename?: 'ProjectAdminTab', _id: string, _id_currency: string, _id_device: string, invoiceAmount: number, invoiceFrequency: InvoiceFrequencyEnum, legalEntity: string, projectNumber: string }> } };

export type GetCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrenciesQuery = { __typename?: 'Query', Currency: { __typename?: 'CurrencyPagination', items: Array<{ __typename?: 'Currency', name: string, symbol: string, country: string, code: string, _id: string }> } };

export type CreateDeviceReferenceMutationVariables = Exact<{
  _id_device: Scalars['String']['input'];
}>;


export type CreateDeviceReferenceMutation = { __typename?: 'Mutation', createDeviceReference: { __typename?: 'Device', _id: string, _id_deviceType?: string | null, name: string, displayName: string } };

export type GetDeviceReferenceQueryVariables = Exact<{
  _id_reference: Scalars['String']['input'];
}>;


export type GetDeviceReferenceQuery = { __typename?: 'Query', Device: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', displayName: string, name: string, _id: string }> } };

export type GetSecurityPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSecurityPreferencesQuery = { __typename?: 'Query', securityPreferences: { __typename?: 'SecurityPreferences', twoFAEnabled: boolean } };

export type SendTwoFaSetupEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type SendTwoFaSetupEmailMutation = { __typename?: 'Mutation', sendTwoFASetupEmail: boolean };

export type RemoveTwoFaMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveTwoFaMutation = { __typename?: 'Mutation', removeTwoFA: boolean };

export type SendResetPasswordEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type SendResetPasswordEmailMutation = { __typename?: 'Mutation', sendResetPasswordEmail: boolean };

export type GetMainSensorsQueryVariables = Exact<{
  _id_device: Scalars['String']['input'];
}>;


export type GetMainSensorsQuery = { __typename?: 'Query', CalcSetting: { __typename?: 'CalcSettingPagination', items: Array<{ __typename?: 'CalcSetting', _id_mainAnemometer?: string | null, _id_mainWindVane?: string | null, _id_mainPyranometer?: string | null, _id_mainThermometer?: string | null, _id_mainRainSensor?: string | null, _id_device: string, shearAnemometers?: Array<string | null> | null, thermometers?: Array<string | null> | null, ampmeters?: Array<string | null> | null }> } };

export type GetAllDeviceSensorsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAllDeviceSensorsQuery = { __typename?: 'Query', Sensor: { __typename?: 'SensorPagination', items: Array<{ __typename?: 'Sensor', _id: string, name: string, sensorTypeName?: string | null, Signals: { __typename?: 'SignalPagination', items: Array<{ __typename?: 'Signal', name: string, unit: string }> } }> } };

export type GetUserPermissionsWithFiltersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<UserFiltersInput>;
}>;


export type GetUserPermissionsWithFiltersQuery = { __typename?: 'Query', userPermissions: { __typename?: 'UserPermissions', userInfo: { __typename?: 'UserInfo', id: string, username?: string | null, role: UserRole }, accessibleResources: { __typename?: 'PortfolioAccess', Portfolios?: { __typename?: 'PortfolioPagination', items: Array<{ __typename?: 'Portfolio', _id: string, displayName: string }> } | null }, managedUsers: { __typename?: 'ManagedUserPagination', totalCount: number, items: Array<{ __typename?: 'ManagedUserSummary', id: string, username?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, role: UserRole, downloadDataEnabled: boolean, portfolioIds: Array<string> }> } } };

export type PortfolioTreeFragment = { __typename?: 'PortfolioAccess', Portfolios?: { __typename?: 'PortfolioPagination', items: Array<{ __typename?: 'Portfolio', _id: string, displayName: string, Sites: { __typename?: 'SitePagination', items: Array<{ __typename?: 'Site', _id: string, name: string, Devices: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', _id: string, displayName: string }> } }> } }> } | null };

export type GetAccessibleResourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccessibleResourcesQuery = { __typename?: 'Query', userPermissions: { __typename?: 'UserPermissions', accessibleResources: { __typename?: 'PortfolioAccess', Portfolios?: { __typename?: 'PortfolioPagination', items: Array<{ __typename?: 'Portfolio', _id: string, displayName: string, Sites: { __typename?: 'SitePagination', items: Array<{ __typename?: 'Site', _id: string, name: string, Devices: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', _id: string, displayName: string }> } }> } }> } | null } } };

export type GetManagedUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetManagedUserQuery = { __typename?: 'Query', userPermissions: { __typename?: 'UserPermissions', accessibleResources: { __typename?: 'PortfolioAccess', Portfolios?: { __typename?: 'PortfolioPagination', items: Array<{ __typename?: 'Portfolio', _id: string, displayName: string, Sites: { __typename?: 'SitePagination', items: Array<{ __typename?: 'Site', _id: string, name: string, Devices: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', _id: string, displayName: string }> } }> } }> } | null } }, managedUser: { __typename?: 'UserDetails', id: string, username?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, role: UserRole, downloadDataEnabled: boolean, accessiblePortfolios?: { __typename?: 'PortfolioAccess', Portfolios?: { __typename?: 'PortfolioPagination', items: Array<{ __typename?: 'Portfolio', _id: string, displayName: string, Sites: { __typename?: 'SitePagination', items: Array<{ __typename?: 'Site', _id: string, name: string, Devices: { __typename?: 'DevicePagination', items: Array<{ __typename?: 'Device', _id: string, displayName: string }> } }> } }> } | null } | null } };

export type CreateUserMutationVariables = Exact<{
  username: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  downloadDataEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  availableDeviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: string };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  downloadDataEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  availableDeviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: string };

export type DeleteUsersMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteUsersMutation = { __typename?: 'Mutation', deleteUsers: boolean };

export const PortfolioTreeFragmentDoc = gql`
    fragment PortfolioTree on PortfolioAccess {
  Portfolios {
    items {
      _id
      displayName
      Sites {
        items {
          _id
          name
          Devices {
            items {
              _id
              displayName
            }
          }
        }
      }
    }
  }
}
    `;
export const GetCorrelationDataDocument = gql`
    query getCorrelationData($idDevice: ID!, $sensor2Device: ID!, $startDate: Float!, $endDate: Float!, $sensor1: ID!, $sensor2: ID!, $signal1: SignalEnum!, $signal2: SignalEnum!, $lwsCutoffInput: SCLwsCutoffInput, $dirSectorInput: DirSectorInput) {
  SensorCorrelation(
    device_id: $idDevice
    where: {sensor1: {id: $sensor1, signal: $signal1}, sensor2: {id: $sensor2, signal: $signal2, device_id: $sensor2Device}, startTS: $startDate, endTS: $endDate, lwsCutoff: $lwsCutoffInput, dirSector: $dirSectorInput}
  ) {
    sensor1Values
    sensor2Values
    timestamps
    pearsonCorr
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCorrelationDataGQL extends Apollo.Query<GetCorrelationDataQuery, GetCorrelationDataQueryVariables> {
    document = GetCorrelationDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDataCoverageDocument = gql`
    query getDataCoverage($id: ID!) {
  DataCoverage(device_id: $id) {
    month
    year
    data {
      average {
        signal_name
        signal_unit
        value
      }
      coverage
      potential_coverage
      sensor_id
      sensor_name
      sensor_type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDataCoverageGQL extends Apollo.Query<GetDataCoverageQuery, GetDataCoverageQueryVariables> {
    document = GetDataCoverageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceSensorDocument = gql`
    query getDeviceSensor($id: String!) {
  Device(where: {_id: $id}) {
    items {
      Sensors(where: {is_hide_sensors_references: true, _id_device: $id}) {
        items {
          startDate
          serialNumber
          sensorTypeName
          sensorModel
          scale
          orientation
          offset
          name
          mastDiameterAtInstrument
          loggerScale
          loggerOffset
          length
          iecCompliant
          height
          functioning
          diameter
          description
          deadbandOrientation
          calibrationFacility
          calibrationDate
          boomToRotorDistance
          _id_mountingType
          _id_sensorType
          _id_device
          _id
          SensorType {
            items {
              displayName
              _id
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceSensorGQL extends Apollo.Query<GetDeviceSensorQuery, GetDeviceSensorQueryVariables> {
    document = GetDeviceSensorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDiurnalVariationDocument = gql`
    query getDiurnalVariation($device_id: String!, $sensors: [ID]!, $startTS: Float, $endTS: Float, $granularity: DiurnalVariationGranularity!) {
  DiurnalVariation(
    device_id: $device_id
    where: {granularity: $granularity, endTS: $endTS, startTS: $startTS, sensors: $sensors}
  ) {
    signals {
      sensor
      values
    }
    month
    year
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDiurnalVariationGQL extends Apollo.Query<GetDiurnalVariationQuery, GetDiurnalVariationQueryVariables> {
    document = GetDiurnalVariationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExclusionDataDocument = gql`
    query getExclusionData($deviceIds: [String], $startTs: Float, $endTs: Float, $pageSize: Int, $pageNumber: Int, $sensorIds: [String], $exclusion_type: [ExclusionTypeEnum]) {
  Exclusion(
    where: {deviceIds: $deviceIds, startTs: $startTs, endTs: $endTs, sensorIds: $sensorIds, exclusion_type: $exclusion_type}
    pageSize: $pageSize
    pageNumber: $pageNumber
  ) {
    exclusions {
      _id
      _id_sensor
      _id_sensorType
      end_ts
      exclusion_type
      note
      start_ts
      mut_ts
      Sensor {
        name
      }
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExclusionDataGQL extends Apollo.Query<GetExclusionDataQuery, GetExclusionDataQueryVariables> {
    document = GetExclusionDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteExclusionsDocument = gql`
    mutation deleteExclusions($exclusionIds: [String!]) {
  deleteExclusions(exclusionIds: $exclusionIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteExclusionsGQL extends Apollo.Mutation<DeleteExclusionsMutation, DeleteExclusionsMutationVariables> {
    document = DeleteExclusionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExclusionsDocument = gql`
    mutation createExclusions($data: [CreateExclusionDataInput!]) {
  createExclusions(newExclusions: $data) {
    success
    insertedCount
    skippedCount
    mergedCount
    warnings {
      code
      message
      sensorName
      sensorId
      startDate
      endDate
    }
    errors {
      code
      message
      rowIndex
    }
    exclusions {
      start_ts
      exclusion_type
      end_ts
      _id_site
      _id_sensorType
      _id_sensor
      _id_portfolio
      _id_device
      _id
      note
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExclusionsGQL extends Apollo.Mutation<CreateExclusionsMutation, CreateExclusionsMutationVariables> {
    document = CreateExclusionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadExclusionsDocument = gql`
    mutation uploadExclusions($targetDevice: String, $file: File!, $dryRun: Boolean = false) {
  uploadExclusions(targetDevice: $targetDevice, file: $file, dryRun: $dryRun) {
    success
    insertedCount
    skippedCount
    mergedCount
    warnings {
      code
      message
      sensorName
      sensorId
      startDate
      endDate
    }
    errors {
      code
      message
      rowIndex
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadExclusionsGQL extends Apollo.Mutation<UploadExclusionsMutation, UploadExclusionsMutationVariables> {
    document = UploadExclusionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExclusionSensorsDocument = gql`
    query getExclusionSensors($deviceIds: [String]) {
  Exclusion(where: {deviceIds: $deviceIds}) {
    sensors {
      name
      _id_device
      _id
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExclusionSensorsGQL extends Apollo.Query<GetExclusionSensorsQuery, GetExclusionSensorsQueryVariables> {
    document = GetExclusionSensorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFreqDistributionsDocument = gql`
    query getFreqDistributions($device_id: String!, $sensor_id: ID!, $startTS: Float, $endTS: Float, $granularity: FreqDistributionsGranularity!) {
  FreqDistributions(
    device_id: $device_id
    where: {sensor_id: $sensor_id, startTS: $startTS, endTS: $endTS, granularity: $granularity}
  ) {
    measuredFrequencies
    weibullFrequencies
    weibullX
    binCenters
    month
    scaleParameter
    shapeParameter
    year
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFreqDistributionsGQL extends Apollo.Query<GetFreqDistributionsQuery, GetFreqDistributionsQueryVariables> {
    document = GetFreqDistributionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInfoDevicesListDocument = gql`
    query getInfoDevicesList($_id_portfolio: String!) {
  Site(where: {_id_portfolio: $_id_portfolio}) {
    items {
      Devices {
        items {
          DeviceType {
            displayName
          }
          Loggers {
            items {
              timezone
            }
          }
          Sensors {
            items {
              _id
              name
              height
              orientation
              _id_sensorType
              startDate
              deadbandOrientation
              serialNumber
              scale
              loggerOffset
              loggerScale
              offset
              functioning
              iecCompliant
              sensorModel
              _id_reference
            }
            totalCount
          }
          Notes {
            totalCount
          }
          _id
          displayName
          height
          exactHeight
          width
          timezone
          status
          latitude
          longitude
          monitoringDate
          monitoringEndDate
        }
      }
      _id
      name
      country
    }
  }
  SensorType {
    items {
      _id
      displayName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInfoDevicesListGQL extends Apollo.Query<GetInfoDevicesListQuery, GetInfoDevicesListQueryVariables> {
    document = GetInfoDevicesListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceNotesDocument = gql`
    query getDeviceNotes($_id_reference: String) {
  Note(where: {_id_reference: $_id_reference}) {
    items {
      _id
      _id_reference
      actionDate
      text
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceNotesGQL extends Apollo.Query<GetDeviceNotesQuery, GetDeviceNotesQueryVariables> {
    document = GetDeviceNotesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLongTermWsEnergyDocument = gql`
    query getLongTermWSEnergy($id_device: ID!) {
  longTermWSEnergy(input: {_id_device: $id_device}) {
    windSpeedMean
    merra2
    longTermHubHeightWindSpeed
    hubHeight
    hubHeighWindSpeed
    estimatedGrossEnergy
    estimatedGrossCapacity
    defaultShearValue
    airDensity
    hubHeighFrequencyDistribution
    powerCurve
    windSpeedMeanReferenceMast
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLongTermWsEnergyGQL extends Apollo.Query<GetLongTermWsEnergyQuery, GetLongTermWsEnergyQueryVariables> {
    document = GetLongTermWsEnergyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSensorsDocument = gql`
    query getSensors($id: String!) {
  anemometer: Sensor(
    where: {_id_device: $id, sensorTypeName: ANEMOMETER, is_hide_sensors_references: true}
  ) {
    items {
      _id
      name
    }
  }
  wind_vane: Sensor(
    where: {_id_device: $id, sensorTypeName: WIND_VANE, is_hide_sensors_references: true}
  ) {
    items {
      _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSensorsGQL extends Apollo.Query<GetSensorsQuery, GetSensorsQueryVariables> {
    document = GetSensorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MastShadowDocument = gql`
    query mastShadow($_id_device: ID!, $startTS: Float!, $endTS: Float!, $anemometer1: ID!, $anemometer2: ID!, $windVane: ID!, $lwsCutoff: Int) {
  MastShadow(
    device_id: $_id_device
    where: {startTS: $startTS, endTS: $endTS, anemometer1: $anemometer1, anemometer2: $anemometer2, windVane: $windVane, lwsCutoff: $lwsCutoff}
  ) {
    ratio
    wdDir
    timestamps
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MastShadowGQL extends Apollo.Query<MastShadowQuery, MastShadowQueryVariables> {
    document = MastShadowDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPortfolioSitesWeatherDocument = gql`
    query getPortfolioSitesWeather($_id_portfolio: String!, $offset: Int, $limit: Int) {
  Site(where: {_id_portfolio: $_id_portfolio}, offset: $offset, limit: $limit) {
    items {
      Devices {
        items {
          Weather {
            icon
            temperature
            weather
            windDirection
            windSpeed
          }
        }
      }
      name
      _id
      country
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPortfolioSitesWeatherGQL extends Apollo.Query<GetPortfolioSitesWeatherQuery, GetPortfolioSitesWeatherQueryVariables> {
    document = GetPortfolioSitesWeatherDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCountrySitesWeatherDocument = gql`
    query getCountrySitesWeather($_id_portfolio: String!, $_id_country: String!, $offset: Int, $limit: Int) {
  Site(
    where: {_id_portfolio: $_id_portfolio, _id_country: $_id_country}
    offset: $offset
    limit: $limit
  ) {
    items {
      Devices {
        items {
          Weather {
            icon
            temperature
            weather
            windDirection
            windSpeed
          }
        }
      }
      name
      _id
      country
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCountrySitesWeatherGQL extends Apollo.Query<GetCountrySitesWeatherQuery, GetCountrySitesWeatherQueryVariables> {
    document = GetCountrySitesWeatherDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceWeatherDocument = gql`
    query getDeviceWeather($_id: String!, $offset: Int, $limit: Int) {
  Site(where: {_id: $_id}) {
    items {
      Devices(offset: $offset, limit: $limit) {
        items {
          name
          displayName
          _id
          Weather {
            icon
            temperature
            weather
            windDirection
            windSpeed
          }
        }
        totalCount
      }
      _id
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceWeatherGQL extends Apollo.Query<GetDeviceWeatherQuery, GetDeviceWeatherQueryVariables> {
    document = GetDeviceWeatherDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPortfolioStandardAlarmsDocument = gql`
    query getPortfolioStandardAlarms($_id_portfolio: String!) {
  Device(where: {_id_portfolio: $_id_portfolio}) {
    items {
      displayName
      TriggeredAlarms {
        items {
          _id_alarm
          _id_category
          _id_device
          alarmType
          description
          severity
          startTime
          reviewed
          Sensors {
            totalCount
          }
        }
      }
    }
  }
  CustomAlarmCategory {
    items {
      _id
      color
      displayName
    }
  }
  StandardAlarmCategory {
    categories {
      _id
      color
      displayName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPortfolioStandardAlarmsGQL extends Apollo.Query<GetPortfolioStandardAlarmsQuery, GetPortfolioStandardAlarmsQueryVariables> {
    document = GetPortfolioStandardAlarmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCountryStandardAlarmsDocument = gql`
    query getCountryStandardAlarms($_id_country: String!) {
  Device(where: {_id_country: $_id_country}) {
    items {
      displayName
      TriggeredAlarms {
        items {
          _id_alarm
          _id_category
          _id_device
          alarmType
          description
          severity
          startTime
          reviewed
          Sensors {
            totalCount
          }
        }
      }
    }
  }
  CustomAlarmCategory {
    items {
      _id
      color
      displayName
    }
  }
  StandardAlarmCategory {
    categories {
      _id
      color
      displayName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCountryStandardAlarmsGQL extends Apollo.Query<GetCountryStandardAlarmsQuery, GetCountryStandardAlarmsQueryVariables> {
    document = GetCountryStandardAlarmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSiteStandardAlarmsDocument = gql`
    query getSiteStandardAlarms($_id_site: String!) {
  Device(where: {_id_site: $_id_site}) {
    items {
      displayName
      TriggeredAlarms {
        items {
          _id_alarm
          _id_category
          _id_device
          alarmType
          description
          severity
          startTime
          reviewed
          Sensors {
            totalCount
          }
        }
      }
    }
  }
  CustomAlarmCategory {
    items {
      _id
      color
      displayName
    }
  }
  StandardAlarmCategory {
    categories {
      _id
      color
      displayName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSiteStandardAlarmsGQL extends Apollo.Query<GetSiteStandardAlarmsQuery, GetSiteStandardAlarmsQueryVariables> {
    document = GetSiteStandardAlarmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceTriggeredAlarmsDocument = gql`
    query getDeviceTriggeredAlarms($_id: String!) {
  Device(where: {_id: $_id}) {
    items {
      TriggeredAlarms(sortBy: "startTime") {
        items {
          _id_alarm
          _id_device
          _id_category
          _id_portfolio
          alarmType
          description
          severity
          startTime
          endTime
          duration
          sensorIds
          name
          reviewed
          status
          Sensors {
            items {
              _id
              name
            }
            totalCount
          }
        }
      }
    }
  }
  CustomAlarmCategory {
    items {
      _id
      color
      displayName
    }
  }
  StandardAlarmCategory {
    categories {
      _id
      color
      displayName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceTriggeredAlarmsGQL extends Apollo.Query<GetDeviceTriggeredAlarmsQuery, GetDeviceTriggeredAlarmsQueryVariables> {
    document = GetDeviceTriggeredAlarmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTriggeredAlarmDocument = gql`
    mutation updateTriggeredAlarm($_id_alarm: String!, $_id_device: String!, $_id_category: String!, $_id_portfolio: String!, $name: String!, $description: String, $startTime: DateTime!, $sensorIds: [String!]!, $status: Boolean!, $reviewed: Boolean!, $alarmType: TriggeredAlarmTypeEnum, $severity: TriggeredAlarmSeverityEnum) {
  updateTriggeredAlarm(
    alarm: {_id_alarm: $_id_alarm, _id_device: $_id_device, _id_category: $_id_category, _id_portfolio: $_id_portfolio, name: $name, description: $description, startTime: $startTime, sensorIds: $sensorIds, status: $status, reviewed: $reviewed, alarmType: $alarmType, severity: $severity}
  ) {
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTriggeredAlarmGQL extends Apollo.Mutation<UpdateTriggeredAlarmMutation, UpdateTriggeredAlarmMutationVariables> {
    document = UpdateTriggeredAlarmDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSiteCoverageDocument = gql`
    query getSiteCoverage($device_ids: [ID!]!, $yearFilter: String) {
  SiteCoverage(device_ids: $device_ids, yearFilter: $yearFilter) {
    device_id
    displayName
    coverages {
      year
      month
      data {
        sensor_id
        sensor_type
        sensor_name
        coverage
        average {
          signal_name
          signal_unit
          value
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSiteCoverageGQL extends Apollo.Query<GetSiteCoverageQuery, GetSiteCoverageQueryVariables> {
    document = GetSiteCoverageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetServiceCasesDocument = gql`
    query getServiceCases($_id_device: String) {
  serviceCases(where: {_id_device: $_id_device}) {
    items {
      _id
      _id_country
      _id_device
      _id_portfolio
      _id_site
      createdAt
      description
      note
      priority
      status
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetServiceCasesGQL extends Apollo.Query<GetServiceCasesQuery, GetServiceCasesQueryVariables> {
    document = GetServiceCasesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllCountriesDocument = gql`
    query getAllCountries {
  Country {
    items {
      _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllCountriesGQL extends Apollo.Query<GetAllCountriesQuery, GetAllCountriesQueryVariables> {
    document = GetAllCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllSitesDocument = gql`
    query getAllSites {
  Site {
    items {
      _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllSitesGQL extends Apollo.Query<GetAllSitesQuery, GetAllSitesQueryVariables> {
    document = GetAllSitesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVerticalWindProfileDocument = gql`
    query getVerticalWindProfile($_id_device: ID!) {
  verticalWindProfile(input: {_id_device: $_id_device}) {
    referenceHeight
    referenceSpeed
    shearCoefficient
    fittedProfile {
      height
      windSpeed
    }
    observedPoints {
      height
      windSpeed
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetVerticalWindProfileGQL extends Apollo.Query<GetVerticalWindProfileQuery, GetVerticalWindProfileQueryVariables> {
    document = GetVerticalWindProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDirectionalWindShearVariationDocument = gql`
    query getDirectionalWindShearVariation($_id_device: ID!) {
  getDirectionalWindShearVariation(input: {_id_device: $_id_device}) {
    n
    shearAlpha
    directionSector
    frequencyPct
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDirectionalWindShearVariationGQL extends Apollo.Query<GetDirectionalWindShearVariationQuery, GetDirectionalWindShearVariationQueryVariables> {
    document = GetDirectionalWindShearVariationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDiurnalWindShearVariationDocument = gql`
    query getDiurnalWindShearVariation($_id_device: ID!) {
  getDiurnalWindShearVariation(input: {_id_device: $_id_device}) {
    hour
    shearMin
    shearAvg
    shearMax
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDiurnalWindShearVariationGQL extends Apollo.Query<GetDiurnalWindShearVariationQuery, GetDiurnalWindShearVariationQueryVariables> {
    document = GetDiurnalWindShearVariationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSeasonalWindShearVariationDocument = gql`
    query getSeasonalWindShearVariation($_id_device: ID!, $years: [Int]) {
  getSeasonalWindShearVariation(input: {_id_device: $_id_device, years: $years}) {
    totals: all
    hour
    january
    february
    march
    april
    may
    june
    july
    august
    september
    october
    november
    december
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSeasonalWindShearVariationGQL extends Apollo.Query<GetSeasonalWindShearVariationQuery, GetSeasonalWindShearVariationQueryVariables> {
    document = GetSeasonalWindShearVariationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFirstAndLastDataDatesDocument = gql`
    query getFirstAndLastDataDates($id: String!) {
  Device(where: {_id: $id}) {
    items {
      monitoringDate: installationDate
      lastMonitoringDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFirstAndLastDataDatesGQL extends Apollo.Query<GetFirstAndLastDataDatesQuery, GetFirstAndLastDataDatesQueryVariables> {
    document = GetFirstAndLastDataDatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSensorsByTypeDocument = gql`
    query getSensorsByType($id: String!) {
  Sensor(where: {_id_device: $id, is_hide_sensors_references: true}) {
    items {
      _id
      _id_device
      name
      sensorTypeName
      _id_sensorType
      Signals {
        items {
          _id
          name
          unit
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSensorsByTypeGQL extends Apollo.Query<GetSensorsByTypeQuery, GetSensorsByTypeQueryVariables> {
    document = GetSensorsByTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetScatterMastShadowDataDocument = gql`
    query getScatterMastShadowData($idDevice: ID!, $startDate: Float!, $endDate: Float!, $anemometer1: ID!, $anemometer2: ID!, $windVane: ID!, $cutOff: Int) {
  MastShadow(
    device_id: $idDevice
    where: {startTS: $startDate, endTS: $endDate, anemometer1: $anemometer1, anemometer2: $anemometer2, windVane: $windVane, lwsCutoff: $cutOff}
  ) {
    ratio
    timestamps
    wdDir
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetScatterMastShadowDataGQL extends Apollo.Query<GetScatterMastShadowDataQuery, GetScatterMastShadowDataQueryVariables> {
    document = GetScatterMastShadowDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetScatterCorrelationDataDocument = gql`
    query getScatterCorrelationData($idDevice: ID!, $startDate: Float!, $endDate: Float!, $sensor1: ID!, $sensor2: ID!, $sensor3: ID!, $cutOff: Float!, $signal: SignalEnum!) {
  SensorCorrelation(
    device_id: $idDevice
    where: {sensor1: {id: $sensor1, signal: $signal}, sensor2: {id: $sensor2, signal: $signal}, startTS: $startDate, endTS: $endDate, lwsCutoff: {cut: $cutOff, anemometer: $sensor3}}
  ) {
    sensor1Values
    sensor2Values
    timestamps
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetScatterCorrelationDataGQL extends Apollo.Query<GetScatterCorrelationDataQuery, GetScatterCorrelationDataQueryVariables> {
    document = GetScatterCorrelationDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTimeseriesDataDocument = gql`
    query getTimeseriesData($deviceId: String!, $startTS: Float!, $endTS: Float!, $timeseriesSignals: [TimeseriesSignalsWhereInput]!) {
  Timeseries(
    device_id: $deviceId
    where: {sensorSignal: $timeseriesSignals, startTS: $startTS, endTS: $endTS}
  ) {
    signal
    sensor
    values
    timestamps
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTimeseriesDataGQL extends Apollo.Query<GetTimeseriesDataQuery, GetTimeseriesDataQueryVariables> {
    document = GetTimeseriesDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTurbulenceIntensityDocument = gql`
    query getTurbulenceIntensity($_id_device: ID!) {
  getTurbulenceIntensity(input: {_id_device: $_id_device}) {
    windSpeedBins
    meanTI
    meanPlus128SD
    IECClassA
    IECClassB
    IECClassC
    Datapoints
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTurbulenceIntensityGQL extends Apollo.Query<GetTurbulenceIntensityQuery, GetTurbulenceIntensityQueryVariables> {
    document = GetTurbulenceIntensityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTurbulenceWdirIntensityDocument = gql`
    query getTurbulenceWDIRIntensity($_id_device: ID!) {
  getTurbulenceWDIRIntensity(input: {_id_device: $_id_device}) {
    windDirectionBins
    meanTI
    meanPlus128SD
    Datapoints
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTurbulenceWdirIntensityGQL extends Apollo.Query<GetTurbulenceWdirIntensityQuery, GetTurbulenceWdirIntensityQueryVariables> {
    document = GetTurbulenceWdirIntensityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCheckPeriodsDocument = gql`
    query getCheckPeriods($deviceId: String!) {
  GetCheckPeriod(where: {_id_device: $deviceId}) {
    items {
      _id
      _id_device
      createdAt
      updatedAt
      createdBy
      from
      to
      updatedBy
      checked
      auto
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCheckPeriodsGQL extends Apollo.Query<GetCheckPeriodsQuery, GetCheckPeriodsQueryVariables> {
    document = GetCheckPeriodsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCheckPeriodDocument = gql`
    mutation deleteCheckPeriod($_id: String!) {
  deleteCheckPeriod(_id: $_id) {
    items {
      _id
      _id_device
      from
      to
      checked
      createdBy
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCheckPeriodGQL extends Apollo.Mutation<DeleteCheckPeriodMutation, DeleteCheckPeriodMutationVariables> {
    document = DeleteCheckPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWindRosesDocument = gql`
    query getWindRoses($device_id: String!, $anemometer: ID!, $windVane: ID!, $startTS: Float, $endTS: Float, $granularity: WindRosesGranularity!) {
  WindRoses(
    device_id: $device_id
    where: {anemometer: $anemometer, windVane: $windVane, startTS: $startTS, endTS: $endTS, granularity: $granularity}
  ) {
    month
    year
    bins {
      bin
      data {
        percentage
        range
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWindRosesGQL extends Apollo.Query<GetWindRosesQuery, GetWindRosesQueryVariables> {
    document = GetWindRosesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetImagesDocument = gql`
    query getImages($scope: [String!]) {
  Images(where: {scope: $scope}) {
    items {
      _id
      createdBy
      description
      name
      originalName
      fileExtension
      scope
      size
      username
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetImagesGQL extends Apollo.Query<GetImagesQuery, GetImagesQueryVariables> {
    document = GetImagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReportSensorsInfoDocument = gql`
    query getReportSensorsInfo($_id: String!) {
  Sensor(where: {_id_device: $_id}, sortDirection: ASC, sortField: "name") {
    items {
      _id
      _id_reference
      sensorTypeName
      name
      height
      orientation
      sensorModel
      startDate
      deadbandOrientation
      serialNumber
      scale
      offset
      loggerScale
      loggerOffset
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReportSensorsInfoGQL extends Apollo.Query<GetReportSensorsInfoQuery, GetReportSensorsInfoQueryVariables> {
    document = GetReportSensorsInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReportDeviceInfoDocument = gql`
    query getReportDeviceInfo($_id: String!) {
  Device(where: {_id: $_id}) {
    items {
      Onshore
      installationDate
      monitoringDate
      status
      serialNumber
      magneticDeclination
      latitude
      longitude
      width
      height
      elevation
      exactHeight
      Timezone {
        displayName
      }
      DeviceManufacturer {
        name
      }
      DeviceModel {
        name
      }
      MastType {
        displayName
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReportDeviceInfoGQL extends Apollo.Query<GetReportDeviceInfoQuery, GetReportDeviceInfoQueryVariables> {
    document = GetReportDeviceInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTemplatesDocument = gql`
    query getTemplates($_id_portfolio: String!, $limit: Int, $skip: Int, $orderBy: ReportOrderByInput) {
  Reports(
    where: {_id_portfolio: $_id_portfolio, reportType: TEMPLATE}
    limit: $limit
    skip: $skip
    orderBy: $orderBy
  ) {
    total
    data {
      _id
      _id_deviceType
      _id_portfolio
      createdBy
      creatorName
      createdAt
      deviceIds
      displayName
      name
      report
      reportType
      schedule {
        weekDays
        schedule
        logoName
        logo
        hour
        level
        header
        footer
        firstDays
        emailList
        autoUpdate
        dateRange {
          endDate
          startDate
        }
      }
      siteIds
      updatedAt
      updatedBy
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTemplatesGQL extends Apollo.Query<GetTemplatesQuery, GetTemplatesQueryVariables> {
    document = GetTemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReportsDocument = gql`
    query getReports($_id_portfolio: String!, $limit: Int, $skip: Int, $orderBy: ReportOrderByInput) {
  Reports(
    where: {_id_portfolio: $_id_portfolio, reportType: REPORT}
    limit: $limit
    skip: $skip
    orderBy: $orderBy
  ) {
    total
    data {
      _id
      _id_deviceType
      _id_portfolio
      createdBy
      creatorName
      createdAt
      deviceIds
      displayName
      name
      report
      reportType
      schedule {
        weekDays
        schedule
        logoName
        logo
        hour
        level
        header
        footer
        firstDays
        emailList
        autoUpdate
        dateRange {
          endDate
          startDate
        }
      }
      siteIds
      updatedAt
      updatedBy
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReportsGQL extends Apollo.Query<GetReportsQuery, GetReportsQueryVariables> {
    document = GetReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReportDocument = gql`
    query getReport($id: String!) {
  Reports(where: {_id: $id}) {
    data {
      _id
      _id_deviceType
      createdBy
      createdAt
      deviceIds
      creatorName
      displayName
      name
      report
      reportType
      _id_portfolio
      siteIds
      updatedAt
      updatedBy
      schedule {
        autoUpdate
        emailList
        firstDays
        footer
        header
        level
        hour
        logo
        logoName
        schedule
        dateRange {
          endDate
          startDate
        }
        weekDays
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReportGQL extends Apollo.Query<GetReportQuery, GetReportQueryVariables> {
    document = GetReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateReportDocument = gql`
    mutation createReport($input: CreateReportInput!) {
  createReport(input: $input) {
    _id_deviceType
    _id
    _id_portfolio
    createdAt
    createdBy
    creatorName
    displayName
    deviceIds
    report
    name
    reportType
    schedule {
      autoUpdate
      emailList
      firstDays
      footer
      header
      hour
      level
      logo
      logoName
      schedule
      dateRange {
        endDate
        startDate
      }
      weekDays
    }
    siteIds
    updatedAt
    updatedBy
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateReportGQL extends Apollo.Mutation<CreateReportMutation, CreateReportMutationVariables> {
    document = CreateReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteReportDocument = gql`
    mutation deleteReport($id: String!) {
  deleteReport(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteReportGQL extends Apollo.Mutation<DeleteReportMutation, DeleteReportMutationVariables> {
    document = DeleteReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateReportDocument = gql`
    mutation updateReport($id: String!, $input: UpdateReportInput!) {
  updateReport(id: $id, input: $input) {
    _id_deviceType
    _id
    _id_portfolio
    createdAt
    createdBy
    creatorName
    displayName
    deviceIds
    report
    name
    reportType
    schedule {
      autoUpdate
      emailList
      firstDays
      footer
      header
      hour
      level
      logo
      logoName
      schedule
      dateRange {
        endDate
        startDate
      }
      weekDays
    }
    siteIds
    updatedAt
    updatedBy
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateReportGQL extends Apollo.Mutation<UpdateReportMutation, UpdateReportMutationVariables> {
    document = UpdateReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendReportNowDocument = gql`
    mutation sendReportNow($_id: String!, $emailList: [String]!) {
  sendReportNow(_id: $_id, emailList: $emailList)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendReportNowGQL extends Apollo.Mutation<SendReportNowMutation, SendReportNowMutationVariables> {
    document = SendReportNowDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllTemplatesCreatorAndTypesDocument = gql`
    query getAllTemplatesCreatorAndTypes($_id_portfolio: String!) {
  Reports(where: {_id_portfolio: $_id_portfolio, reportType: TEMPLATE}) {
    data {
      _id_deviceType
      creatorName
      createdBy
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllTemplatesCreatorAndTypesGQL extends Apollo.Query<GetAllTemplatesCreatorAndTypesQuery, GetAllTemplatesCreatorAndTypesQueryVariables> {
    document = GetAllTemplatesCreatorAndTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllReportDevicesDocument = gql`
    query getAllReportDevices {
  Device {
    items {
      _id
      displayName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllReportDevicesGQL extends Apollo.Query<GetAllReportDevicesQuery, GetAllReportDevicesQueryVariables> {
    document = GetAllReportDevicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceTimezoneDocument = gql`
    query getDeviceTimezone($id: String!) {
  Device(where: {_id: $id}) {
    items {
      Timezone {
        timezoneOffset
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceTimezoneGQL extends Apollo.Query<GetDeviceTimezoneQuery, GetDeviceTimezoneQueryVariables> {
    document = GetDeviceTimezoneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStandardAlarmsDocument = gql`
    query getStandardAlarms($_id_portfolio: [String], $_id_site: [String], $_id_country: [String], $_id_category: [String]) {
  StandardAlarm(
    where: {_id_portfolio: $_id_portfolio, _id_country: $_id_country, _id_site: $_id_site, _id_category: $_id_category}
  ) {
    alarms {
      _id
      _id_country
      _id_portfolio
      _id_site
      category {
        _id
        color
        displayName
        name
      }
      condition {
        time
        value
      }
      createdAt
      description
      deviceIds
      displayName
      name
      severity
      active: status
      updatedAt
    }
  }
  Site {
    items {
      name
      _id
    }
  }
  Device {
    items {
      _id
      displayName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStandardAlarmsGQL extends Apollo.Query<GetStandardAlarmsQuery, GetStandardAlarmsQueryVariables> {
    document = GetStandardAlarmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStandardCategoriesDocument = gql`
    query getStandardCategories {
  StandardAlarmCategory {
    categories {
      _id
      color
      displayName
      name
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStandardCategoriesGQL extends Apollo.Query<GetStandardCategoriesQuery, GetStandardCategoriesQueryVariables> {
    document = GetStandardCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateStandardAlarmDocument = gql`
    mutation createStandardAlarm($deviceIds: [String!]!, $displayName: String!, $description: String, $_id_category: String!, $condition: ConditionInput!, $severity: AlarmSeverityEnum!, $status: Boolean!) {
  createStandardAlarm(
    input: {deviceIds: $deviceIds, displayName: $displayName, description: $description, _id_category: $_id_category, condition: $condition, severity: $severity, status: $status}
  ) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateStandardAlarmGQL extends Apollo.Mutation<CreateStandardAlarmMutation, CreateStandardAlarmMutationVariables> {
    document = CreateStandardAlarmDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStandardAlarmDocument = gql`
    mutation updateStandardAlarm($_id: String!, $deviceIds: [String!], $displayName: String, $description: String, $_id_category: String, $condition: ConditionInput, $severity: AlarmSeverityEnum, $status: Boolean) {
  updateStandardAlarm(
    _id: $_id
    input: {deviceIds: $deviceIds, displayName: $displayName, description: $description, _id_category: $_id_category, condition: $condition, severity: $severity, status: $status}
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStandardAlarmGQL extends Apollo.Mutation<UpdateStandardAlarmMutation, UpdateStandardAlarmMutationVariables> {
    document = UpdateStandardAlarmDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteStandardAlarmDocument = gql`
    mutation deleteStandardAlarm($_id: String!) {
  deleteStandardAlarm(_id: $_id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteStandardAlarmGQL extends Apollo.Mutation<DeleteStandardAlarmMutation, DeleteStandardAlarmMutationVariables> {
    document = DeleteStandardAlarmDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteStandardAlarmsDocument = gql`
    mutation deleteStandardAlarms($ids: [String!]!) {
  deleteStandardAlarms(ids: $ids)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteStandardAlarmsGQL extends Apollo.Mutation<DeleteStandardAlarmsMutation, DeleteStandardAlarmsMutationVariables> {
    document = DeleteStandardAlarmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCustomAlarmDocument = gql`
    mutation createCustomAlarm($_id_device: String!, $displayName: String!, $description: String, $_id_category: String!, $severity: AlarmSeverityEnum!, $status: Boolean!) {
  createCustomAlarm(
    input: {_id_device: $_id_device, displayName: $displayName, description: $description, _id_category: $_id_category, severity: $severity, status: $status}
  ) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCustomAlarmGQL extends Apollo.Mutation<CreateCustomAlarmMutation, CreateCustomAlarmMutationVariables> {
    document = CreateCustomAlarmDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCustomAlarmConditionDocument = gql`
    mutation createCustomAlarmCondition($_id_custom_alarm: String!, $condition: String!, $count: Int!, $sensorIds: [String!]!, $notify: NotifyModeEnum!) {
  createCustomAlarmCondition(
    input: {_id_custom_alarm: $_id_custom_alarm, condition: $condition, count: $count, sensorIds: $sensorIds, notify: $notify}
  ) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCustomAlarmConditionGQL extends Apollo.Mutation<CreateCustomAlarmConditionMutation, CreateCustomAlarmConditionMutationVariables> {
    document = CreateCustomAlarmConditionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomAlarmCategoriesDocument = gql`
    query getCustomAlarmCategories {
  CustomAlarmCategory {
    items {
      _id
      color
      displayName
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCustomAlarmCategoriesGQL extends Apollo.Query<GetCustomAlarmCategoriesQuery, GetCustomAlarmCategoriesQueryVariables> {
    document = GetCustomAlarmCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCustomAlarmCategoryDocument = gql`
    mutation createCustomAlarmCategory($color: String!, $displayName: String!) {
  createCustomAlarmCategory(input: {color: $color, displayName: $displayName}) {
    _id
    color
    name
    displayName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCustomAlarmCategoryGQL extends Apollo.Mutation<CreateCustomAlarmCategoryMutation, CreateCustomAlarmCategoryMutationVariables> {
    document = CreateCustomAlarmCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCustomAlarmCategoryDocument = gql`
    mutation deleteCustomAlarmCategory($_id: String!, $reassignToCategoryId: String) {
  deleteCustomAlarmCategory(
    _id: $_id
    reassignToCategoryId: $reassignToCategoryId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCustomAlarmCategoryGQL extends Apollo.Mutation<DeleteCustomAlarmCategoryMutation, DeleteCustomAlarmCategoryMutationVariables> {
    document = DeleteCustomAlarmCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCustomAlarmCategoryDocument = gql`
    mutation updateCustomAlarmCategory($_id: String!, $color: String!, $displayName: String!) {
  updateCustomAlarmCategory(
    _id: $_id
    input: {color: $color, displayName: $displayName}
  ) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCustomAlarmCategoryGQL extends Apollo.Mutation<UpdateCustomAlarmCategoryMutation, UpdateCustomAlarmCategoryMutationVariables> {
    document = UpdateCustomAlarmCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomAlarmsDocument = gql`
    query getCustomAlarms($_id_portfolio: [String], $_id_site: [String], $_id_country: [String], $_id_category: [String]) {
  CustomAlarm(
    filters: {_id_portfolio: $_id_portfolio, _id_country: $_id_country, _id_site: $_id_site, _id_category: $_id_category}
  ) {
    items {
      _id
      _id_category
      _id_device
      _id_portfolio
      _id_country
      _id_site
      createdAt
      description
      displayName
      name
      severity
      active: status
      updatedAt
    }
  }
  Site {
    items {
      name
      _id
    }
  }
  Device {
    items {
      _id
      displayName
    }
  }
  CustomAlarmCategory {
    items {
      _id
      color
      displayName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCustomAlarmsGQL extends Apollo.Query<GetCustomAlarmsQuery, GetCustomAlarmsQueryVariables> {
    document = GetCustomAlarmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceCustomAlarmsIdsDocument = gql`
    query getDeviceCustomAlarmsIds($_id_device: [String]!) {
  CustomAlarm(filters: {_id_device: $_id_device}) {
    items {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceCustomAlarmsIdsGQL extends Apollo.Query<GetDeviceCustomAlarmsIdsQuery, GetDeviceCustomAlarmsIdsQueryVariables> {
    document = GetDeviceCustomAlarmsIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomAlarmsByCategoryDocument = gql`
    query getCustomAlarmsByCategory($_id_category: [String]) {
  CustomAlarm(filters: {_id_category: $_id_category}) {
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCustomAlarmsByCategoryGQL extends Apollo.Query<GetCustomAlarmsByCategoryQuery, GetCustomAlarmsByCategoryQueryVariables> {
    document = GetCustomAlarmsByCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCustomAlarmDocument = gql`
    mutation deleteCustomAlarm($_id: String!) {
  deleteCustomAlarm(_id: $_id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCustomAlarmGQL extends Apollo.Mutation<DeleteCustomAlarmMutation, DeleteCustomAlarmMutationVariables> {
    document = DeleteCustomAlarmDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCustomAlarmsDocument = gql`
    mutation deleteCustomAlarms($ids: [String!]!) {
  deleteCustomAlarms(ids: $ids)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCustomAlarmsGQL extends Apollo.Mutation<DeleteCustomAlarmsMutation, DeleteCustomAlarmsMutationVariables> {
    document = DeleteCustomAlarmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomAlarmConditionDocument = gql`
    query getCustomAlarmCondition($_id_custom_alarm: String!) {
  CustomAlarmCondition(filters: {_id_custom_alarm: $_id_custom_alarm}) {
    items {
      _id
      _id_custom_alarm
      condition
      count
      sensorIds
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCustomAlarmConditionGQL extends Apollo.Query<GetCustomAlarmConditionQuery, GetCustomAlarmConditionQueryVariables> {
    document = GetCustomAlarmConditionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCustomAlarmDocument = gql`
    mutation updateCustomAlarm($_id: String!, $_id_device: String, $displayName: String, $description: String, $_id_category: String, $severity: AlarmSeverityEnum, $status: Boolean) {
  updateCustomAlarm(
    _id: $_id
    input: {_id_device: $_id_device, displayName: $displayName, description: $description, _id_category: $_id_category, severity: $severity, status: $status}
  ) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCustomAlarmGQL extends Apollo.Mutation<UpdateCustomAlarmMutation, UpdateCustomAlarmMutationVariables> {
    document = UpdateCustomAlarmDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCustomAlarmConditionDocument = gql`
    mutation updateCustomAlarmCondition($_id: String!, $_id_custom_alarm: String!, $condition: String!, $count: Int!, $sensorIds: [String!]!, $notify: NotifyModeEnum!) {
  updateCustomAlarmCondition(
    _id: $_id
    input: {_id_custom_alarm: $_id_custom_alarm, condition: $condition, count: $count, sensorIds: $sensorIds, notify: $notify}
  ) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCustomAlarmConditionGQL extends Apollo.Mutation<UpdateCustomAlarmConditionMutation, UpdateCustomAlarmConditionMutationVariables> {
    document = UpdateCustomAlarmConditionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCalcSettingDocument = gql`
    query getCalcSetting($_id_device: String!) {
  CalcSetting(where: {_id_device: $_id_device}) {
    items {
      _id
      _id_device
      _id_mainAnemometer
      _id_mainWindVane
      _id_mainPyranometer
      _id_mainThermometer
      _id_mainRainSensor
      longTermAnalisis
      shearAnemometers
      statisticSensors
      thermometers
      ampmeters
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCalcSettingGQL extends Apollo.Query<GetCalcSettingQuery, GetCalcSettingQueryVariables> {
    document = GetCalcSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCalcSettingDocument = gql`
    mutation createCalcSetting($_id_device: String!, $_id_mainAnemometer: String, $_id_mainWindVane: String, $_id_mainPyranometer: String, $_id_mainThermometer: String, $_id_mainRainSensor: String, $longTermAnalisis: Boolean!, $shearAnemometers: [String], $statisticSensors: [String], $thermometers: [String], $ampmeters: [String]) {
  createCalcSetting(
    _id_device: $_id_device
    _id_mainAnemometer: $_id_mainAnemometer
    _id_mainWindVane: $_id_mainWindVane
    _id_mainPyranometer: $_id_mainPyranometer
    _id_mainThermometer: $_id_mainThermometer
    _id_mainRainSensor: $_id_mainRainSensor
    longTermAnalisis: $longTermAnalisis
    shearAnemometers: $shearAnemometers
    statisticSensors: $statisticSensors
    thermometers: $thermometers
    ampmeters: $ampmeters
  ) {
    _id
    _id_device
    _id_mainAnemometer
    _id_mainWindVane
    _id_mainPyranometer
    _id_mainThermometer
    _id_mainRainSensor
    longTermAnalisis
    shearAnemometers
    statisticSensors
    thermometers
    ampmeters
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCalcSettingGQL extends Apollo.Mutation<CreateCalcSettingMutation, CreateCalcSettingMutationVariables> {
    document = CreateCalcSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCalcSettingDocument = gql`
    mutation updateCalcSetting($_id: String!, $_id_device: String, $_id_mainAnemometer: String, $_id_mainWindVane: String, $_id_mainPyranometer: String, $_id_mainThermometer: String, $_id_mainRainSensor: String, $longTermAnalisis: Boolean, $shearAnemometers: [String], $statisticSensors: [String], $thermometers: [String], $ampmeters: [String]) {
  updateCalcSetting(
    _id: $_id
    _id_device: $_id_device
    _id_mainAnemometer: $_id_mainAnemometer
    _id_mainWindVane: $_id_mainWindVane
    _id_mainPyranometer: $_id_mainPyranometer
    _id_mainThermometer: $_id_mainThermometer
    _id_mainRainSensor: $_id_mainRainSensor
    longTermAnalisis: $longTermAnalisis
    shearAnemometers: $shearAnemometers
    statisticSensors: $statisticSensors
    thermometers: $thermometers
    ampmeters: $ampmeters
  ) {
    _id
    _id_device
    _id_mainAnemometer
    _id_mainWindVane
    _id_mainPyranometer
    _id_mainThermometer
    _id_mainRainSensor
    longTermAnalisis
    shearAnemometers
    statisticSensors
    thermometers
    ampmeters
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCalcSettingGQL extends Apollo.Mutation<UpdateCalcSettingMutation, UpdateCalcSettingMutationVariables> {
    document = UpdateCalcSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePowerCurveSettingDocument = gql`
    mutation createPowerCurveSetting($_id_calc_settings: String!, $_id_device: String!, $_id_reference_mast: String, $hubHeight: Float!, $overrideShearAlpha: Boolean!, $powercurve: [Float!]!, $powerCurveAirDensity: Float!, $ratedPower: Float!, $siteAirDensity: Float!, $templateName: String!, $shearValue: Float) {
  createPowerCurveSetting(
    _id_calc_settings: $_id_calc_settings
    _id_device: $_id_device
    _id_reference_mast: $_id_reference_mast
    hubHeight: $hubHeight
    overrideShearAlpha: $overrideShearAlpha
    powercurve: $powercurve
    powerCurveAirDensity: $powerCurveAirDensity
    ratedPower: $ratedPower
    siteAirDensity: $siteAirDensity
    templateName: $templateName
    shearValue: $shearValue
  ) {
    _id
    _id_calc_settings
    _id_device
    _id_reference_mast
    hubHeight
    overrideShearAlpha
    powerCurveAirDensity
    powercurve
    ratedPower
    siteAirDensity
    templateName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePowerCurveSettingGQL extends Apollo.Mutation<CreatePowerCurveSettingMutation, CreatePowerCurveSettingMutationVariables> {
    document = CreatePowerCurveSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePowerCurveSettingDocument = gql`
    mutation updatePowerCurveSetting($_id: String!, $_id_calc_settings: String, $_id_device: String, $_id_reference_mast: String, $hubHeight: Float, $overrideShearAlpha: Boolean, $powercurve: [Float!], $powerCurveAirDensity: Float, $ratedPower: Float, $siteAirDensity: Float, $templateName: String, $shearValue: Float) {
  updatePowerCurveSetting(
    _id: $_id
    _id_calc_settings: $_id_calc_settings
    _id_device: $_id_device
    _id_reference_mast: $_id_reference_mast
    hubHeight: $hubHeight
    overrideShearAlpha: $overrideShearAlpha
    powercurve: $powercurve
    powerCurveAirDensity: $powerCurveAirDensity
    ratedPower: $ratedPower
    siteAirDensity: $siteAirDensity
    templateName: $templateName
    shearValue: $shearValue
  ) {
    _id
    _id_calc_settings
    _id_device
    hubHeight
    overrideShearAlpha
    powerCurveAirDensity
    powercurve
    ratedPower
    siteAirDensity
    templateName
    shearValue
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePowerCurveSettingGQL extends Apollo.Mutation<UpdatePowerCurveSettingMutation, UpdatePowerCurveSettingMutationVariables> {
    document = UpdatePowerCurveSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PowerCurveSettingDocument = gql`
    query powerCurveSetting($_id_device: String!) {
  PowerCurveSetting(where: {_id_device: $_id_device}) {
    items {
      _id
      _id_calc_settings
      _id_device
      _id_reference_mast
      hubHeight
      overrideShearAlpha
      powerCurveAirDensity
      powercurve
      ratedPower
      siteAirDensity
      templateName
      shearValue
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PowerCurveSettingGQL extends Apollo.Query<PowerCurveSettingQuery, PowerCurveSettingQueryVariables> {
    document = PowerCurveSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParsePowerCurveDataFileDocument = gql`
    mutation parsePowerCurveDataFile($file: File!) {
  parsePowerCurveDataFile(file: $file) {
    hubHeight
    powerCurveAirDensity
    powercurve
    ratedPower
    siteAirDensity
    templateName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParsePowerCurveDataFileGQL extends Apollo.Mutation<ParsePowerCurveDataFileMutation, ParsePowerCurveDataFileMutationVariables> {
    document = ParsePowerCurveDataFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePowerCurveSettingDocument = gql`
    mutation deletePowerCurveSetting($_id: String!) {
  deletePowerCurveSetting(_id: $_id) {
    _id
    _id_calc_settings
    _id_device
    hubHeight
    overrideShearAlpha
    powerCurveAirDensity
    powercurve
    ratedPower
    siteAirDensity
    templateName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePowerCurveSettingGQL extends Apollo.Mutation<DeletePowerCurveSettingMutation, DeletePowerCurveSettingMutationVariables> {
    document = DeletePowerCurveSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDocumentsDocument = gql`
    query getDocuments($_id_device: [String!]!, $limit: Int, $offset: Int) {
  Document(_id_device: $_id_device, limit: $limit, offset: $offset) {
    totalCount
    items {
      _id
      _id_device
      name
      storagePath
      note
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDocumentsGQL extends Apollo.Query<GetDocumentsQuery, GetDocumentsQueryVariables> {
    document = GetDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDocumentsDocument = gql`
    query getAllDocuments($_id_device: [String!]!) {
  Document(_id_device: $_id_device) {
    items {
      _id
      _id_device
      name
      storagePath
      note
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDocumentsGQL extends Apollo.Query<GetAllDocumentsQuery, GetAllDocumentsQueryVariables> {
    document = GetAllDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDocumentsCountDocument = gql`
    query getDocumentsCount($_id_device: [String!]!) {
  Document(_id_device: $_id_device) {
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDocumentsCountGQL extends Apollo.Query<GetDocumentsCountQuery, GetDocumentsCountQueryVariables> {
    document = GetDocumentsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRawDataDocument = gql`
    query getRawData($_id_device: [String!]!, $limit: Int, $offset: Int) {
  RawFile(
    _id_device: $_id_device
    sortDirection: DESC
    offset: $offset
    limit: $limit
  ) {
    items {
      _id
      filename
      received_at
      bucket_path
      size
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRawDataGQL extends Apollo.Query<GetRawDataQuery, GetRawDataQueryVariables> {
    document = GetRawDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRawDataCountDocument = gql`
    query getRawDataCount($_id_device: [String!]!) {
  RawFile(_id_device: $_id_device) {
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRawDataCountGQL extends Apollo.Query<GetRawDataCountQuery, GetRawDataCountQueryVariables> {
    document = GetRawDataCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDocumentDocument = gql`
    mutation createDocument($_id_device: String!, $name: String!, $storagePath: String!, $note: String) {
  createDocument(
    input: {_id_device: $_id_device, name: $name, storagePath: $storagePath, note: $note}
  ) {
    _id
    _id_device
    name
    storagePath
    note
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDocumentGQL extends Apollo.Mutation<CreateDocumentMutation, CreateDocumentMutationVariables> {
    document = CreateDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDocumentDocument = gql`
    mutation deleteDocument($_id: String!) {
  deleteDocument(_id: $_id) {
    _id
    _id_device
    name
    storagePath
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDocumentGQL extends Apollo.Mutation<DeleteDocumentMutation, DeleteDocumentMutationVariables> {
    document = DeleteDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDocumentDocument = gql`
    mutation updateDocument($_id: String!, $note: String!) {
  updateDocument(input: {_id: $_id, note: $note}) {
    _id
    _id_device
    name
    storagePath
    note
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDocumentGQL extends Apollo.Mutation<UpdateDocumentMutation, UpdateDocumentMutationVariables> {
    document = UpdateDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLoggerManufacturerDocument = gql`
    query GetLoggerManufacturer {
  LoggerManufacturer(sortField: "name") {
    items {
      _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLoggerManufacturerGQL extends Apollo.Query<GetLoggerManufacturerQuery, GetLoggerManufacturerQueryVariables> {
    document = GetLoggerManufacturerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLoggerModelDocument = gql`
    query GetLoggerModel($id_manufacturer: String) {
  LoggerModel(where: {_id_manufacturer: $id_manufacturer}, sortField: "name") {
    items {
      _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLoggerModelGQL extends Apollo.Query<GetLoggerModelQuery, GetLoggerModelQueryVariables> {
    document = GetLoggerModelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLoggerDocument = gql`
    mutation createLogger($newLogger: [LoggerInput!]!) {
  createLogger(data: $newLogger) {
    _id
    _id_device
    _id_manufacturer
    _id_model
    enabled
    averagingPeriod
    sampleFrequency
    matchedFilenameFormat
    installationDate
    serialNumber
    timezone
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLoggerGQL extends Apollo.Mutation<CreateLoggerMutation, CreateLoggerMutationVariables> {
    document = CreateLoggerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDictionaryDocument = gql`
    mutation createDictionary($newDictionary: [DictionaryInput!]!) {
  createDictionary(data: $newDictionary) {
    _id
    _id_device
    _id_logger
    def {
      _id
      _id_signal
      _id_sensor
      sensorName
      signalName
      rawSignalName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDictionaryGQL extends Apollo.Mutation<CreateDictionaryMutation, CreateDictionaryMutationVariables> {
    document = CreateDictionaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertLoggerDocument = gql`
    mutation upsertLogger($upsertLogger: [LoggerUpsertInput!]!) {
  upsertLogger(data: $upsertLogger) {
    _id
    _id_device
    _id_manufacturer
    _id_model
    enabled
    averagingPeriod
    sampleFrequency
    matchedFilenameFormat
    installationDate
    serialNumber
    timezone
    Dictionary {
      items {
        _id
        _id_device
        _id_logger
        def {
          _id
          _id_sensor
          _id_signal
          rawSignalName
          sensorName
          signalName
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertLoggerGQL extends Apollo.Mutation<UpsertLoggerMutation, UpsertLoggerMutationVariables> {
    document = UpsertLoggerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertDictionaryDocument = gql`
    mutation upsertDictionary($upsertDictionary: [DictionaryUpsertInput!]!) {
  upsertDictionary(data: $upsertDictionary) {
    _id
    _id_device
    _id_logger
    def {
      _id
      _id_signal
      _id_sensor
      sensorName
      signalName
      rawSignalName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertDictionaryGQL extends Apollo.Mutation<UpsertDictionaryMutation, UpsertDictionaryMutationVariables> {
    document = UpsertDictionaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteLoggerDocument = gql`
    mutation deleteLogger($idLogger: String!) {
  deleteLogger(_id: $idLogger) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLoggerGQL extends Apollo.Mutation<DeleteLoggerMutation, DeleteLoggerMutationVariables> {
    document = DeleteLoggerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDictionaryDocument = gql`
    mutation deleteDictionary($idDictionary: String!) {
  deleteDictionary(_id: $idDictionary) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDictionaryGQL extends Apollo.Mutation<DeleteDictionaryMutation, DeleteDictionaryMutationVariables> {
    document = DeleteDictionaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParseSensorFileDocument = gql`
    mutation parseSensorFile($idDevice: String!, $file: File!) {
  parseSensorFile(idDevice: $idDevice, file: $file) {
    _id
    _id_device
    _id_sensorType
    _id_mountingType
    boomToRotorDistance
    calibrationDate
    calibrationFacility
    deadbandOrientation
    description
    diameter
    serialNumber
    startDate
    sensorModel
    scale
    orientation
    offset
    name
    mastDiameterAtInstrument
    loggerScale
    loggerOffset
    length
    iecCompliant
    height
    functioning
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParseSensorFileGQL extends Apollo.Mutation<ParseSensorFileMutation, ParseSensorFileMutationVariables> {
    document = ParseSensorFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSensorTypeDocument = gql`
    query getSensorType {
  SensorType {
    items {
      _id
      category
      description
      name
      unit
      displayName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSensorTypeGQL extends Apollo.Query<GetSensorTypeQuery, GetSensorTypeQueryVariables> {
    document = GetSensorTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSensorsBatchDocument = gql`
    mutation createSensorsBatch($data: [SensorInput!]!) {
  createSensorsBatch(data: $data) {
    _id
    _id_device
    _id_sensorType
    _id_mountingType
    _id_reference
    boomToRotorDistance
    sensorTypeName
    calibrationDate
    calibrationFacility
    deadbandOrientation
    description
    diameter
    serialNumber
    startDate
    sensorModel
    scale
    orientation
    offset
    name
    mastDiameterAtInstrument
    loggerScale
    loggerOffset
    length
    iecCompliant
    height
    functioning
    Signals {
      items {
        _id
        _id_subType
        _id_sensorType
        _id_varType
        name
        description
        unit
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSensorsBatchGQL extends Apollo.Mutation<CreateSensorsBatchMutation, CreateSensorsBatchMutationVariables> {
    document = CreateSensorsBatchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMountingTypeDocument = gql`
    query getMountingType {
  MountingType {
    items {
      _id
      displayName
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMountingTypeGQL extends Apollo.Query<GetMountingTypeQuery, GetMountingTypeQueryVariables> {
    document = GetMountingTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSensorDocument = gql`
    mutation deleteSensor($_id: String!) {
  deleteSensor(_id: $_id) {
    _id
    _id_device
    _id_sensorType
    _id_mountingType
    boomToRotorDistance
    sensorTypeName
    calibrationDate
    calibrationFacility
    deadbandOrientation
    description
    diameter
    serialNumber
    startDate
    sensorModel
    scale
    orientation
    offset
    name
    mastDiameterAtInstrument
    loggerScale
    loggerOffset
    length
    iecCompliant
    height
    functioning
    Signals {
      items {
        _id
        _id_subType
        _id_sensorType
        _id_varType
        name
        description
        unit
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSensorGQL extends Apollo.Mutation<DeleteSensorMutation, DeleteSensorMutationVariables> {
    document = DeleteSensorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSensorDocument = gql`
    mutation updateSensor($_id: String!, $_id_device: String, $_id_mountingType: String, $_id_sensorType: String, $boomToRotorDistance: Float, $calibrationDate: DateTime, $calibrationFacility: String, $deadbandOrientation: Float, $description: String, $diameter: Float, $functioning: Boolean, $height: Float, $iecCompliant: String, $length: Float, $loggerOffset: Float, $loggerScale: Float, $mastDiameterAtInstrument: Float, $name: String, $offset: Float, $orientation: Float, $scale: Float, $sensorModel: String, $serialNumber: String, $startDate: DateTime) {
  updateSensor(
    _id: $_id
    _id_device: $_id_device
    _id_mountingType: $_id_mountingType
    _id_sensorType: $_id_sensorType
    boomToRotorDistance: $boomToRotorDistance
    calibrationDate: $calibrationDate
    calibrationFacility: $calibrationFacility
    deadbandOrientation: $deadbandOrientation
    description: $description
    diameter: $diameter
    functioning: $functioning
    height: $height
    iecCompliant: $iecCompliant
    length: $length
    loggerOffset: $loggerOffset
    loggerScale: $loggerScale
    mastDiameterAtInstrument: $mastDiameterAtInstrument
    name: $name
    offset: $offset
    orientation: $orientation
    scale: $scale
    sensorModel: $sensorModel
    serialNumber: $serialNumber
    startDate: $startDate
  ) {
    _id
    _id_device
    _id_sensorType
    _id_mountingType
    boomToRotorDistance
    sensorTypeName
    calibrationDate
    calibrationFacility
    deadbandOrientation
    description
    diameter
    serialNumber
    startDate
    sensorModel
    scale
    orientation
    offset
    name
    mastDiameterAtInstrument
    loggerScale
    loggerOffset
    length
    iecCompliant
    height
    functioning
    Signals {
      items {
        _id
        _id_subType
        _id_sensorType
        _id_varType
        name
        description
        unit
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSensorGQL extends Apollo.Mutation<UpdateSensorMutation, UpdateSensorMutationVariables> {
    document = UpdateSensorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNavigationDataDocument = gql`
    query getNavigationData {
  Portfolio {
    items {
      _id
      displayName
      Sites(sortField: "regionName", sortDirection: ASC) {
        items {
          Devices {
            items {
              _id
              _id_deviceType
              _id_site
              name
              displayName
              lat: latitude
              lon: longitude
              DeviceType {
                displayName
              }
              Timezone {
                timezoneOffset
              }
            }
          }
          _id
          _id_country
          _id_portfolio
          _id_region
          name
          country
          regionName
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNavigationDataGQL extends Apollo.Query<GetNavigationDataQuery, GetNavigationDataQueryVariables> {
    document = GetNavigationDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPortfolioDocument = gql`
    query getPortfolio($_id: String!) {
  Portfolio(where: {_id: $_id}) {
    items {
      _id
      displayName
      Sites {
        totalCount
        items {
          _id
          _id_country
          country
          _id_portfolio
          _id_region
          regionName
          boundary
          name
          Devices {
            items {
              _id
              _id_deviceType
              name
              displayName
              ReferenceStation {
                displayName
                name
                _id
                _id_deviceType
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPortfolioGQL extends Apollo.Query<GetPortfolioQuery, GetPortfolioQueryVariables> {
    document = GetPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCountriesDocument = gql`
    query getCountries {
  Country {
    items {
      name
      code
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCountriesGQL extends Apollo.Query<GetCountriesQuery, GetCountriesQueryVariables> {
    document = GetCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePortfolioDocument = gql`
    mutation createPortfolio($displayName: String!) {
  createPortfolio(input: {displayName: $displayName}) {
    _id
    displayName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePortfolioGQL extends Apollo.Mutation<CreatePortfolioMutation, CreatePortfolioMutationVariables> {
    document = CreatePortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePortfolioDocument = gql`
    mutation deletePortfolio($id: String!) {
  deletePortfolio(_id: $id) {
    _id
    displayName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePortfolioGQL extends Apollo.Mutation<DeletePortfolioMutation, DeletePortfolioMutationVariables> {
    document = DeletePortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSiteDocument = gql`
    mutation createSite($id_country: String!, $id_portfolio: String!, $name: String!, $boundary: String!, $_id_region: String) {
  createSite(
    _id_country: $id_country
    _id_portfolio: $id_portfolio
    name: $name
    boundary: $boundary
    _id_region: $_id_region
  ) {
    _id_country
    _id_portfolio
    _id_region
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSiteGQL extends Apollo.Mutation<CreateSiteMutation, CreateSiteMutationVariables> {
    document = CreateSiteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSiteDocument = gql`
    mutation deleteSite($id: String!) {
  deleteSite(_id: $id) {
    _id
    _id_country
    _id_portfolio
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSiteGQL extends Apollo.Mutation<DeleteSiteMutation, DeleteSiteMutationVariables> {
    document = DeleteSiteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceTypesDocument = gql`
    query getDeviceTypes {
  DeviceType {
    items {
      _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceTypesGQL extends Apollo.Query<GetDeviceTypesQuery, GetDeviceTypesQueryVariables> {
    document = GetDeviceTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSiteDocument = gql`
    mutation updateSite($id: String!, $name: String) {
  updateSite(_id: $id, name: $name) {
    _id
    _id_country
    _id_portfolio
    boundary
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSiteGQL extends Apollo.Mutation<UpdateSiteMutation, UpdateSiteMutationVariables> {
    document = UpdateSiteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMastTypeDocument = gql`
    query getMastType {
  MastType {
    items {
      _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMastTypeGQL extends Apollo.Query<GetMastTypeQuery, GetMastTypeQueryVariables> {
    document = GetMastTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceManufacturerAndModelDocument = gql`
    query GetDeviceManufacturerAndModel($id_deviceType: String) {
  DeviceManufacturer(where: {_id_deviceType: $id_deviceType}, sortField: "name") {
    items {
      _id
      name
      DeviceModels(sortField: "name") {
        items {
          _id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceManufacturerAndModelGQL extends Apollo.Query<GetDeviceManufacturerAndModelQuery, GetDeviceManufacturerAndModelQueryVariables> {
    document = GetDeviceManufacturerAndModelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDeviceDocument = gql`
    mutation createDevice($_id_deviceType: String!, $_id_site: String!, $_id_manufacturer: String!, $_id_model: String!, $_id_mastType: String, $displayName: String, $installationDate: DateTime!, $monitoringDate: DateTime, $status: DeviceStatusEnum, $serialNumber: String, $magneticDeclination: Float, $Onshore: Boolean, $Offshore: Boolean, $height: Float, $exactHeight: Float, $latitude: Float!, $longitude: Float!, $elevation: Float, $width: Float, $easting: Float, $northing: Float, $coordinationSystem: String, $timezone: String!) {
  createDevice(
    data: {_id_deviceType: $_id_deviceType, _id_site: $_id_site, _id_manufacturer: $_id_manufacturer, _id_model: $_id_model, _id_mastType: $_id_mastType, displayName: $displayName, installationDate: $installationDate, monitoringDate: $monitoringDate, status: $status, serialNumber: $serialNumber, magneticDeclination: $magneticDeclination, Onshore: $Onshore, Offshore: $Offshore, height: $height, exactHeight: $exactHeight, latitude: $latitude, longitude: $longitude, elevation: $elevation, width: $width, easting: $easting, northing: $northing, coordinationSystem: $coordinationSystem, timezone: $timezone}
  ) {
    Offshore
    Onshore
    _id
    _id_deviceType
    _id_manufacturer
    _id_mastType
    _id_model
    _id_site
    coordinationSystem
    easting
    exactHeight
    elevation
    height
    installationDate
    latitude
    longitude
    magneticDeclination
    status
    monitoringDate
    name
    displayName
    northing
    Notes {
      items {
        _id
        _id_reference
        referenceType
        text
        actionDate
      }
    }
    serialNumber
    timezone
    Timezone {
      timezoneOffset
    }
    width
    Sensors {
      items {
        _id
        _id_device
        _id_sensorType
        _id_mountingType
        _id_reference
        boomToRotorDistance
        sensorTypeName
        calibrationDate
        calibrationFacility
        deadbandOrientation
        description
        diameter
        serialNumber
        startDate
        sensorModel
        scale
        orientation
        offset
        name
        mastDiameterAtInstrument
        loggerScale
        loggerOffset
        length
        iecCompliant
        height
        functioning
        Signals {
          items {
            _id
            _id_subType
            _id_sensorType
            _id_varType
            name
            description
            unit
          }
        }
      }
    }
    Loggers {
      items {
        _id
        _id_device
        _id_manufacturer
        _id_model
        enabled
        averagingPeriod
        sampleFrequency
        matchedFilenameFormat
        installationDate
        serialNumber
        timezone
        Dictionary {
          items {
            _id
            _id_device
            _id_logger
            def {
              _id
              _id_signal
              _id_sensor
              sensorName
              signalName
              rawSignalName
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDeviceGQL extends Apollo.Mutation<CreateDeviceMutation, CreateDeviceMutationVariables> {
    document = CreateDeviceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDeviceDocument = gql`
    mutation updateDevice($_id: String!, $_id_deviceType: String, $_id_manufacturer: String, $_id_model: String, $_id_mastType: String, $displayName: String, $installationDate: DateTime, $monitoringDate: DateTime, $status: DeviceStatusEnum, $serialNumber: String, $magneticDeclination: Float, $Onshore: Boolean, $Offshore: Boolean, $height: Float, $exactHeight: Float, $latitude: Float, $longitude: Float, $elevation: Float, $width: Float, $easting: Float, $northing: Float, $coordinationSystem: String, $timezone: String) {
  updateDevice(
    _id: $_id
    data: {_id_deviceType: $_id_deviceType, _id_manufacturer: $_id_manufacturer, _id_model: $_id_model, _id_mastType: $_id_mastType, displayName: $displayName, installationDate: $installationDate, monitoringDate: $monitoringDate, status: $status, serialNumber: $serialNumber, magneticDeclination: $magneticDeclination, Onshore: $Onshore, Offshore: $Offshore, height: $height, exactHeight: $exactHeight, latitude: $latitude, longitude: $longitude, elevation: $elevation, width: $width, easting: $easting, northing: $northing, coordinationSystem: $coordinationSystem, timezone: $timezone}
  ) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDeviceGQL extends Apollo.Mutation<UpdateDeviceMutation, UpdateDeviceMutationVariables> {
    document = UpdateDeviceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDeviceDocument = gql`
    mutation deleteDevice($_id: String!) {
  deleteDevice(_id: $_id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDeviceGQL extends Apollo.Mutation<DeleteDeviceMutation, DeleteDeviceMutationVariables> {
    document = DeleteDeviceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTimezoneDocument = gql`
    query getTimezone {
  Timezone {
    items {
      timezone
      displayName
      timezoneOffset
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTimezoneGQL extends Apollo.Query<GetTimezoneQuery, GetTimezoneQueryVariables> {
    document = GetTimezoneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePortfolioDocument = gql`
    mutation updatePortfolio($id: String!, $displayName: String!) {
  updatePortfolio(_id: $id, input: {displayName: $displayName}) {
    _id
    displayName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePortfolioGQL extends Apollo.Mutation<UpdatePortfolioMutation, UpdatePortfolioMutationVariables> {
    document = UpdatePortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNotesDocument = gql`
    query getNotes($_id_reference: String, $referenceType: String) {
  Note(where: {_id_reference: $_id_reference, referenceType: $referenceType}) {
    items {
      _id
      _id_reference
      actionDate
      referenceType
      text
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotesGQL extends Apollo.Query<GetNotesQuery, GetNotesQueryVariables> {
    document = GetNotesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateNoteDocument = gql`
    mutation createNote($_id_reference: String!, $referenceType: String!, $text: String!, $actionDate: DateTime!) {
  createNote(
    _id_reference: $_id_reference
    referenceType: $referenceType
    text: $text
    actionDate: $actionDate
  ) {
    _id
    _id_reference
    actionDate
    referenceType
    text
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateNoteGQL extends Apollo.Mutation<CreateNoteMutation, CreateNoteMutationVariables> {
    document = CreateNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteNoteDocument = gql`
    mutation deleteNote($_id: String!) {
  deleteNote(_id: $_id) {
    _id
    _id_reference
    actionDate
    referenceType
    text
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteNoteGQL extends Apollo.Mutation<DeleteNoteMutation, DeleteNoteMutationVariables> {
    document = DeleteNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNoteDocument = gql`
    mutation updateNote($_id: String!, $_id_reference: String, $referenceType: String, $text: String, $actionDate: DateTime!) {
  updateNote(
    _id: $_id
    _id_reference: $_id_reference
    referenceType: $referenceType
    text: $text
    actionDate: $actionDate
  ) {
    _id
    _id_reference
    actionDate
    referenceType
    text
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNoteGQL extends Apollo.Mutation<UpdateNoteMutation, UpdateNoteMutationVariables> {
    document = UpdateNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPortfolioListDocument = gql`
    query getPortfolioList($limit: Int, $offset: Int) {
  Portfolio(limit: $limit, offset: $offset) {
    totalCount
    items {
      displayName
      _id
      Sites {
        totalCount
        items {
          name
          country
          _id_country
          _id
          Devices {
            totalCount
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPortfolioListGQL extends Apollo.Query<GetPortfolioListQuery, GetPortfolioListQueryVariables> {
    document = GetPortfolioListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceDocument = gql`
    query getDevice($_id: String!) {
  Device(where: {_id: $_id}) {
    items {
      Offshore
      Onshore
      _id
      _id_deviceType
      _id_manufacturer
      _id_mastType
      _id_model
      _id_site
      coordinationSystem
      easting
      exactHeight
      elevation
      height
      installationDate
      latitude
      longitude
      magneticDeclination
      status
      monitoringDate
      name
      displayName
      northing
      Notes {
        items {
          _id
          _id_reference
          referenceType
          text
          actionDate
        }
      }
      serialNumber
      timezone
      width
      Sensors {
        items {
          _id
          _id_device
          _id_sensorType
          _id_mountingType
          _id_reference
          boomToRotorDistance
          sensorTypeName
          calibrationDate
          calibrationFacility
          deadbandOrientation
          description
          diameter
          serialNumber
          startDate
          sensorModel
          scale
          orientation
          offset
          name
          mastDiameterAtInstrument
          loggerScale
          loggerOffset
          length
          iecCompliant
          height
          functioning
          Signals {
            items {
              _id
              _id_subType
              _id_sensorType
              _id_varType
              name
              description
              unit
            }
          }
        }
      }
      Loggers {
        items {
          _id
          _id_device
          _id_manufacturer
          _id_model
          enabled
          averagingPeriod
          sampleFrequency
          matchedFilenameFormat
          installationDate
          serialNumber
          timezone
          Dictionary {
            items {
              _id
              _id_device
              _id_logger
              def {
                _id
                _id_signal
                _id_sensor
                sensorName
                signalName
                rawSignalName
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceGQL extends Apollo.Query<GetDeviceQuery, GetDeviceQueryVariables> {
    document = GetDeviceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPortfolioByNameDocument = gql`
    query getPortfolioByName($displayName: String!, $offset: Int, $limit: Int) {
  Portfolio(where: {displayName: $displayName}, offset: $offset, limit: $limit) {
    totalCount
    items {
      _id
      displayName
      Sites {
        totalCount
        items {
          _id
          _id_country
          country
          _id_portfolio
          boundary
          name
          Devices {
            totalCount
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPortfolioByNameGQL extends Apollo.Query<GetPortfolioByNameQuery, GetPortfolioByNameQueryVariables> {
    document = GetPortfolioByNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSiteDocument = gql`
    query getSite($id: String!) {
  Site(where: {_id: $id}) {
    items {
      _id
      country
      name
      Devices {
        items {
          displayName
          ReferenceStation {
            displayName
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSiteGQL extends Apollo.Query<GetSiteQuery, GetSiteQueryVariables> {
    document = GetSiteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDeviceManufacturerDocument = gql`
    mutation createDeviceManufacturer($_id_deviceType: String!, $name: String!) {
  createDeviceManufacturer(_id_deviceType: $_id_deviceType, name: $name) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDeviceManufacturerGQL extends Apollo.Mutation<CreateDeviceManufacturerMutation, CreateDeviceManufacturerMutationVariables> {
    document = CreateDeviceManufacturerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDeviceModelDocument = gql`
    mutation createDeviceModel($_id_manufacturer: String!, $name: String!) {
  createDeviceModel(_id_manufacturer: $_id_manufacturer, name: $name) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDeviceModelGQL extends Apollo.Mutation<CreateDeviceModelMutation, CreateDeviceModelMutationVariables> {
    document = CreateDeviceModelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLoggerManufacturerDocument = gql`
    mutation createLoggerManufacturer($name: String!) {
  createLoggerManufacturer(name: $name) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLoggerManufacturerGQL extends Apollo.Mutation<CreateLoggerManufacturerMutation, CreateLoggerManufacturerMutationVariables> {
    document = CreateLoggerManufacturerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLoggerModelDocument = gql`
    mutation createLoggerModel($_id_manufacturer: String!, $name: String!) {
  createLoggerModel(_id_manufacturer: $_id_manufacturer, name: $name) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLoggerModelGQL extends Apollo.Mutation<CreateLoggerModelMutation, CreateLoggerModelMutationVariables> {
    document = CreateLoggerModelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceInfoDocument = gql`
    query getDeviceInfo($deviceIds: [String], $deviceId: [String]) {
  Reports(where: {deviceIds: $deviceIds}) {
    total
  }
  CustomAlarm(filters: {_id_device: $deviceId}) {
    totalCount
  }
  StandardAlarm(where: {deviceIds: $deviceIds}) {
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceInfoGQL extends Apollo.Query<GetDeviceInfoQuery, GetDeviceInfoQueryVariables> {
    document = GetDeviceInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCountryRegionsDocument = gql`
    query getCountryRegions($_id_country: String!) {
  Region(where: {_id_country: $_id_country}, sortDirection: ASC) {
    items {
      _id
      code
      description
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCountryRegionsGQL extends Apollo.Query<GetCountryRegionsQuery, GetCountryRegionsQueryVariables> {
    document = GetCountryRegionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateProjectAdminTabDocument = gql`
    mutation createProjectAdminTab($_id_device: String!, $_id_currency: String!, $projectNumber: String!, $invoiceFrequency: InvoiceFrequencyEnum!, $invoiceAmount: Float!, $legalEntity: String!) {
  createProjectAdminTab(
    input: {_id_device: $_id_device, _id_currency: $_id_currency, projectNumber: $projectNumber, invoiceFrequency: $invoiceFrequency, invoiceAmount: $invoiceAmount, legalEntity: $legalEntity}
  ) {
    _id
    projectNumber
    invoiceAmount
    legalEntity
    invoiceFrequency
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateProjectAdminTabGQL extends Apollo.Mutation<CreateProjectAdminTabMutation, CreateProjectAdminTabMutationVariables> {
    document = CreateProjectAdminTabDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProjectAdminTabDocument = gql`
    mutation updateProjectAdminTab($_id: String!, $_id_device: String, $_id_currency: String, $projectNumber: String, $invoiceFrequency: InvoiceFrequencyEnum, $invoiceAmount: Float, $legalEntity: String) {
  updateProjectAdminTab(
    _id: $_id
    input: {_id_device: $_id_device, _id_currency: $_id_currency, projectNumber: $projectNumber, invoiceFrequency: $invoiceFrequency, invoiceAmount: $invoiceAmount, legalEntity: $legalEntity}
  ) {
    _id
    projectNumber
    invoiceAmount
    legalEntity
    invoiceFrequency
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProjectAdminTabGQL extends Apollo.Mutation<UpdateProjectAdminTabMutation, UpdateProjectAdminTabMutationVariables> {
    document = UpdateProjectAdminTabDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProjectAdminTabDocument = gql`
    query getProjectAdminTab($_id_device: String!) {
  projectAdminTabs(where: {_id_device: $_id_device}) {
    items {
      _id
      _id_currency
      _id_device
      invoiceAmount
      invoiceFrequency
      legalEntity
      projectNumber
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProjectAdminTabGQL extends Apollo.Query<GetProjectAdminTabQuery, GetProjectAdminTabQueryVariables> {
    document = GetProjectAdminTabDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrenciesDocument = gql`
    query getCurrencies {
  Currency(
    where: {name: ["British Pound", "Euro", "United States", "Brazil", "Japan"]}
  ) {
    items {
      name
      symbol
      country
      code
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrenciesGQL extends Apollo.Query<GetCurrenciesQuery, GetCurrenciesQueryVariables> {
    document = GetCurrenciesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDeviceReferenceDocument = gql`
    mutation createDeviceReference($_id_device: String!) {
  createDeviceReference(where: {_id_device: $_id_device}) {
    _id
    _id_deviceType
    name
    displayName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDeviceReferenceGQL extends Apollo.Mutation<CreateDeviceReferenceMutation, CreateDeviceReferenceMutationVariables> {
    document = CreateDeviceReferenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceReferenceDocument = gql`
    query getDeviceReference($_id_reference: String!) {
  Device(where: {_id_reference: $_id_reference}) {
    items {
      displayName
      name
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceReferenceGQL extends Apollo.Query<GetDeviceReferenceQuery, GetDeviceReferenceQueryVariables> {
    document = GetDeviceReferenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSecurityPreferencesDocument = gql`
    query getSecurityPreferences {
  securityPreferences {
    twoFAEnabled
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSecurityPreferencesGQL extends Apollo.Query<GetSecurityPreferencesQuery, GetSecurityPreferencesQueryVariables> {
    document = GetSecurityPreferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendTwoFaSetupEmailDocument = gql`
    mutation sendTwoFASetupEmail {
  sendTwoFASetupEmail
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendTwoFaSetupEmailGQL extends Apollo.Mutation<SendTwoFaSetupEmailMutation, SendTwoFaSetupEmailMutationVariables> {
    document = SendTwoFaSetupEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveTwoFaDocument = gql`
    mutation removeTwoFA {
  removeTwoFA
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveTwoFaGQL extends Apollo.Mutation<RemoveTwoFaMutation, RemoveTwoFaMutationVariables> {
    document = RemoveTwoFaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendResetPasswordEmailDocument = gql`
    mutation sendResetPasswordEmail {
  sendResetPasswordEmail
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendResetPasswordEmailGQL extends Apollo.Mutation<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables> {
    document = SendResetPasswordEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMainSensorsDocument = gql`
    query getMainSensors($_id_device: String!) {
  CalcSetting(where: {_id_device: $_id_device}) {
    items {
      _id_mainAnemometer
      _id_mainWindVane
      _id_mainPyranometer
      _id_mainThermometer
      _id_mainRainSensor
      _id_device
      shearAnemometers
      thermometers
      ampmeters
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMainSensorsGQL extends Apollo.Query<GetMainSensorsQuery, GetMainSensorsQueryVariables> {
    document = GetMainSensorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDeviceSensorsDocument = gql`
    query getAllDeviceSensors($id: String!) {
  Sensor(where: {_id_device: $id, is_hide_sensors_references: true}) {
    items {
      _id
      name
      sensorTypeName
      Signals(where: {isMainSignal: true}) {
        items {
          name
          unit
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDeviceSensorsGQL extends Apollo.Query<GetAllDeviceSensorsQuery, GetAllDeviceSensorsQueryVariables> {
    document = GetAllDeviceSensorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserPermissionsWithFiltersDocument = gql`
    query GetUserPermissionsWithFilters($limit: Int, $offset: Int, $filters: UserFiltersInput) {
  userPermissions {
    userInfo {
      id
      username
      role
    }
    accessibleResources {
      Portfolios {
        items {
          _id
          displayName
        }
      }
    }
    managedUsers(limit: $limit, offset: $offset, filters: $filters) {
      totalCount
      items {
        id
        username
        firstName
        lastName
        email
        role
        downloadDataEnabled
        portfolioIds
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserPermissionsWithFiltersGQL extends Apollo.Query<GetUserPermissionsWithFiltersQuery, GetUserPermissionsWithFiltersQueryVariables> {
    document = GetUserPermissionsWithFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAccessibleResourcesDocument = gql`
    query GetAccessibleResources {
  userPermissions {
    accessibleResources {
      ...PortfolioTree
    }
  }
}
    ${PortfolioTreeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAccessibleResourcesGQL extends Apollo.Query<GetAccessibleResourcesQuery, GetAccessibleResourcesQueryVariables> {
    document = GetAccessibleResourcesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetManagedUserDocument = gql`
    query GetManagedUser($id: ID!) {
  userPermissions {
    accessibleResources {
      ...PortfolioTree
    }
  }
  managedUser(id: $id) {
    id
    username
    firstName
    lastName
    email
    role
    downloadDataEnabled
    accessiblePortfolios {
      ...PortfolioTree
    }
  }
}
    ${PortfolioTreeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetManagedUserGQL extends Apollo.Query<GetManagedUserQuery, GetManagedUserQueryVariables> {
    document = GetManagedUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation createUser($username: String!, $email: String!, $firstName: String, $lastName: String, $role: UserRole, $enabled: Boolean, $downloadDataEnabled: Boolean, $availableDeviceIds: [String]) {
  createUser(
    data: {username: $username, email: $email, firstName: $firstName, lastName: $lastName, role: $role, downloadDataEnabled: $downloadDataEnabled, enabled: $enabled, availableDeviceIds: $availableDeviceIds}
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation updateUser($id: String!, $firstName: String, $lastName: String, $role: UserRole, $downloadDataEnabled: Boolean, $availableDeviceIds: [String]) {
  updateUser(
    data: {id: $id, availableDeviceIds: $availableDeviceIds, downloadDataEnabled: $downloadDataEnabled, firstName: $firstName, lastName: $lastName, role: $role}
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUsersDocument = gql`
    mutation deleteUsers($ids: [String!]!) {
  deleteUsers(data: {ids: $ids})
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUsersGQL extends Apollo.Mutation<DeleteUsersMutation, DeleteUsersMutationVariables> {
    document = DeleteUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }